/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AcceptInviteDetails = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateUserWithPasswordInput = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ActivateUserWithSso = {
  provider: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ActiveUserStatusInput = {
  assignSeat: Scalars['Boolean']['input'];
  districtId: Scalars['String']['input'];
  removeFromWorkspace: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type AiAssistantInput = {
  commandType: Scalars['String']['input'];
  commandValue?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['String']['input'];
  selection: Scalars['String']['input'];
};

export type AiAutofillInput = {
  aiStepId: Scalars['String']['input'];
  aiToolId: Scalars['String']['input'];
  fieldId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type AiChatInterfaceInput = {
  aiStepId: Scalars['String']['input'];
  aiToolId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  query: Scalars['String']['input'];
};

export type AiChatInterfaceSuggestionResponseInput = {
  accept: Scalars['Boolean']['input'];
  aiStepId: Scalars['String']['input'];
  aiToolId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type AiFavorite = {
  __typename?: 'AiFavorite';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['String']['output'];
  entityType?: Maybe<EnumAiFavoriteEntityType>;
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type AiFavoriteCreateInput = {
  entityId: Scalars['String']['input'];
  entityType: EnumAiFavoriteEntityType;
  user: UserWhereUniqueInput;
};

export type AiFavoriteCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AiFavoriteWhereUniqueInput>>;
};

export type AiFavoriteListRelationFilter = {
  every?: InputMaybe<AiFavoriteWhereInput>;
  none?: InputMaybe<AiFavoriteWhereInput>;
  some?: InputMaybe<AiFavoriteWhereInput>;
};

export type AiFavoriteOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AiFavoriteUpdateInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumAiFavoriteEntityType>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type AiFavoriteUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AiFavoriteWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AiFavoriteWhereUniqueInput>>;
  set?: InputMaybe<Array<AiFavoriteWhereUniqueInput>>;
};

export type AiFavoriteWhereInput = {
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumAiFavoriteEntityType>;
  id?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type AiFavoriteWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type AiFeedback = {
  __typename?: 'AiFeedback';
  aiContext?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entity?: Maybe<EnumAiFeedbackEntity>;
  entityId?: Maybe<Scalars['String']['output']>;
  feedback: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  parentEntityId?: Maybe<Scalars['String']['output']>;
  runId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type AiFeedbackCreateInput = {
  aiContext?: InputMaybe<Scalars['JSON']['input']>;
  entity: EnumAiFeedbackEntity;
  entityId?: InputMaybe<Scalars['String']['input']>;
  feedback: Scalars['JSON']['input'];
  parentEntityId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['String']['input'];
  user: UserWhereUniqueInput;
};

export type AiFeedbackCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AiFeedbackWhereUniqueInput>>;
};

export type AiFeedbackListRelationFilter = {
  every?: InputMaybe<AiFeedbackWhereInput>;
  none?: InputMaybe<AiFeedbackWhereInput>;
  some?: InputMaybe<AiFeedbackWhereInput>;
};

export type AiFeedbackOrderByInput = {
  aiContext?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  entity?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  feedback?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parentEntityId?: InputMaybe<SortOrder>;
  runId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AiFeedbackUpdateInput = {
  aiContext?: InputMaybe<Scalars['JSON']['input']>;
  entity?: InputMaybe<EnumAiFeedbackEntity>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['JSON']['input']>;
  parentEntityId?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type AiFeedbackUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AiFeedbackWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AiFeedbackWhereUniqueInput>>;
  set?: InputMaybe<Array<AiFeedbackWhereUniqueInput>>;
};

export type AiFeedbackWhereInput = {
  aiContext?: InputMaybe<JsonFilter>;
  entity?: InputMaybe<EnumAiFeedbackEntity>;
  entityId?: InputMaybe<StringNullableFilter>;
  feedback?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  parentEntityId?: InputMaybe<StringNullableFilter>;
  runId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type AiFeedbackWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type AiResourceGeneratorEditInput = {
  data: Scalars['JSON']['input'];
  fieldId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type AiTool = {
  __typename?: 'AiTool';
  aiToolParticipants: Array<AiToolParticipant>;
  aiToolSteps: Array<AiToolStep>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  initData: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  toolId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  version?: Maybe<Scalars['Float']['output']>;
};


export type AiToolAiToolParticipantsArgs = {
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type AiToolAiToolStepsArgs = {
  orderBy?: InputMaybe<Array<AiToolStepOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolStepWhereInput>;
};

export type AiToolCreateInput = {
  aiToolParticipants?: InputMaybe<AiToolParticipantCreateNestedManyWithoutAiToolsInput>;
  aiToolSteps?: InputMaybe<AiToolStepCreateNestedManyWithoutAiToolsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  initData: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
  toolId: Scalars['String']['input'];
  urlId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type AiToolOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  initData?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  toolId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export type AiToolParticipant = {
  __typename?: 'AiToolParticipant';
  additionalFeedback?: Maybe<Scalars['String']['output']>;
  aiTool?: Maybe<AiTool>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  feedbackType?: Maybe<EnumAiToolParticipantFeedbackType>;
  id: Scalars['String']['output'];
  owner?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<EnumAiToolParticipantPermissions>>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type AiToolParticipantCreateInput = {
  additionalFeedback?: InputMaybe<Scalars['String']['input']>;
  aiTool: AiToolWhereUniqueInput;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  feedbackType?: InputMaybe<EnumAiToolParticipantFeedbackType>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<EnumAiToolParticipantPermissions>>;
  user: UserWhereUniqueInput;
};

export type AiToolParticipantCreateNestedManyWithoutAiToolsInput = {
  connect?: InputMaybe<Array<AiToolParticipantWhereUniqueInput>>;
};

export type AiToolParticipantCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AiToolParticipantWhereUniqueInput>>;
};

export type AiToolParticipantListRelationFilter = {
  every?: InputMaybe<AiToolParticipantWhereInput>;
  none?: InputMaybe<AiToolParticipantWhereInput>;
  some?: InputMaybe<AiToolParticipantWhereInput>;
};

export type AiToolParticipantOrderByInput = {
  additionalFeedback?: InputMaybe<SortOrder>;
  aiToolId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  feedbackType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AiToolParticipantUpdateInput = {
  additionalFeedback?: InputMaybe<Scalars['String']['input']>;
  aiTool?: InputMaybe<AiToolWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  feedbackType?: InputMaybe<EnumAiToolParticipantFeedbackType>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<EnumAiToolParticipantPermissions>>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type AiToolParticipantUpdateManyWithoutAiToolsInput = {
  connect?: InputMaybe<Array<AiToolParticipantWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AiToolParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<AiToolParticipantWhereUniqueInput>>;
};

export type AiToolParticipantUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AiToolParticipantWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AiToolParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<AiToolParticipantWhereUniqueInput>>;
};

export type AiToolParticipantWhereInput = {
  additionalFeedback?: InputMaybe<StringNullableFilter>;
  aiTool?: InputMaybe<AiToolWhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  feedbackType?: InputMaybe<EnumAiToolParticipantFeedbackType>;
  id?: InputMaybe<StringFilter>;
  owner?: InputMaybe<BooleanNullableFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type AiToolParticipantWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type AiToolStep = {
  __typename?: 'AiToolStep';
  aiTool?: Maybe<AiTool>;
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  discardedEntries?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  stepId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AiToolStepCreateInput = {
  aiTool: AiToolWhereUniqueInput;
  data: Scalars['JSON']['input'];
  discardedEntries?: InputMaybe<Scalars['JSON']['input']>;
  stepId: Scalars['String']['input'];
};

export type AiToolStepCreateNestedManyWithoutAiToolsInput = {
  connect?: InputMaybe<Array<AiToolStepWhereUniqueInput>>;
};

export type AiToolStepListRelationFilter = {
  every?: InputMaybe<AiToolStepWhereInput>;
  none?: InputMaybe<AiToolStepWhereInput>;
  some?: InputMaybe<AiToolStepWhereInput>;
};

export type AiToolStepOrderByInput = {
  aiToolId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  discardedEntries?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  stepId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AiToolStepUpdateInput = {
  aiTool?: InputMaybe<AiToolWhereUniqueInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  discardedEntries?: InputMaybe<Scalars['JSON']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
};

export type AiToolStepUpdateManyWithoutAiToolsInput = {
  connect?: InputMaybe<Array<AiToolStepWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AiToolStepWhereUniqueInput>>;
  set?: InputMaybe<Array<AiToolStepWhereUniqueInput>>;
};

export type AiToolStepWhereInput = {
  aiTool?: InputMaybe<AiToolWhereUniqueInput>;
  data?: InputMaybe<JsonFilter>;
  discardedEntries?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  stepId?: InputMaybe<StringFilter>;
};

export type AiToolStepWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type AiToolUpdateInput = {
  aiToolParticipants?: InputMaybe<AiToolParticipantUpdateManyWithoutAiToolsInput>;
  aiToolSteps?: InputMaybe<AiToolStepUpdateManyWithoutAiToolsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  initData?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolId?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type AiToolUrlIdInput = {
  urlId: Scalars['String']['input'];
};

export type AiToolWhereInput = {
  aiToolParticipants?: InputMaybe<AiToolParticipantListRelationFilter>;
  aiToolSteps?: InputMaybe<AiToolStepListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  initData?: InputMaybe<JsonFilter>;
  title?: InputMaybe<StringFilter>;
  toolId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  urlId?: InputMaybe<StringFilter>;
  version?: InputMaybe<FloatNullableFilter>;
};

export type AiToolWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type AlternateSchedule = {
  __typename?: 'AlternateSchedule';
  blockSchedules: Array<BlockSchedule>;
  calendarDays: Array<CalendarDay>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rotationSchedule?: Maybe<RotationSchedule>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AlternateScheduleBlockSchedulesArgs = {
  orderBy?: InputMaybe<Array<BlockScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BlockScheduleWhereInput>;
};


export type AlternateScheduleCalendarDaysArgs = {
  orderBy?: InputMaybe<Array<CalendarDayOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarDayWhereInput>;
};

export type AlternateScheduleCreateInput = {
  blockSchedules?: InputMaybe<BlockScheduleCreateNestedManyWithoutAlternateSchedulesInput>;
  calendarDays?: InputMaybe<CalendarDayCreateNestedManyWithoutAlternateSchedulesInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type AlternateScheduleCreateNestedManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<AlternateScheduleWhereUniqueInput>>;
};

export type AlternateScheduleListRelationFilter = {
  every?: InputMaybe<AlternateScheduleWhereInput>;
  none?: InputMaybe<AlternateScheduleWhereInput>;
  some?: InputMaybe<AlternateScheduleWhereInput>;
};

export type AlternateScheduleOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  rotationScheduleId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AlternateScheduleUpdateInput = {
  blockSchedules?: InputMaybe<BlockScheduleUpdateManyWithoutAlternateSchedulesInput>;
  calendarDays?: InputMaybe<CalendarDayUpdateManyWithoutAlternateSchedulesInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type AlternateScheduleUpdateManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<AlternateScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AlternateScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<AlternateScheduleWhereUniqueInput>>;
};

export type AlternateScheduleWhereInput = {
  blockSchedules?: InputMaybe<BlockScheduleListRelationFilter>;
  calendarDays?: InputMaybe<CalendarDayListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type AlternateScheduleWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Asset = {
  __typename?: 'Asset';
  acl?: Maybe<EnumAssetAcl>;
  advancedDocLoader?: Maybe<Scalars['String']['output']>;
  advancedProcessing?: Maybe<EnumAssetAdvancedProcessing>;
  advancedProcessingProgress?: Maybe<Scalars['Float']['output']>;
  assetType?: Maybe<EnumAssetAssetType>;
  basicDocLoader?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  course?: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  hypoQuestions?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  imageSummaries?: Maybe<Scalars['JSON']['output']>;
  images?: Maybe<Scalars['JSON']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  processingOptions?: Maybe<Scalars['JSON']['output']>;
  resource?: Maybe<Resource>;
  shortSummaries?: Maybe<Scalars['JSON']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  summaries?: Maybe<Scalars['JSON']['output']>;
  tableSummaries?: Maybe<Scalars['JSON']['output']>;
  tables?: Maybe<Scalars['JSON']['output']>;
  textElements?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  user?: Maybe<User>;
  vectorEmbeddings?: Maybe<EnumAssetVectorEmbeddings>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type AssetCreateInput = {
  acl?: InputMaybe<EnumAssetAcl>;
  advancedDocLoader?: InputMaybe<Scalars['String']['input']>;
  advancedProcessing?: InputMaybe<EnumAssetAdvancedProcessing>;
  advancedProcessingProgress?: InputMaybe<Scalars['Float']['input']>;
  assetType: EnumAssetAssetType;
  basicDocLoader?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  hypoQuestions?: InputMaybe<Scalars['JSON']['input']>;
  imageSummaries?: InputMaybe<Scalars['JSON']['input']>;
  images?: InputMaybe<Scalars['JSON']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  processingOptions?: InputMaybe<Scalars['JSON']['input']>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
  shortSummaries?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  summaries?: InputMaybe<Scalars['JSON']['input']>;
  tableSummaries?: InputMaybe<Scalars['JSON']['input']>;
  tables?: InputMaybe<Scalars['JSON']['input']>;
  textElements?: InputMaybe<Scalars['JSON']['input']>;
  user: UserWhereUniqueInput;
  vectorEmbeddings?: InputMaybe<EnumAssetVectorEmbeddings>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type AssetCreateNestedManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
};

export type AssetCreateNestedManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
};

export type AssetCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
};

export type AssetListRelationFilter = {
  every?: InputMaybe<AssetWhereInput>;
  none?: InputMaybe<AssetWhereInput>;
  some?: InputMaybe<AssetWhereInput>;
};

export type AssetOrderByInput = {
  acl?: InputMaybe<SortOrder>;
  advancedDocLoader?: InputMaybe<SortOrder>;
  advancedProcessing?: InputMaybe<SortOrder>;
  advancedProcessingProgress?: InputMaybe<SortOrder>;
  assetType?: InputMaybe<SortOrder>;
  basicDocLoader?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  hypoQuestions?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageSummaries?: InputMaybe<SortOrder>;
  images?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  processingOptions?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  shortSummaries?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  summaries?: InputMaybe<SortOrder>;
  tableSummaries?: InputMaybe<SortOrder>;
  tables?: InputMaybe<SortOrder>;
  textElements?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  vectorEmbeddings?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export type AssetUpdateInput = {
  acl?: InputMaybe<EnumAssetAcl>;
  advancedDocLoader?: InputMaybe<Scalars['String']['input']>;
  advancedProcessing?: InputMaybe<EnumAssetAdvancedProcessing>;
  advancedProcessingProgress?: InputMaybe<Scalars['Float']['input']>;
  assetType?: InputMaybe<EnumAssetAssetType>;
  basicDocLoader?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  hypoQuestions?: InputMaybe<Scalars['JSON']['input']>;
  imageSummaries?: InputMaybe<Scalars['JSON']['input']>;
  images?: InputMaybe<Scalars['JSON']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  processingOptions?: InputMaybe<Scalars['JSON']['input']>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
  shortSummaries?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  summaries?: InputMaybe<Scalars['JSON']['input']>;
  tableSummaries?: InputMaybe<Scalars['JSON']['input']>;
  tables?: InputMaybe<Scalars['JSON']['input']>;
  textElements?: InputMaybe<Scalars['JSON']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
  vectorEmbeddings?: InputMaybe<EnumAssetVectorEmbeddings>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type AssetUpdateManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
};

export type AssetUpdateManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
};

export type AssetUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
};

export type AssetWhereInput = {
  acl?: InputMaybe<EnumAssetAcl>;
  advancedDocLoader?: InputMaybe<StringNullableFilter>;
  advancedProcessing?: InputMaybe<EnumAssetAdvancedProcessing>;
  advancedProcessingProgress?: InputMaybe<IntNullableFilter>;
  assetType?: InputMaybe<EnumAssetAssetType>;
  basicDocLoader?: InputMaybe<StringNullableFilter>;
  content?: InputMaybe<JsonFilter>;
  contentType?: InputMaybe<StringNullableFilter>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  deletedAt?: InputMaybe<StringNullableFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  hypoQuestions?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  imageSummaries?: InputMaybe<JsonFilter>;
  images?: InputMaybe<JsonFilter>;
  key?: InputMaybe<StringNullableFilter>;
  processingOptions?: InputMaybe<JsonFilter>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
  shortSummaries?: InputMaybe<JsonFilter>;
  size?: InputMaybe<FloatNullableFilter>;
  summaries?: InputMaybe<JsonFilter>;
  tableSummaries?: InputMaybe<JsonFilter>;
  tables?: InputMaybe<JsonFilter>;
  textElements?: InputMaybe<JsonFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
  vectorEmbeddings?: InputMaybe<EnumAssetVectorEmbeddings>;
  version?: InputMaybe<DecimalNullableFilter>;
};

export type AssetWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  actionId: Scalars['String']['output'];
  actionType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  details: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type AuditLogCreateInput = {
  actionId: Scalars['String']['input'];
  actionType: Scalars['String']['input'];
  details: Scalars['JSON']['input'];
  user: UserWhereUniqueInput;
};

export type AuditLogCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
};

export type AuditLogListRelationFilter = {
  every?: InputMaybe<AuditLogWhereInput>;
  none?: InputMaybe<AuditLogWhereInput>;
  some?: InputMaybe<AuditLogWhereInput>;
};

export type AuditLogOrderByInput = {
  actionId?: InputMaybe<SortOrder>;
  actionType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  details?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AuditLogUpdateInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  actionType?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type AuditLogUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
  set?: InputMaybe<Array<AuditLogWhereUniqueInput>>;
};

export type AuditLogWhereInput = {
  actionId?: InputMaybe<StringFilter>;
  actionType?: InputMaybe<StringFilter>;
  details?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type AuditLogWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Block = {
  __typename?: 'Block';
  abbreviation: Scalars['String']['output'];
  blockSchedules: Array<BlockSchedule>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rotationSchedule?: Maybe<RotationSchedule>;
  updatedAt: Scalars['DateTime']['output'];
};


export type BlockBlockSchedulesArgs = {
  orderBy?: InputMaybe<Array<BlockScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BlockScheduleWhereInput>;
};

export type BlockCreateInput = {
  abbreviation: Scalars['String']['input'];
  blockSchedules?: InputMaybe<BlockScheduleCreateNestedManyWithoutBlocksInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type BlockCreateNestedManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<BlockWhereUniqueInput>>;
};

export type BlockListRelationFilter = {
  every?: InputMaybe<BlockWhereInput>;
  none?: InputMaybe<BlockWhereInput>;
  some?: InputMaybe<BlockWhereInput>;
};

export type BlockOrderByInput = {
  abbreviation?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rotationScheduleId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BlockSchedule = {
  __typename?: 'BlockSchedule';
  alternateSchedule?: Maybe<AlternateSchedule>;
  block?: Maybe<Block>;
  calendarSchedules: Array<CalendarSchedule>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  rotationDay?: Maybe<RotationDay>;
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type BlockScheduleCalendarSchedulesArgs = {
  orderBy?: InputMaybe<Array<CalendarScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarScheduleWhereInput>;
};

export type BlockScheduleCreateInput = {
  alternateSchedule?: InputMaybe<AlternateScheduleWhereUniqueInput>;
  block: BlockWhereUniqueInput;
  calendarSchedules?: InputMaybe<CalendarScheduleCreateNestedManyWithoutBlockSchedulesInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endTime: Scalars['String']['input'];
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  startTime: Scalars['String']['input'];
};

export type BlockScheduleCreateNestedManyWithoutAlternateSchedulesInput = {
  connect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
};

export type BlockScheduleCreateNestedManyWithoutBlocksInput = {
  connect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
};

export type BlockScheduleCreateNestedManyWithoutRotationDaysInput = {
  connect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
};

export type BlockScheduleListRelationFilter = {
  every?: InputMaybe<BlockScheduleWhereInput>;
  none?: InputMaybe<BlockScheduleWhereInput>;
  some?: InputMaybe<BlockScheduleWhereInput>;
};

export type BlockScheduleOrderByInput = {
  alternateScheduleId?: InputMaybe<SortOrder>;
  blockId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rotationDayId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BlockScheduleUpdateInput = {
  alternateSchedule?: InputMaybe<AlternateScheduleWhereUniqueInput>;
  block?: InputMaybe<BlockWhereUniqueInput>;
  calendarSchedules?: InputMaybe<CalendarScheduleUpdateManyWithoutBlockSchedulesInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type BlockScheduleUpdateManyWithoutAlternateSchedulesInput = {
  connect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
};

export type BlockScheduleUpdateManyWithoutBlocksInput = {
  connect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
};

export type BlockScheduleUpdateManyWithoutRotationDaysInput = {
  connect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<BlockScheduleWhereUniqueInput>>;
};

export type BlockScheduleWhereInput = {
  alternateSchedule?: InputMaybe<AlternateScheduleWhereUniqueInput>;
  block?: InputMaybe<BlockWhereUniqueInput>;
  calendarSchedules?: InputMaybe<CalendarScheduleListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  startTime?: InputMaybe<StringFilter>;
};

export type BlockScheduleWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BlockUpdateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  blockSchedules?: InputMaybe<BlockScheduleUpdateManyWithoutBlocksInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type BlockUpdateManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<BlockWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BlockWhereUniqueInput>>;
  set?: InputMaybe<Array<BlockWhereUniqueInput>>;
};

export type BlockWhereInput = {
  abbreviation?: InputMaybe<StringFilter>;
  blockSchedules?: InputMaybe<BlockScheduleListRelationFilter>;
  color?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type BlockWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BooleanNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BotConversation = {
  __typename?: 'BotConversation';
  botConversationParticipants: Array<BotConversationParticipant>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  conversationEntries: Array<BotConversationEntry>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
};


export type BotConversationBotConversationParticipantsArgs = {
  orderBy?: InputMaybe<Array<BotConversationParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BotConversationParticipantWhereInput>;
};


export type BotConversationConversationEntriesArgs = {
  orderBy?: InputMaybe<Array<BotConversationEntryOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BotConversationEntryWhereInput>;
};

export type BotConversationCreateInput = {
  botConversationParticipants?: InputMaybe<BotConversationParticipantCreateNestedManyWithoutBotConversationsInput>;
  conversationEntries?: InputMaybe<BotConversationEntryCreateNestedManyWithoutBotConversationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  urlId: Scalars['String']['input'];
};

export type BotConversationEntry = {
  __typename?: 'BotConversationEntry';
  conversation?: Maybe<BotConversation>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discardedEntries?: Maybe<Scalars['JSON']['output']>;
  entry: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  speaker?: Maybe<EnumBotConversationEntrySpeaker>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type BotConversationEntryCreateInput = {
  conversation: BotConversationWhereUniqueInput;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  discardedEntries?: InputMaybe<Scalars['JSON']['input']>;
  entry: Scalars['JSON']['input'];
  speaker: EnumBotConversationEntrySpeaker;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type BotConversationEntryCreateNestedManyWithoutBotConversationsInput = {
  connect?: InputMaybe<Array<BotConversationEntryWhereUniqueInput>>;
};

export type BotConversationEntryCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<BotConversationEntryWhereUniqueInput>>;
};

export type BotConversationEntryListRelationFilter = {
  every?: InputMaybe<BotConversationEntryWhereInput>;
  none?: InputMaybe<BotConversationEntryWhereInput>;
  some?: InputMaybe<BotConversationEntryWhereInput>;
};

export type BotConversationEntryOrderByInput = {
  conversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  discardedEntries?: InputMaybe<SortOrder>;
  entry?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  speaker?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BotConversationEntryUpdateInput = {
  conversation?: InputMaybe<BotConversationWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  discardedEntries?: InputMaybe<Scalars['JSON']['input']>;
  entry?: InputMaybe<Scalars['JSON']['input']>;
  speaker?: InputMaybe<EnumBotConversationEntrySpeaker>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type BotConversationEntryUpdateManyWithoutBotConversationsInput = {
  connect?: InputMaybe<Array<BotConversationEntryWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BotConversationEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<BotConversationEntryWhereUniqueInput>>;
};

export type BotConversationEntryUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<BotConversationEntryWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BotConversationEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<BotConversationEntryWhereUniqueInput>>;
};

export type BotConversationEntryWhereInput = {
  conversation?: InputMaybe<BotConversationWhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discardedEntries?: InputMaybe<JsonFilter>;
  entry?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  speaker?: InputMaybe<EnumBotConversationEntrySpeaker>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type BotConversationEntryWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BotConversationOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
};

export type BotConversationParticipant = {
  __typename?: 'BotConversationParticipant';
  botConversation?: Maybe<BotConversation>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  owner?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<EnumBotConversationParticipantPermissions>>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type BotConversationParticipantCreateInput = {
  botConversation: BotConversationWhereUniqueInput;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<EnumBotConversationParticipantPermissions>>;
  user: UserWhereUniqueInput;
};

export type BotConversationParticipantCreateNestedManyWithoutBotConversationsInput = {
  connect?: InputMaybe<Array<BotConversationParticipantWhereUniqueInput>>;
};

export type BotConversationParticipantCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<BotConversationParticipantWhereUniqueInput>>;
};

export type BotConversationParticipantListRelationFilter = {
  every?: InputMaybe<BotConversationParticipantWhereInput>;
  none?: InputMaybe<BotConversationParticipantWhereInput>;
  some?: InputMaybe<BotConversationParticipantWhereInput>;
};

export type BotConversationParticipantOrderByInput = {
  botConversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  owner?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BotConversationParticipantUpdateInput = {
  botConversation?: InputMaybe<BotConversationWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<EnumBotConversationParticipantPermissions>>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type BotConversationParticipantUpdateManyWithoutBotConversationsInput = {
  connect?: InputMaybe<Array<BotConversationParticipantWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BotConversationParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<BotConversationParticipantWhereUniqueInput>>;
};

export type BotConversationParticipantUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<BotConversationParticipantWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BotConversationParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<BotConversationParticipantWhereUniqueInput>>;
};

export type BotConversationParticipantWhereInput = {
  botConversation?: InputMaybe<BotConversationWhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  owner?: InputMaybe<BooleanNullableFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type BotConversationParticipantWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BotConversationUpdateInput = {
  botConversationParticipants?: InputMaybe<BotConversationParticipantUpdateManyWithoutBotConversationsInput>;
  conversationEntries?: InputMaybe<BotConversationEntryUpdateManyWithoutBotConversationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
};

export type BotConversationUrlIdInput = {
  urlId: Scalars['String']['input'];
};

export type BotConversationWhereInput = {
  botConversationParticipants?: InputMaybe<BotConversationParticipantListRelationFilter>;
  conversationEntries?: InputMaybe<BotConversationEntryListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  urlId?: InputMaybe<StringFilter>;
};

export type BotConversationWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type BulkLicenseActiveInput = {
  assignSeat: Scalars['Boolean']['input'];
  districtId: Scalars['String']['input'];
  users: Array<Scalars['String']['input']>;
};

export type BulkUserActiveInput = {
  assignSeat: Scalars['Boolean']['input'];
  districtId: Scalars['String']['input'];
  users: Array<Scalars['String']['input']>;
};

export type Calendar = {
  __typename?: 'Calendar';
  calendarDays: Array<CalendarDay>;
  calendarEntries: Array<CalendarEntry>;
  calendarSchedules: Array<CalendarSchedule>;
  calendarType?: Maybe<EnumCalendarCalendarType>;
  classV2?: Maybe<ClassV2>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<District>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['String']['output'];
  planner?: Maybe<PlannerRevision>;
  plannerCourse?: Maybe<Course>;
  plannerSection?: Maybe<Section>;
  rotationSchedule?: Maybe<RotationSchedule>;
  schools: Array<School>;
  section?: Maybe<SectionV2>;
  session?: Maybe<Session>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  user?: Maybe<User>;
};


export type CalendarCalendarDaysArgs = {
  orderBy?: InputMaybe<Array<CalendarDayOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarDayWhereInput>;
};


export type CalendarCalendarEntriesArgs = {
  orderBy?: InputMaybe<Array<CalendarEntryOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarEntryWhereInput>;
};


export type CalendarCalendarSchedulesArgs = {
  orderBy?: InputMaybe<Array<CalendarScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarScheduleWhereInput>;
};


export type CalendarEventsArgs = {
  orderBy?: InputMaybe<Array<EventOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EventWhereInput>;
};


export type CalendarSchoolsArgs = {
  orderBy?: InputMaybe<Array<SchoolOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SchoolWhereInput>;
};

export type CalendarCreateInput = {
  calendarDays?: InputMaybe<CalendarDayCreateNestedManyWithoutCalendarsInput>;
  calendarEntries?: InputMaybe<CalendarEntryCreateNestedManyWithoutCalendarsInput>;
  calendarSchedules?: InputMaybe<CalendarScheduleCreateNestedManyWithoutCalendarsInput>;
  calendarType: EnumCalendarCalendarType;
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCalendarsInput>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
  plannerCourse?: InputMaybe<CourseWhereUniqueInput>;
  plannerSection?: InputMaybe<SectionWhereUniqueInput>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
  schools?: InputMaybe<SchoolCreateNestedManyWithoutCalendarsInput>;
  section?: InputMaybe<SectionV2WhereUniqueInput>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId: Scalars['String']['input'];
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type CalendarCreateNestedManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutPlannerRevisionsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutSectionV2sInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutSectionsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutSessionsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarDay = {
  __typename?: 'CalendarDay';
  alternateSchedule?: Maybe<AlternateSchedule>;
  calendar?: Maybe<Calendar>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['String']['output'];
  rotationDay?: Maybe<RotationDay>;
  rotationSchedule?: Maybe<RotationSchedule>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CalendarDayEventsArgs = {
  orderBy?: InputMaybe<Array<EventOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EventWhereInput>;
};

export type CalendarDayCreateInput = {
  alternateSchedule?: InputMaybe<AlternateScheduleWhereUniqueInput>;
  calendar: CalendarWhereUniqueInput;
  date: Scalars['DateTime']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCalendarDaysInput>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  rotationSchedule: RotationScheduleWhereUniqueInput;
};

export type CalendarDayCreateNestedManyWithoutAlternateSchedulesInput = {
  connect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
};

export type CalendarDayCreateNestedManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
};

export type CalendarDayCreateNestedManyWithoutRotationDaysInput = {
  connect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
};

export type CalendarDayCreateNestedManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
};

export type CalendarDayListRelationFilter = {
  every?: InputMaybe<CalendarDayWhereInput>;
  none?: InputMaybe<CalendarDayWhereInput>;
  some?: InputMaybe<CalendarDayWhereInput>;
};

export type CalendarDayOrderByInput = {
  alternateScheduleId?: InputMaybe<SortOrder>;
  calendarId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rotationDayId?: InputMaybe<SortOrder>;
  rotationScheduleId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CalendarDayUpdateInput = {
  alternateSchedule?: InputMaybe<AlternateScheduleWhereUniqueInput>;
  calendar?: InputMaybe<CalendarWhereUniqueInput>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventUpdateManyWithoutCalendarDaysInput>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type CalendarDayUpdateManyWithoutAlternateSchedulesInput = {
  connect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
};

export type CalendarDayUpdateManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
};

export type CalendarDayUpdateManyWithoutRotationDaysInput = {
  connect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
};

export type CalendarDayUpdateManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarDayWhereUniqueInput>>;
};

export type CalendarDayWhereInput = {
  alternateSchedule?: InputMaybe<AlternateScheduleWhereUniqueInput>;
  calendar?: InputMaybe<CalendarWhereUniqueInput>;
  date?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type CalendarDayWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CalendarEntry = {
  __typename?: 'CalendarEntry';
  calendar?: Maybe<Calendar>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type CalendarEntryCreateInput = {
  calendar: CalendarWhereUniqueInput;
  color?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserWhereUniqueInput;
};

export type CalendarEntryCreateNestedManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<CalendarEntryWhereUniqueInput>>;
};

export type CalendarEntryCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<CalendarEntryWhereUniqueInput>>;
};

export type CalendarEntryListRelationFilter = {
  every?: InputMaybe<CalendarEntryWhereInput>;
  none?: InputMaybe<CalendarEntryWhereInput>;
  some?: InputMaybe<CalendarEntryWhereInput>;
};

export type CalendarEntryOrderByInput = {
  calendarId?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CalendarEntryUpdateInput = {
  calendar?: InputMaybe<CalendarWhereUniqueInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type CalendarEntryUpdateManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<CalendarEntryWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarEntryWhereUniqueInput>>;
};

export type CalendarEntryUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<CalendarEntryWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarEntryWhereUniqueInput>>;
};

export type CalendarEntryWhereInput = {
  calendar?: InputMaybe<CalendarWhereUniqueInput>;
  color?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type CalendarEntryWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CalendarListRelationFilter = {
  every?: InputMaybe<CalendarWhereInput>;
  none?: InputMaybe<CalendarWhereInput>;
  some?: InputMaybe<CalendarWhereInput>;
};

export type CalendarOrderByInput = {
  calendarType?: InputMaybe<SortOrder>;
  classV2Id?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  plannerCourseId?: InputMaybe<SortOrder>;
  plannerId?: InputMaybe<SortOrder>;
  plannerSectionId?: InputMaybe<SortOrder>;
  rotationScheduleId?: InputMaybe<SortOrder>;
  sectionId?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CalendarSchedule = {
  __typename?: 'CalendarSchedule';
  blockSchedule?: Maybe<BlockSchedule>;
  calendar?: Maybe<Calendar>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['String']['output'];
  rotationDay?: Maybe<RotationDay>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CalendarScheduleEventsArgs = {
  orderBy?: InputMaybe<Array<EventOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EventWhereInput>;
};

export type CalendarScheduleCreateInput = {
  blockSchedule?: InputMaybe<BlockScheduleWhereUniqueInput>;
  calendar: CalendarWhereUniqueInput;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventCreateNestedManyWithoutCalendarSchedulesInput>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarScheduleCreateNestedManyWithoutBlockSchedulesInput = {
  connect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
};

export type CalendarScheduleCreateNestedManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
};

export type CalendarScheduleCreateNestedManyWithoutRotationDaysInput = {
  connect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
};

export type CalendarScheduleListRelationFilter = {
  every?: InputMaybe<CalendarScheduleWhereInput>;
  none?: InputMaybe<CalendarScheduleWhereInput>;
  some?: InputMaybe<CalendarScheduleWhereInput>;
};

export type CalendarScheduleOrderByInput = {
  blockScheduleId?: InputMaybe<SortOrder>;
  calendarId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rotationDayId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CalendarScheduleUpdateInput = {
  blockSchedule?: InputMaybe<BlockScheduleWhereUniqueInput>;
  calendar?: InputMaybe<CalendarWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventUpdateManyWithoutCalendarSchedulesInput>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarScheduleUpdateManyWithoutBlockSchedulesInput = {
  connect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
};

export type CalendarScheduleUpdateManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
};

export type CalendarScheduleUpdateManyWithoutRotationDaysInput = {
  connect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarScheduleWhereUniqueInput>>;
};

export type CalendarScheduleWhereInput = {
  blockSchedule?: InputMaybe<BlockScheduleWhereUniqueInput>;
  calendar?: InputMaybe<CalendarWhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<StringNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
  startTime?: InputMaybe<StringNullableFilter>;
};

export type CalendarScheduleWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CalendarUpdateInput = {
  calendarDays?: InputMaybe<CalendarDayUpdateManyWithoutCalendarsInput>;
  calendarEntries?: InputMaybe<CalendarEntryUpdateManyWithoutCalendarsInput>;
  calendarSchedules?: InputMaybe<CalendarScheduleUpdateManyWithoutCalendarsInput>;
  calendarType?: InputMaybe<EnumCalendarCalendarType>;
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventUpdateManyWithoutCalendarsInput>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
  plannerCourse?: InputMaybe<CourseWhereUniqueInput>;
  plannerSection?: InputMaybe<SectionWhereUniqueInput>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
  schools?: InputMaybe<SchoolUpdateManyWithoutCalendarsInput>;
  section?: InputMaybe<SectionV2WhereUniqueInput>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type CalendarUpdateManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutPlannerRevisionsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutSectionV2sInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutSectionsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutSessionsInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CalendarWhereUniqueInput>>;
  set?: InputMaybe<Array<CalendarWhereUniqueInput>>;
};

export type CalendarUrlIdInput = {
  urlId: Scalars['String']['input'];
};

export type CalendarWhereInput = {
  calendarDays?: InputMaybe<CalendarDayListRelationFilter>;
  calendarEntries?: InputMaybe<CalendarEntryListRelationFilter>;
  calendarSchedules?: InputMaybe<CalendarScheduleListRelationFilter>;
  calendarType?: InputMaybe<EnumCalendarCalendarType>;
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  events?: InputMaybe<EventListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
  plannerCourse?: InputMaybe<CourseWhereUniqueInput>;
  plannerSection?: InputMaybe<SectionWhereUniqueInput>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
  schools?: InputMaybe<SchoolListRelationFilter>;
  section?: InputMaybe<SectionV2WhereUniqueInput>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  timezone?: InputMaybe<StringNullableFilter>;
  urlId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type CalendarWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type ChatEntry = {
  __typename?: 'ChatEntry';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type ClassV2 = {
  __typename?: 'ClassV2';
  calendars: Array<Calendar>;
  course?: Maybe<CourseV2>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drives: Array<Drive>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  enrollments: Array<Enrollment>;
  gradeLevels?: Maybe<Array<EnumClassV2GradeLevels>>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  school?: Maybe<School>;
  sections: Array<SectionV2>;
  sessions: Array<Session>;
  state?: Maybe<EnumClassV2State>;
  subjectCodes?: Maybe<Array<EnumClassV2SubjectCodes>>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
};


export type ClassV2CalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type ClassV2DrivesArgs = {
  orderBy?: InputMaybe<Array<DriveOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DriveWhereInput>;
};


export type ClassV2EnrollmentsArgs = {
  orderBy?: InputMaybe<Array<EnrollmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EnrollmentWhereInput>;
};


export type ClassV2SectionsArgs = {
  orderBy?: InputMaybe<Array<SectionV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SectionV2WhereInput>;
};


export type ClassV2SessionsArgs = {
  orderBy?: InputMaybe<Array<SessionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SessionWhereInput>;
};

export type ClassV2CreateInput = {
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutClassV2sInput>;
  course?: InputMaybe<CourseV2WhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  drives?: InputMaybe<DriveCreateNestedManyWithoutClassV2sInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  enrollments?: InputMaybe<EnrollmentCreateNestedManyWithoutClassV2sInput>;
  gradeLevels?: InputMaybe<Array<EnumClassV2GradeLevels>>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  school: SchoolWhereUniqueInput;
  sections?: InputMaybe<SectionV2CreateNestedManyWithoutClassV2sInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutClassV2sInput>;
  state: EnumClassV2State;
  subjectCodes?: InputMaybe<Array<EnumClassV2SubjectCodes>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId: Scalars['String']['input'];
};

export type ClassV2CreateNestedManyWithoutCourseV2sInput = {
  connect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
};

export type ClassV2CreateNestedManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
};

export type ClassV2CreateNestedManyWithoutSessionsInput = {
  connect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
};

export type ClassV2ListRelationFilter = {
  every?: InputMaybe<ClassV2WhereInput>;
  none?: InputMaybe<ClassV2WhereInput>;
  some?: InputMaybe<ClassV2WhereInput>;
};

export type ClassV2OrderByInput = {
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  gradeLevels?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  schoolId?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  subjectCodes?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
};

export type ClassV2UpdateInput = {
  calendars?: InputMaybe<CalendarUpdateManyWithoutClassV2sInput>;
  course?: InputMaybe<CourseV2WhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  drives?: InputMaybe<DriveUpdateManyWithoutClassV2sInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  enrollments?: InputMaybe<EnrollmentUpdateManyWithoutClassV2sInput>;
  gradeLevels?: InputMaybe<Array<EnumClassV2GradeLevels>>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  school?: InputMaybe<SchoolWhereUniqueInput>;
  sections?: InputMaybe<SectionV2UpdateManyWithoutClassV2sInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutClassV2sInput>;
  state?: InputMaybe<EnumClassV2State>;
  subjectCodes?: InputMaybe<Array<EnumClassV2SubjectCodes>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
};

export type ClassV2UpdateManyWithoutCourseV2sInput = {
  connect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
};

export type ClassV2UpdateManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
};

export type ClassV2UpdateManyWithoutSessionsInput = {
  connect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ClassV2WhereUniqueInput>>;
};

export type ClassV2WhereInput = {
  calendars?: InputMaybe<CalendarListRelationFilter>;
  course?: InputMaybe<CourseV2WhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  drives?: InputMaybe<DriveListRelationFilter>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  enrollments?: InputMaybe<EnrollmentListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  properties?: InputMaybe<JsonFilter>;
  school?: InputMaybe<SchoolWhereUniqueInput>;
  sections?: InputMaybe<SectionV2ListRelationFilter>;
  sessions?: InputMaybe<SessionListRelationFilter>;
  state?: InputMaybe<EnumClassV2State>;
  timezone?: InputMaybe<StringNullableFilter>;
  urlId?: InputMaybe<StringFilter>;
};

export type ClassV2WhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CollaboratorsInput = {
  districtId: Scalars['String']['input'];
  districtRoles: Array<EnumUserDistrictRoles>;
  emails: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CompleteToolStepInput = {
  id: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
};

export type Course = {
  __typename?: 'Course';
  assets: Array<Asset>;
  calendars: Array<Calendar>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  drives: Array<Drive>;
  emoji?: Maybe<Scalars['String']['output']>;
  favorites: Array<Favorite>;
  gradeLevel?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  periods: Array<Period>;
  planner?: Maybe<Planner>;
  resources: Array<Resource>;
  sections: Array<Section>;
  setup?: Maybe<Scalars['JSON']['output']>;
  standards?: Maybe<Scalars['JSON']['output']>;
  unitsAttributes?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  user?: Maybe<User>;
};


export type CourseAssetsArgs = {
  orderBy?: InputMaybe<Array<AssetOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type CourseCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type CourseDrivesArgs = {
  orderBy?: InputMaybe<Array<DriveOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DriveWhereInput>;
};


export type CourseFavoritesArgs = {
  orderBy?: InputMaybe<Array<FavoriteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<FavoriteWhereInput>;
};


export type CoursePeriodsArgs = {
  orderBy?: InputMaybe<Array<PeriodOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PeriodWhereInput>;
};


export type CourseResourcesArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type CourseSectionsArgs = {
  orderBy?: InputMaybe<Array<SectionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SectionWhereInput>;
};

export type CourseCreateInput = {
  assets?: InputMaybe<AssetCreateNestedManyWithoutCoursesInput>;
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutCoursesInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  drives?: InputMaybe<DriveCreateNestedManyWithoutCoursesInput>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  favorites?: InputMaybe<FavoriteCreateNestedManyWithoutCoursesInput>;
  gradeLevel?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  periods?: InputMaybe<PeriodCreateNestedManyWithoutCoursesInput>;
  planner: PlannerWhereUniqueInput;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutCoursesInput>;
  sections?: InputMaybe<SectionCreateNestedManyWithoutCoursesInput>;
  setup?: InputMaybe<Scalars['JSON']['input']>;
  standards?: InputMaybe<Scalars['JSON']['input']>;
  unitsAttributes?: InputMaybe<Scalars['JSON']['input']>;
  urlId: Scalars['String']['input'];
  user: UserWhereUniqueInput;
};

export type CourseCreateNestedManyWithoutPlannersInput = {
  connect?: InputMaybe<Array<CourseWhereUniqueInput>>;
};

export type CourseCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<CourseWhereUniqueInput>>;
};

export type CourseDatesList = {
  __typename?: 'CourseDatesList';
  sectionDates: Array<SectionDate>;
};

export type CourseListRelationFilter = {
  every?: InputMaybe<CourseWhereInput>;
  none?: InputMaybe<CourseWhereInput>;
  some?: InputMaybe<CourseWhereInput>;
};

export type CourseOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  emoji?: InputMaybe<SortOrder>;
  gradeLevel?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  plannerId?: InputMaybe<SortOrder>;
  setup?: InputMaybe<SortOrder>;
  standards?: InputMaybe<SortOrder>;
  unitsAttributes?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CourseUpdateInput = {
  assets?: InputMaybe<AssetUpdateManyWithoutCoursesInput>;
  calendars?: InputMaybe<CalendarUpdateManyWithoutCoursesInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  drives?: InputMaybe<DriveUpdateManyWithoutCoursesInput>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  favorites?: InputMaybe<FavoriteUpdateManyWithoutCoursesInput>;
  gradeLevel?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<PeriodUpdateManyWithoutCoursesInput>;
  planner?: InputMaybe<PlannerWhereUniqueInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutCoursesInput>;
  sections?: InputMaybe<SectionUpdateManyWithoutCoursesInput>;
  setup?: InputMaybe<Scalars['JSON']['input']>;
  standards?: InputMaybe<Scalars['JSON']['input']>;
  unitsAttributes?: InputMaybe<Scalars['JSON']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type CourseUpdateManyWithoutPlannersInput = {
  connect?: InputMaybe<Array<CourseWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CourseWhereUniqueInput>>;
  set?: InputMaybe<Array<CourseWhereUniqueInput>>;
};

export type CourseUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<CourseWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CourseWhereUniqueInput>>;
  set?: InputMaybe<Array<CourseWhereUniqueInput>>;
};

export type CourseV2 = {
  __typename?: 'CourseV2';
  classes: Array<ClassV2>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<District>;
  drives: Array<Drive>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  gradeLevels?: Maybe<Array<EnumCourseV2GradeLevels>>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  school?: Maybe<School>;
  session?: Maybe<Session>;
  subject?: Maybe<Subject>;
  subjectCodes?: Maybe<Array<EnumCourseV2SubjectCodes>>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
};


export type CourseV2ClassesArgs = {
  orderBy?: InputMaybe<Array<ClassV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ClassV2WhereInput>;
};


export type CourseV2DrivesArgs = {
  orderBy?: InputMaybe<Array<DriveOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DriveWhereInput>;
};

export type CourseV2CreateInput = {
  classes?: InputMaybe<ClassV2CreateNestedManyWithoutCourseV2sInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  district: DistrictWhereUniqueInput;
  drives?: InputMaybe<DriveCreateNestedManyWithoutCourseV2sInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  gradeLevels?: InputMaybe<Array<EnumCourseV2GradeLevels>>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  school?: InputMaybe<SchoolWhereUniqueInput>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  subject?: InputMaybe<SubjectWhereUniqueInput>;
  subjectCodes?: InputMaybe<Array<EnumCourseV2SubjectCodes>>;
  urlId: Scalars['String']['input'];
};

export type CourseV2CreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
};

export type CourseV2CreateNestedManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
};

export type CourseV2CreateNestedManyWithoutSessionsInput = {
  connect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
};

export type CourseV2CreateNestedManyWithoutSubjectsInput = {
  connect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
};

export type CourseV2ListRelationFilter = {
  every?: InputMaybe<CourseV2WhereInput>;
  none?: InputMaybe<CourseV2WhereInput>;
  some?: InputMaybe<CourseV2WhereInput>;
};

export type CourseV2OrderByInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  gradeLevels?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  schoolId?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrder>;
  subjectCodes?: InputMaybe<SortOrder>;
  subjectId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
};

export type CourseV2UpdateInput = {
  classes?: InputMaybe<ClassV2UpdateManyWithoutCourseV2sInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  drives?: InputMaybe<DriveUpdateManyWithoutCourseV2sInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  gradeLevels?: InputMaybe<Array<EnumCourseV2GradeLevels>>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  school?: InputMaybe<SchoolWhereUniqueInput>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  subject?: InputMaybe<SubjectWhereUniqueInput>;
  subjectCodes?: InputMaybe<Array<EnumCourseV2SubjectCodes>>;
  urlId?: InputMaybe<Scalars['String']['input']>;
};

export type CourseV2UpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
  set?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
};

export type CourseV2UpdateManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
  set?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
};

export type CourseV2UpdateManyWithoutSessionsInput = {
  connect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
  set?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
};

export type CourseV2UpdateManyWithoutSubjectsInput = {
  connect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
  disconnect?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
  set?: InputMaybe<Array<CourseV2WhereUniqueInput>>;
};

export type CourseV2WhereInput = {
  classes?: InputMaybe<ClassV2ListRelationFilter>;
  code?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  drives?: InputMaybe<DriveListRelationFilter>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  name?: InputMaybe<StringFilter>;
  properties?: InputMaybe<JsonFilter>;
  school?: InputMaybe<SchoolWhereUniqueInput>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  subject?: InputMaybe<SubjectWhereUniqueInput>;
  urlId?: InputMaybe<StringFilter>;
};

export type CourseV2WhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CourseWhereInput = {
  assets?: InputMaybe<AssetListRelationFilter>;
  calendars?: InputMaybe<CalendarListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  drives?: InputMaybe<DriveListRelationFilter>;
  emoji?: InputMaybe<StringNullableFilter>;
  favorites?: InputMaybe<FavoriteListRelationFilter>;
  gradeLevel?: InputMaybe<StringNullableFilter>;
  icon?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  periods?: InputMaybe<PeriodListRelationFilter>;
  planner?: InputMaybe<PlannerWhereUniqueInput>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  sections?: InputMaybe<SectionListRelationFilter>;
  setup?: InputMaybe<JsonFilter>;
  standards?: InputMaybe<JsonFilter>;
  unitsAttributes?: InputMaybe<JsonFilter>;
  urlId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type CourseWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CreateAlternateScheduleInput = {
  block: BlockWhereUniqueInput;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type CreateBlockScheduleInput = {
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  rotationDay: RotationDayWhereUniqueInput;
  startTime: Scalars['String']['input'];
};

export type CreateCalendarScheduleInput = {
  blockSchedule?: InputMaybe<BlockScheduleWhereUniqueInput>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  rotationDay: RotationDayWhereUniqueInput;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRotationDayInput = {
  abbreviation: Scalars['String']['input'];
  dayIndex: Scalars['Float']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type Credentials = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type Department = {
  __typename?: 'Department';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district?: Maybe<District>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  schools: Array<School>;
  subjects: Array<Subject>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  users: Array<User>;
};


export type DepartmentSchoolsArgs = {
  orderBy?: InputMaybe<Array<SchoolOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SchoolWhereInput>;
};


export type DepartmentSubjectsArgs = {
  orderBy?: InputMaybe<Array<SubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SubjectWhereInput>;
};


export type DepartmentUsersArgs = {
  orderBy?: InputMaybe<Array<UserOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type DepartmentCreateInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district: DistrictWhereUniqueInput;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  schools?: InputMaybe<SchoolCreateNestedManyWithoutDepartmentsInput>;
  subjects?: InputMaybe<SubjectCreateNestedManyWithoutDepartmentsInput>;
  urlId: Scalars['String']['input'];
  users?: InputMaybe<UserCreateNestedManyWithoutDepartmentsInput>;
};

export type DepartmentCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
};

export type DepartmentCreateNestedManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
};

export type DepartmentCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
};

export type DepartmentListRelationFilter = {
  every?: InputMaybe<DepartmentWhereInput>;
  none?: InputMaybe<DepartmentWhereInput>;
  some?: InputMaybe<DepartmentWhereInput>;
};

export type DepartmentOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
};

export type DepartmentUpdateInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  schools?: InputMaybe<SchoolUpdateManyWithoutDepartmentsInput>;
  subjects?: InputMaybe<SubjectUpdateManyWithoutDepartmentsInput>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<UserUpdateManyWithoutDepartmentsInput>;
};

export type DepartmentUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
  set?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
};

export type DepartmentUpdateManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
  set?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
};

export type DepartmentUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
  set?: InputMaybe<Array<DepartmentWhereUniqueInput>>;
};

export type DepartmentWhereInput = {
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  name?: InputMaybe<StringFilter>;
  properties?: InputMaybe<JsonFilter>;
  schools?: InputMaybe<SchoolListRelationFilter>;
  subjects?: InputMaybe<SubjectListRelationFilter>;
  urlId?: InputMaybe<StringFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type DepartmentWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type District = {
  __typename?: 'District';
  address?: Maybe<Scalars['JSON']['output']>;
  calendars: Array<Calendar>;
  courses: Array<CourseV2>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  departments: Array<Department>;
  drives: Array<Drive>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  edlinkIntegrations: Array<EdlinkIntegration>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  invites: Array<Invite>;
  legacyUsers: Array<User>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payments?: Maybe<Scalars['JSON']['output']>;
  preferences?: Maybe<Scalars['JSON']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  schools: Array<School>;
  sessions: Array<Session>;
  subjects: Array<Subject>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  users: Array<User>;
  workspaceType?: Maybe<EnumDistrictWorkspaceType>;
};


export type DistrictCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type DistrictCoursesArgs = {
  orderBy?: InputMaybe<Array<CourseV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CourseV2WhereInput>;
};


export type DistrictDepartmentsArgs = {
  orderBy?: InputMaybe<Array<DepartmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DepartmentWhereInput>;
};


export type DistrictDrivesArgs = {
  orderBy?: InputMaybe<Array<DriveOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DriveWhereInput>;
};


export type DistrictEdlinkIntegrationsArgs = {
  orderBy?: InputMaybe<Array<EdlinkIntegrationOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkIntegrationWhereInput>;
};


export type DistrictInvitesArgs = {
  orderBy?: InputMaybe<Array<InviteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<InviteWhereInput>;
};


export type DistrictLegacyUsersArgs = {
  orderBy?: InputMaybe<Array<UserOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type DistrictSchoolsArgs = {
  orderBy?: InputMaybe<Array<SchoolOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SchoolWhereInput>;
};


export type DistrictSessionsArgs = {
  orderBy?: InputMaybe<Array<SessionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type DistrictSubjectsArgs = {
  orderBy?: InputMaybe<Array<SubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SubjectWhereInput>;
};


export type DistrictUsersArgs = {
  orderBy?: InputMaybe<Array<UserOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type DistrictCreateInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutDistrictsInput>;
  courses?: InputMaybe<CourseV2CreateNestedManyWithoutDistrictsInput>;
  createdBy?: InputMaybe<UserWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departments?: InputMaybe<DepartmentCreateNestedManyWithoutDistrictsInput>;
  drives?: InputMaybe<DriveCreateNestedManyWithoutDistrictsInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  edlinkIntegrations?: InputMaybe<EdlinkIntegrationCreateNestedManyWithoutDistrictsInput>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutDistrictsInput>;
  legacyUsers?: InputMaybe<UserCreateNestedManyWithoutDistrictsInput>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  payments?: InputMaybe<Scalars['JSON']['input']>;
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  schools?: InputMaybe<SchoolCreateNestedManyWithoutDistrictsInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutDistrictsInput>;
  subjects?: InputMaybe<SubjectCreateNestedManyWithoutDistrictsInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId: Scalars['String']['input'];
  users?: InputMaybe<UserCreateNestedManyWithoutDistrictsInput>;
  workspaceType?: InputMaybe<EnumDistrictWorkspaceType>;
};

export type DistrictOrderByInput = {
  address?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdById?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  payments?: InputMaybe<SortOrder>;
  preferences?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
  workspaceType?: InputMaybe<SortOrder>;
};

export type DistrictUpdateInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  calendars?: InputMaybe<CalendarUpdateManyWithoutDistrictsInput>;
  courses?: InputMaybe<CourseV2UpdateManyWithoutDistrictsInput>;
  createdBy?: InputMaybe<UserWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departments?: InputMaybe<DepartmentUpdateManyWithoutDistrictsInput>;
  drives?: InputMaybe<DriveUpdateManyWithoutDistrictsInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  edlinkIntegrations?: InputMaybe<EdlinkIntegrationUpdateManyWithoutDistrictsInput>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  invites?: InputMaybe<InviteUpdateManyWithoutDistrictsInput>;
  legacyUsers?: InputMaybe<UserUpdateManyWithoutDistrictsInput>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<Scalars['JSON']['input']>;
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  schools?: InputMaybe<SchoolUpdateManyWithoutDistrictsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutDistrictsInput>;
  subjects?: InputMaybe<SubjectUpdateManyWithoutDistrictsInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<UserUpdateManyWithoutDistrictsInput>;
  workspaceType?: InputMaybe<EnumDistrictWorkspaceType>;
};

export type DistrictWhereInput = {
  address?: InputMaybe<JsonFilter>;
  calendars?: InputMaybe<CalendarListRelationFilter>;
  courses?: InputMaybe<CourseV2ListRelationFilter>;
  createdBy?: InputMaybe<UserWhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  departments?: InputMaybe<DepartmentListRelationFilter>;
  drives?: InputMaybe<DriveListRelationFilter>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  edlinkIntegrations?: InputMaybe<EdlinkIntegrationListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  invites?: InputMaybe<InviteListRelationFilter>;
  legacyUsers?: InputMaybe<UserListRelationFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  payments?: InputMaybe<JsonFilter>;
  preferences?: InputMaybe<JsonFilter>;
  properties?: InputMaybe<JsonFilter>;
  schools?: InputMaybe<SchoolListRelationFilter>;
  sessions?: InputMaybe<SessionListRelationFilter>;
  subjects?: InputMaybe<SubjectListRelationFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  urlId?: InputMaybe<StringFilter>;
  users?: InputMaybe<UserListRelationFilter>;
  workspaceType?: InputMaybe<EnumDistrictWorkspaceType>;
};

export type DistrictWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Drive = {
  __typename?: 'Drive';
  classV2?: Maybe<ClassV2>;
  course?: Maybe<Course>;
  courseV2?: Maybe<CourseV2>;
  createdAt: Scalars['DateTime']['output'];
  district?: Maybe<District>;
  driveType?: Maybe<EnumDriveDriveType>;
  id: Scalars['String']['output'];
  permissions: Array<Permission>;
  resources: Array<Resource>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};


export type DrivePermissionsArgs = {
  orderBy?: InputMaybe<Array<PermissionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type DriveResourcesArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};

export type DriveCreateInput = {
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  courseV2?: InputMaybe<CourseV2WhereUniqueInput>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  driveType: EnumDriveDriveType;
  permissions?: InputMaybe<PermissionCreateNestedManyWithoutDrivesInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutDrivesInput>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type DriveCreateNestedManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveCreateNestedManyWithoutCourseV2sInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveCreateNestedManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveListRelationFilter = {
  every?: InputMaybe<DriveWhereInput>;
  none?: InputMaybe<DriveWhereInput>;
  some?: InputMaybe<DriveWhereInput>;
};

export type DriveOrderByInput = {
  classV2Id?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  courseV2Id?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  driveType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type DriveUpdateInput = {
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  courseV2?: InputMaybe<CourseV2WhereUniqueInput>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  driveType?: InputMaybe<EnumDriveDriveType>;
  permissions?: InputMaybe<PermissionUpdateManyWithoutDrivesInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutDrivesInput>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type DriveUpdateManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  set?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveUpdateManyWithoutCourseV2sInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  set?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveUpdateManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  set?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  set?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<DriveWhereUniqueInput>>;
  set?: InputMaybe<Array<DriveWhereUniqueInput>>;
};

export type DriveWhereInput = {
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  courseV2?: InputMaybe<CourseV2WhereUniqueInput>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  driveType?: InputMaybe<EnumDriveDriveType>;
  id?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<PermissionListRelationFilter>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type DriveWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type EditImageInput = {
  id: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type EditImageResponse = {
  __typename?: 'EditImageResponse';
  draftUrl: Scalars['String']['output'];
};

export type EdlinkCredentials = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type EdlinkIntegration = {
  __typename?: 'EdlinkIntegration';
  accessToken: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  configuration?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<District>;
  edlinkId: Scalars['String']['output'];
  edlinkLogs: Array<EdlinkLog>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  ltiConsumerKey?: Maybe<Scalars['String']['output']>;
  ltiSharedSecret?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['JSON']['output']>;
  provider?: Maybe<EdlinkProvider>;
  scope?: Maybe<EnumEdlinkIntegrationScope>;
  source?: Maybe<EdlinkSource>;
  ssoAvailable?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<EnumEdlinkIntegrationStatus>;
  updatedAt: Scalars['DateTime']['output'];
};


export type EdlinkIntegrationEdlinkLogsArgs = {
  orderBy?: InputMaybe<Array<EdlinkLogOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkLogWhereInput>;
};

export type EdlinkIntegrationCreateInput = {
  accessToken: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId: Scalars['String']['input'];
  edlinkLogs?: InputMaybe<EdlinkLogCreateNestedManyWithoutEdlinkIntegrationsInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  ltiConsumerKey?: InputMaybe<Scalars['String']['input']>;
  ltiSharedSecret?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  provider: EdlinkProviderWhereUniqueInput;
  scope: EnumEdlinkIntegrationScope;
  source: EdlinkSourceWhereUniqueInput;
  ssoAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: EnumEdlinkIntegrationStatus;
};

export type EdlinkIntegrationCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
};

export type EdlinkIntegrationCreateNestedManyWithoutEdlinkProvidersInput = {
  connect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
};

export type EdlinkIntegrationCreateNestedManyWithoutEdlinkSourcesInput = {
  connect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
};

export type EdlinkIntegrationListRelationFilter = {
  every?: InputMaybe<EdlinkIntegrationWhereInput>;
  none?: InputMaybe<EdlinkIntegrationWhereInput>;
  some?: InputMaybe<EdlinkIntegrationWhereInput>;
};

export type EdlinkIntegrationOrderByInput = {
  accessToken?: InputMaybe<SortOrder>;
  applicationId?: InputMaybe<SortOrder>;
  configuration?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locked?: InputMaybe<SortOrder>;
  ltiConsumerKey?: InputMaybe<SortOrder>;
  ltiSharedSecret?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  sourceId?: InputMaybe<SortOrder>;
  ssoAvailable?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EdlinkIntegrationUpdateInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  edlinkLogs?: InputMaybe<EdlinkLogUpdateManyWithoutEdlinkIntegrationsInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  ltiConsumerKey?: InputMaybe<Scalars['String']['input']>;
  ltiSharedSecret?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  provider?: InputMaybe<EdlinkProviderWhereUniqueInput>;
  scope?: InputMaybe<EnumEdlinkIntegrationScope>;
  source?: InputMaybe<EdlinkSourceWhereUniqueInput>;
  ssoAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<EnumEdlinkIntegrationStatus>;
};

export type EdlinkIntegrationUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
  set?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
};

export type EdlinkIntegrationUpdateManyWithoutEdlinkProvidersInput = {
  connect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
  set?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
};

export type EdlinkIntegrationUpdateManyWithoutEdlinkSourcesInput = {
  connect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
  set?: InputMaybe<Array<EdlinkIntegrationWhereUniqueInput>>;
};

export type EdlinkIntegrationWhereInput = {
  accessToken?: InputMaybe<StringFilter>;
  applicationId?: InputMaybe<StringFilter>;
  configuration?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<StringFilter>;
  edlinkLogs?: InputMaybe<EdlinkLogListRelationFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locked?: InputMaybe<BooleanNullableFilter>;
  ltiConsumerKey?: InputMaybe<StringNullableFilter>;
  ltiSharedSecret?: InputMaybe<StringNullableFilter>;
  permissions?: InputMaybe<JsonFilter>;
  provider?: InputMaybe<EdlinkProviderWhereUniqueInput>;
  scope?: InputMaybe<EnumEdlinkIntegrationScope>;
  source?: InputMaybe<EdlinkSourceWhereUniqueInput>;
  ssoAvailable?: InputMaybe<BooleanNullableFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumEdlinkIntegrationStatus>;
};

export type EdlinkIntegrationWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type EdlinkLog = {
  __typename?: 'EdlinkLog';
  createdAt: Scalars['DateTime']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integration?: Maybe<EdlinkIntegration>;
  logType?: Maybe<EnumEdlinkLogLogType>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  syncData?: Maybe<Scalars['JSON']['output']>;
  syncStatus?: Maybe<EnumEdlinkLogSyncStatus>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EdlinkLogCreateInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<EdlinkIntegrationWhereUniqueInput>;
  logType: EnumEdlinkLogLogType;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  syncData?: InputMaybe<Scalars['JSON']['input']>;
  syncStatus?: InputMaybe<EnumEdlinkLogSyncStatus>;
};

export type EdlinkLogCreateNestedManyWithoutEdlinkIntegrationsInput = {
  connect?: InputMaybe<Array<EdlinkLogWhereUniqueInput>>;
};

export type EdlinkLogListRelationFilter = {
  every?: InputMaybe<EdlinkLogWhereInput>;
  none?: InputMaybe<EdlinkLogWhereInput>;
  some?: InputMaybe<EdlinkLogWhereInput>;
};

export type EdlinkLogOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  integrationId?: InputMaybe<SortOrder>;
  logType?: InputMaybe<SortOrder>;
  metaData?: InputMaybe<SortOrder>;
  syncData?: InputMaybe<SortOrder>;
  syncStatus?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EdlinkLogUpdateInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<EdlinkIntegrationWhereUniqueInput>;
  logType?: InputMaybe<EnumEdlinkLogLogType>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  syncData?: InputMaybe<Scalars['JSON']['input']>;
  syncStatus?: InputMaybe<EnumEdlinkLogSyncStatus>;
};

export type EdlinkLogUpdateManyWithoutEdlinkIntegrationsInput = {
  connect?: InputMaybe<Array<EdlinkLogWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EdlinkLogWhereUniqueInput>>;
  set?: InputMaybe<Array<EdlinkLogWhereUniqueInput>>;
};

export type EdlinkLogWhereInput = {
  eventId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  integration?: InputMaybe<EdlinkIntegrationWhereUniqueInput>;
  logType?: InputMaybe<EnumEdlinkLogLogType>;
  metaData?: InputMaybe<JsonFilter>;
  syncData?: InputMaybe<JsonFilter>;
  syncStatus?: InputMaybe<EnumEdlinkLogSyncStatus>;
};

export type EdlinkLogWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type EdlinkProvider = {
  __typename?: 'EdlinkProvider';
  allowsDataSync?: Maybe<Scalars['Boolean']['output']>;
  application?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  edlinkId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integrations: Array<EdlinkIntegration>;
  name: Scalars['String']['output'];
  sources: Array<EdlinkSource>;
  updatedAt: Scalars['DateTime']['output'];
};


export type EdlinkProviderIntegrationsArgs = {
  orderBy?: InputMaybe<Array<EdlinkIntegrationOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkIntegrationWhereInput>;
};


export type EdlinkProviderSourcesArgs = {
  orderBy?: InputMaybe<Array<EdlinkSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkSourceWhereInput>;
};

export type EdlinkProviderCreateInput = {
  allowsDataSync?: InputMaybe<Scalars['Boolean']['input']>;
  application?: InputMaybe<Scalars['String']['input']>;
  edlinkId: Scalars['String']['input'];
  integrations?: InputMaybe<EdlinkIntegrationCreateNestedManyWithoutEdlinkProvidersInput>;
  name: Scalars['String']['input'];
  sources?: InputMaybe<EdlinkSourceCreateNestedManyWithoutEdlinkProvidersInput>;
};

export type EdlinkProviderOrderByInput = {
  allowsDataSync?: InputMaybe<SortOrder>;
  application?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EdlinkProviderUpdateInput = {
  allowsDataSync?: InputMaybe<Scalars['Boolean']['input']>;
  application?: InputMaybe<Scalars['String']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<EdlinkIntegrationUpdateManyWithoutEdlinkProvidersInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<EdlinkSourceUpdateManyWithoutEdlinkProvidersInput>;
};

export type EdlinkProviderWhereInput = {
  allowsDataSync?: InputMaybe<BooleanNullableFilter>;
  application?: InputMaybe<StringNullableFilter>;
  edlinkId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  integrations?: InputMaybe<EdlinkIntegrationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  sources?: InputMaybe<EdlinkSourceListRelationFilter>;
};

export type EdlinkProviderWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type EdlinkSource = {
  __typename?: 'EdlinkSource';
  configuration?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  edlinkId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  integrations: Array<EdlinkIntegration>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  provider?: Maybe<EdlinkProvider>;
  status?: Maybe<EnumEdlinkSourceStatus>;
  updatedAt: Scalars['DateTime']['output'];
};


export type EdlinkSourceIntegrationsArgs = {
  orderBy?: InputMaybe<Array<EdlinkIntegrationOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkIntegrationWhereInput>;
};

export type EdlinkSourceCreateInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  edlinkId: Scalars['String']['input'];
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  integrations?: InputMaybe<EdlinkIntegrationCreateNestedManyWithoutEdlinkSourcesInput>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  provider: EdlinkProviderWhereUniqueInput;
  status: EnumEdlinkSourceStatus;
};

export type EdlinkSourceCreateNestedManyWithoutEdlinkProvidersInput = {
  connect?: InputMaybe<Array<EdlinkSourceWhereUniqueInput>>;
};

export type EdlinkSourceListRelationFilter = {
  every?: InputMaybe<EdlinkSourceWhereInput>;
  none?: InputMaybe<EdlinkSourceWhereInput>;
  some?: InputMaybe<EdlinkSourceWhereInput>;
};

export type EdlinkSourceOrderByInput = {
  configuration?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EdlinkSourceUpdateInput = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  integrations?: InputMaybe<EdlinkIntegrationUpdateManyWithoutEdlinkSourcesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  provider?: InputMaybe<EdlinkProviderWhereUniqueInput>;
  status?: InputMaybe<EnumEdlinkSourceStatus>;
};

export type EdlinkSourceUpdateManyWithoutEdlinkProvidersInput = {
  connect?: InputMaybe<Array<EdlinkSourceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EdlinkSourceWhereUniqueInput>>;
  set?: InputMaybe<Array<EdlinkSourceWhereUniqueInput>>;
};

export type EdlinkSourceWhereInput = {
  configuration?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  edlinkId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  integrations?: InputMaybe<EdlinkIntegrationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  properties?: InputMaybe<JsonFilter>;
  provider?: InputMaybe<EdlinkProviderWhereUniqueInput>;
  status?: InputMaybe<EnumEdlinkSourceStatus>;
};

export type EdlinkSourceWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type EmailHashInput = {
  email: Scalars['String']['input'];
  hash: Scalars['String']['input'];
};

export type Enrollment = {
  __typename?: 'Enrollment';
  classV2?: Maybe<ClassV2>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  role?: Maybe<EnumEnrollmentRole>;
  section?: Maybe<SectionV2>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<EnumEnrollmentState>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type EnrollmentCreateInput = {
  classV2: ClassV2WhereUniqueInput;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  role: EnumEnrollmentRole;
  section: SectionV2WhereUniqueInput;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state: EnumEnrollmentState;
  user: UserWhereUniqueInput;
};

export type EnrollmentCreateNestedManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
};

export type EnrollmentCreateNestedManyWithoutSectionV2sInput = {
  connect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
};

export type EnrollmentCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
};

export type EnrollmentListRelationFilter = {
  every?: InputMaybe<EnrollmentWhereInput>;
  none?: InputMaybe<EnrollmentWhereInput>;
  some?: InputMaybe<EnrollmentWhereInput>;
};

export type EnrollmentOrderByInput = {
  classV2Id?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  primary?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  sectionId?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type EnrollmentUpdateInput = {
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  role?: InputMaybe<EnumEnrollmentRole>;
  section?: InputMaybe<SectionV2WhereUniqueInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<EnumEnrollmentState>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type EnrollmentUpdateManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
  set?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
};

export type EnrollmentUpdateManyWithoutSectionV2sInput = {
  connect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
  set?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
};

export type EnrollmentUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
  set?: InputMaybe<Array<EnrollmentWhereUniqueInput>>;
};

export type EnrollmentWhereInput = {
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  primary?: InputMaybe<BooleanNullableFilter>;
  properties?: InputMaybe<JsonFilter>;
  role?: InputMaybe<EnumEnrollmentRole>;
  section?: InputMaybe<SectionV2WhereUniqueInput>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  state?: InputMaybe<EnumEnrollmentState>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type EnrollmentWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type EnterpriseOnboardingCredentials = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type EnterprisePlan = {
  __typename?: 'EnterprisePlan';
  isEnterpriseAccount: Scalars['Boolean']['output'];
  isLicenseActive: Scalars['Boolean']['output'];
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

export enum EnumAiFavoriteEntityType {
  Gpt = 'Gpt',
  Tool = 'Tool'
}

export enum EnumAiFeedbackEntity {
  AiTool = 'AiTool',
  AiToolAutofill = 'AiToolAutofill',
  AiToolStepOutput = 'AiToolStepOutput',
  ChatMessage = 'ChatMessage',
  CreatePresentation = 'CreatePresentation',
  DocAi = 'DocAi'
}

export enum EnumAiToolParticipantFeedbackType {
  Dislike = 'Dislike',
  Like = 'Like'
}

export enum EnumAiToolParticipantPermissions {
  Read = 'Read',
  Write = 'Write'
}

export enum EnumAssetAcl {
  Private = 'Private',
  PublicRead = 'PublicRead'
}

export enum EnumAssetAdvancedProcessing {
  Error = 'Error',
  InProgress = 'InProgress',
  Successful = 'Successful'
}

export enum EnumAssetAssetType {
  Attachment = 'Attachment',
  Embed = 'Embed',
  Import = 'Import'
}

export enum EnumAssetVectorEmbeddings {
  Error = 'Error',
  InProgress = 'InProgress',
  Successful = 'Successful'
}

export enum EnumBotConversationEntrySpeaker {
  Bot = 'Bot',
  User = 'User'
}

export enum EnumBotConversationParticipantPermissions {
  Read = 'Read',
  Write = 'Write'
}

export enum EnumCalendarCalendarType {
  Custom = 'Custom',
  PlannerDefault = 'PlannerDefault',
  SectionDefault = 'SectionDefault',
  SessionDefault = 'SessionDefault',
  UserDefault = 'UserDefault'
}

export enum EnumCalendarDayChangeType {
  AlternateSchedule = 'AlternateSchedule',
  RotationDay = 'RotationDay'
}

export enum EnumClassV2GradeLevels {
  Al = 'Al',
  Birth = 'Birth',
  Cl = 'Cl',
  G1 = 'G1',
  G2 = 'G2',
  G3 = 'G3',
  G4 = 'G4',
  G5 = 'G5',
  G6 = 'G6',
  G7 = 'G7',
  G8 = 'G8',
  G9 = 'G9',
  G10 = 'G10',
  G11 = 'G11',
  G12 = 'G12',
  G13 = 'G13',
  It = 'It',
  Kg = 'Kg',
  Other = 'Other',
  Pk = 'Pk',
  Pr = 'Pr',
  Prenatal = 'Prenatal',
  Ps = 'Ps',
  Tk = 'Tk',
  Ug = 'Ug'
}

export enum EnumClassV2State {
  Active = 'Active',
  Archived = 'Archived',
  Completed = 'Completed',
  Inactive = 'Inactive',
  Template = 'Template',
  Upcoming = 'Upcoming'
}

export enum EnumClassV2SubjectCodes {
  Ceds01 = 'Ceds01',
  Ceds02 = 'Ceds02',
  Ceds03 = 'Ceds03',
  Ceds04 = 'Ceds04',
  Ceds05 = 'Ceds05',
  Ceds07 = 'Ceds07',
  Ceds08 = 'Ceds08',
  Ceds09 = 'Ceds09',
  Ceds10 = 'Ceds10',
  Ceds11 = 'Ceds11',
  Ceds12 = 'Ceds12',
  Ceds13 = 'Ceds13',
  Ceds14 = 'Ceds14',
  Ceds15 = 'Ceds15',
  Ceds16 = 'Ceds16',
  Ceds17 = 'Ceds17',
  Ceds18 = 'Ceds18',
  Ceds19 = 'Ceds19',
  Ceds20 = 'Ceds20',
  Ceds21 = 'Ceds21',
  Ceds22 = 'Ceds22',
  Ceds23 = 'Ceds23',
  Ceds24 = 'Ceds24',
  El01 = 'El01',
  El02 = 'El02'
}

export enum EnumCourseV2GradeLevels {
  Al = 'Al',
  Birth = 'Birth',
  Cl = 'Cl',
  G1 = 'G1',
  G2 = 'G2',
  G3 = 'G3',
  G4 = 'G4',
  G5 = 'G5',
  G6 = 'G6',
  G7 = 'G7',
  G8 = 'G8',
  G9 = 'G9',
  G10 = 'G10',
  G11 = 'G11',
  G12 = 'G12',
  G13 = 'G13',
  It = 'It',
  Kg = 'Kg',
  Other = 'Other',
  Pk = 'Pk',
  Pr = 'Pr',
  Prenatal = 'Prenatal',
  Ps = 'Ps',
  Tk = 'Tk',
  Ug = 'Ug'
}

export enum EnumCourseV2SubjectCodes {
  Ceds01 = 'Ceds01',
  Ceds02 = 'Ceds02',
  Ceds03 = 'Ceds03',
  Ceds04 = 'Ceds04',
  Ceds05 = 'Ceds05',
  Ceds07 = 'Ceds07',
  Ceds08 = 'Ceds08',
  Ceds09 = 'Ceds09',
  Ceds10 = 'Ceds10',
  Ceds11 = 'Ceds11',
  Ceds12 = 'Ceds12',
  Ceds13 = 'Ceds13',
  Ceds14 = 'Ceds14',
  Ceds15 = 'Ceds15',
  Ceds16 = 'Ceds16',
  Ceds17 = 'Ceds17',
  Ceds18 = 'Ceds18',
  Ceds19 = 'Ceds19',
  Ceds20 = 'Ceds20',
  Ceds21 = 'Ceds21',
  Ceds22 = 'Ceds22',
  Ceds23 = 'Ceds23',
  Ceds24 = 'Ceds24',
  El01 = 'El01',
  El02 = 'El02'
}

export enum EnumDistrictWorkspaceType {
  Department = 'Department',
  District = 'District',
  School = 'School'
}

export enum EnumDriveDriveType {
  ClassDefault = 'ClassDefault',
  CourseDefault = 'CourseDefault',
  MyDrive = 'MyDrive',
  SharedDrive = 'SharedDrive',
  WorkspaceDefault = 'WorkspaceDefault'
}

export enum EnumEdlinkIntegrationScope {
  All = 'All',
  Limited = 'Limited',
  Rules = 'Rules'
}

export enum EnumEdlinkIntegrationStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Error = 'Error',
  Inactive = 'Inactive',
  Paused = 'Paused',
  Pending = 'Pending',
  Requested = 'Requested',
  Scheduled = 'Scheduled'
}

export enum EnumEdlinkLogLogType {
  FullSync = 'FullSync',
  LastEventSynced = 'LastEventSynced',
  PartialSync = 'PartialSync'
}

export enum EnumEdlinkLogSyncStatus {
  Error = 'Error',
  InProgress = 'InProgress',
  Success = 'Success'
}

export enum EnumEdlinkSourceStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Error = 'Error',
  Inactive = 'Inactive'
}

export enum EnumEnrollmentRole {
  Administrator = 'Administrator',
  Aide = 'Aide',
  Designer = 'Designer',
  DistrictAdministrator = 'DistrictAdministrator',
  Guardian = 'Guardian',
  Member = 'Member',
  Parent = 'Parent',
  Staff = 'Staff',
  Student = 'Student',
  Ta = 'Ta',
  Teacher = 'Teacher'
}

export enum EnumEnrollmentState {
  Active = 'Active',
  Completed = 'Completed',
  Dropped = 'Dropped',
  Inactive = 'Inactive',
  Pending = 'Pending',
  Upcoming = 'Upcoming'
}

/** Filter input for user district roles */
export type EnumEnumUserDistrictRolesNullableListFilterInput = {
  equals?: InputMaybe<Array<EnumUserDistrictRoles>>;
  has?: InputMaybe<EnumUserDistrictRoles>;
  hasEvery?: InputMaybe<Array<EnumUserDistrictRoles>>;
  hasSome?: InputMaybe<Array<EnumUserDistrictRoles>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum EnumEventEventType {
  Event = 'Event',
  FirstDay = 'FirstDay',
  Holiday = 'Holiday',
  LastDay = 'LastDay',
  NoSchool = 'NoSchool',
  Occasion = 'Occasion',
  Period = 'Period'
}

export enum EnumFeaturePreset {
  Chat = 'Chat',
  CurriculumCreator = 'CurriculumCreator',
  ImageGenerator = 'ImageGenerator',
  InstantResources = 'InstantResources'
}

export enum EnumInviteDistrictRoles {
  Administrator = 'Administrator',
  Aide = 'Aide',
  Designer = 'Designer',
  DistrictAdministrator = 'DistrictAdministrator',
  Guardian = 'Guardian',
  Member = 'Member',
  Parent = 'Parent',
  Staff = 'Staff',
  Student = 'Student',
  Ta = 'Ta',
  Teacher = 'Teacher'
}

export enum EnumInviteInviteType {
  Referral = 'Referral',
  Workspace = 'Workspace'
}

export enum EnumInviteStatus {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Unverified = 'Unverified'
}

export enum EnumPermissionPermissionType {
  Anyone = 'Anyone',
  User = 'User'
}

export enum EnumPermissionRole {
  Commenter = 'Commenter',
  Editor = 'Editor',
  FileOrganizer = 'FileOrganizer',
  Organizer = 'Organizer',
  Owner = 'Owner',
  Viewer = 'Viewer'
}

export enum EnumPlannerRevisionDaysOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum EnumPlannerRevisionScheduleType {
  CycleDays = 'CycleDays',
  CycleWeeks = 'CycleWeeks',
  Day = 'Day',
  Week = 'Week'
}

export enum EnumRecentActivityItemType {
  Chat = 'Chat',
  CurriculumCreator = 'CurriculumCreator',
  Documents = 'Documents',
  ImageGenerator = 'ImageGenerator',
  InstantResources = 'InstantResources',
  Slides = 'Slides'
}

export enum EnumReferralPendingAction {
  ChatUse = 'ChatUse',
  Completed = 'Completed',
  CreateSlideshow = 'CreateSlideshow',
  FinishOnboarding = 'FinishOnboarding'
}

export enum EnumReferralRewardStatus {
  Active = 'Active',
  MaxDaysExceeded = 'MaxDaysExceeded',
  Pending = 'Pending'
}

export enum EnumReinitializeRotationDayChange {
  Added = 'Added',
  Removed = 'Removed',
  Shifted = 'Shifted',
  Unchanged = 'Unchanged'
}

export enum EnumResourceResourceType {
  Doc = 'Doc',
  Folder = 'Folder',
  LessonPlan = 'LessonPlan',
  ProseMirrorDoc = 'ProseMirrorDoc',
  Unit = 'Unit'
}

export enum EnumRotationScheduleDaysOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum EnumRotationScheduleGradeLevels {
  Al = 'Al',
  Birth = 'Birth',
  Cl = 'Cl',
  G1 = 'G1',
  G2 = 'G2',
  G3 = 'G3',
  G4 = 'G4',
  G5 = 'G5',
  G6 = 'G6',
  G7 = 'G7',
  G8 = 'G8',
  G9 = 'G9',
  G10 = 'G10',
  G11 = 'G11',
  G12 = 'G12',
  G13 = 'G13',
  It = 'It',
  Kg = 'Kg',
  Other = 'Other',
  Pk = 'Pk',
  Pr = 'Pr',
  Prenatal = 'Prenatal',
  Ps = 'Ps',
  Tk = 'Tk',
  Ug = 'Ug'
}

export enum EnumSchoolGradeLevels {
  Al = 'Al',
  Birth = 'Birth',
  Cl = 'Cl',
  G1 = 'G1',
  G2 = 'G2',
  G3 = 'G3',
  G4 = 'G4',
  G5 = 'G5',
  G6 = 'G6',
  G7 = 'G7',
  G8 = 'G8',
  G9 = 'G9',
  G10 = 'G10',
  G11 = 'G11',
  G12 = 'G12',
  G13 = 'G13',
  It = 'It',
  Kg = 'Kg',
  Other = 'Other',
  Pk = 'Pk',
  Pr = 'Pr',
  Prenatal = 'Prenatal',
  Ps = 'Ps',
  Tk = 'Tk',
  Ug = 'Ug'
}

export enum EnumSectionV2State {
  Active = 'Active',
  Archived = 'Archived',
  Completed = 'Completed',
  Default = 'Default',
  Inactive = 'Inactive',
  Upcoming = 'Upcoming'
}

export enum EnumSessionSessionType {
  GradingPeriod = 'GradingPeriod',
  SchoolYear = 'SchoolYear',
  Semester = 'Semester',
  Term = 'Term'
}

export enum EnumSessionState {
  Active = 'Active',
  Completed = 'Completed',
  Upcoming = 'Upcoming'
}

export enum EnumSlideCreationType {
  File = 'File',
  SlideBySlide = 'SlideBySlide',
  TopicDescription = 'TopicDescription',
  Video = 'Video'
}

export enum EnumSlideStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Queued = 'Queued',
  Successful = 'Successful'
}

export enum EnumSubscriptionInterval {
  Annually = 'Annually',
  Monthly = 'Monthly'
}

export enum EnumUserDistrictRoles {
  Administrator = 'Administrator',
  Aide = 'Aide',
  Designer = 'Designer',
  DistrictAdministrator = 'DistrictAdministrator',
  Guardian = 'Guardian',
  Member = 'Member',
  Parent = 'Parent',
  Staff = 'Staff',
  Student = 'Student',
  Ta = 'Ta',
  Teacher = 'Teacher'
}

export enum EnumUserGradeLevels {
  Al = 'Al',
  Birth = 'Birth',
  Cl = 'Cl',
  G1 = 'G1',
  G2 = 'G2',
  G3 = 'G3',
  G4 = 'G4',
  G5 = 'G5',
  G6 = 'G6',
  G7 = 'G7',
  G8 = 'G8',
  G9 = 'G9',
  G10 = 'G10',
  G11 = 'G11',
  G12 = 'G12',
  G13 = 'G13',
  It = 'It',
  Kg = 'Kg',
  Other = 'Other',
  Pk = 'Pk',
  Pr = 'Pr',
  Prenatal = 'Prenatal',
  Ps = 'Ps',
  Tk = 'Tk',
  Ug = 'Ug'
}

export enum EnumUserLanguage {
  Am = 'Am',
  Ar = 'Ar',
  Bn = 'Bn',
  Ca = 'Ca',
  Da = 'Da',
  De = 'De',
  El = 'El',
  En = 'En',
  Es = 'Es',
  Fa = 'Fa',
  Fi = 'Fi',
  Fr = 'Fr',
  He = 'He',
  Hi = 'Hi',
  Hr = 'Hr',
  Hu = 'Hu',
  Id = 'Id',
  It = 'It',
  Ja = 'Ja',
  Ko = 'Ko',
  Mr = 'Mr',
  Nl = 'Nl',
  Pa = 'Pa',
  Pl = 'Pl',
  Pt = 'Pt',
  Ro = 'Ro',
  Ru = 'Ru',
  Sa = 'Sa',
  Sv = 'Sv',
  Sw = 'Sw',
  Ta = 'Ta',
  Te = 'Te',
  Th = 'Th',
  Tr = 'Tr',
  Ur = 'Ur',
  Vi = 'Vi',
  ZhCn = 'ZhCn'
}

export enum EnumUserSubscriptionInterval {
  Annually = 'Annually',
  Monthly = 'Monthly'
}

export enum EnumUserSubscriptionType {
  Copilot = 'Copilot',
  CopilotSlidesBundle = 'CopilotSlidesBundle',
  Slides = 'Slides'
}

export enum EnumUserUserRole {
  AcademicCoordinator = 'AcademicCoordinator',
  Administrator = 'Administrator',
  CurriculumDeveloper = 'CurriculumDeveloper',
  Principal = 'Principal',
  Student = 'Student',
  Teacher = 'Teacher',
  TeachingAssistant = 'TeachingAssistant'
}

export type Event = {
  __typename?: 'Event';
  allDay?: Maybe<Scalars['Boolean']['output']>;
  calendar?: Maybe<Calendar>;
  calendarDay?: Maybe<CalendarDay>;
  calendarSchedule?: Maybe<CalendarSchedule>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  eventType?: Maybe<EnumEventEventType>;
  id: Scalars['String']['output'];
  recurring?: Maybe<Scalars['JSON']['output']>;
  resourceSchedules: Array<ResourceSchedule>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
};


export type EventResourceSchedulesArgs = {
  orderBy?: InputMaybe<Array<ResourceScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceScheduleWhereInput>;
};

export type EventCreateInput = {
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  calendar: CalendarWhereUniqueInput;
  calendarDay?: InputMaybe<CalendarDayWhereUniqueInput>;
  calendarSchedule?: InputMaybe<CalendarScheduleWhereUniqueInput>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<EnumEventEventType>;
  recurring?: InputMaybe<Scalars['JSON']['input']>;
  resourceSchedules?: InputMaybe<ResourceScheduleCreateNestedManyWithoutEventsInput>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  urlId: Scalars['String']['input'];
};

export type EventCreateNestedManyWithoutCalendarDaysInput = {
  connect?: InputMaybe<Array<EventWhereUniqueInput>>;
};

export type EventCreateNestedManyWithoutCalendarSchedulesInput = {
  connect?: InputMaybe<Array<EventWhereUniqueInput>>;
};

export type EventCreateNestedManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<EventWhereUniqueInput>>;
};

export type EventListRelationFilter = {
  every?: InputMaybe<EventWhereInput>;
  none?: InputMaybe<EventWhereInput>;
  some?: InputMaybe<EventWhereInput>;
};

export type EventOrderByInput = {
  allDay?: InputMaybe<SortOrder>;
  calendarDayId?: InputMaybe<SortOrder>;
  calendarId?: InputMaybe<SortOrder>;
  calendarScheduleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  eventType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  recurring?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
};

export type EventUpdateInput = {
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  calendar?: InputMaybe<CalendarWhereUniqueInput>;
  calendarDay?: InputMaybe<CalendarDayWhereUniqueInput>;
  calendarSchedule?: InputMaybe<CalendarScheduleWhereUniqueInput>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<EnumEventEventType>;
  recurring?: InputMaybe<Scalars['JSON']['input']>;
  resourceSchedules?: InputMaybe<ResourceScheduleUpdateManyWithoutEventsInput>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
};

export type EventUpdateManyWithoutCalendarDaysInput = {
  connect?: InputMaybe<Array<EventWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EventWhereUniqueInput>>;
  set?: InputMaybe<Array<EventWhereUniqueInput>>;
};

export type EventUpdateManyWithoutCalendarSchedulesInput = {
  connect?: InputMaybe<Array<EventWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EventWhereUniqueInput>>;
  set?: InputMaybe<Array<EventWhereUniqueInput>>;
};

export type EventUpdateManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<EventWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<EventWhereUniqueInput>>;
  set?: InputMaybe<Array<EventWhereUniqueInput>>;
};

export type EventWhereInput = {
  allDay?: InputMaybe<BooleanNullableFilter>;
  calendar?: InputMaybe<CalendarWhereUniqueInput>;
  calendarDay?: InputMaybe<CalendarDayWhereUniqueInput>;
  calendarSchedule?: InputMaybe<CalendarScheduleWhereUniqueInput>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  eventType?: InputMaybe<EnumEventEventType>;
  id?: InputMaybe<StringFilter>;
  recurring?: InputMaybe<JsonFilter>;
  resourceSchedules?: InputMaybe<ResourceScheduleListRelationFilter>;
  startTime?: InputMaybe<DateTimeNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  urlId?: InputMaybe<StringFilter>;
};

export type EventWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type ExportMarkdownToGoogleDocInput = {
  feature: EnumFeaturePreset;
  markdownContent: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ExportMarkdownToGoogleFormInput = {
  determineValidity: Scalars['Boolean']['input'];
  feature: EnumFeaturePreset;
  markdownContent: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Favorite = {
  __typename?: 'Favorite';
  course?: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  resource?: Maybe<Resource>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type FavoriteCreateInput = {
  course?: InputMaybe<CourseWhereUniqueInput>;
  resource: ResourceWhereUniqueInput;
  user: UserWhereUniqueInput;
};

export type FavoriteCreateNestedManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
};

export type FavoriteCreateNestedManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
};

export type FavoriteCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
};

export type FavoriteListRelationFilter = {
  every?: InputMaybe<FavoriteWhereInput>;
  none?: InputMaybe<FavoriteWhereInput>;
  some?: InputMaybe<FavoriteWhereInput>;
};

export type FavoriteOrderByInput = {
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type FavoriteUpdateInput = {
  course?: InputMaybe<CourseWhereUniqueInput>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type FavoriteUpdateManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
  set?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
};

export type FavoriteUpdateManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
  set?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
};

export type FavoriteUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
  set?: InputMaybe<Array<FavoriteWhereUniqueInput>>;
};

export type FavoriteWhereInput = {
  course?: InputMaybe<CourseWhereUniqueInput>;
  id?: InputMaybe<StringFilter>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type FavoriteWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type FinalStepOutputInput = {
  aiStepId: Scalars['String']['input'];
  aiToolId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type FirstLastDayResponse = {
  __typename?: 'FirstLastDayResponse';
  endEvent: Event;
  startEvent: Event;
};

export type FirstLastDaysInput = {
  endDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GenerateStepOutputInput = {
  aiStepId: Scalars['String']['input'];
  aiToolId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type GetTokenInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GoogleExportResponse = {
  __typename?: 'GoogleExportResponse';
  error?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GoogleSlidesAddOnCredentials = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type InitToolInput = {
  aiToolParticipants?: InputMaybe<AiToolParticipantCreateNestedManyWithoutAiToolsInput>;
  aiToolSteps?: InputMaybe<AiToolStepCreateNestedManyWithoutAiToolsInput>;
  initData: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
  toolId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Invite = {
  __typename?: 'Invite';
  createdAt: Scalars['DateTime']['output'];
  district?: Maybe<District>;
  districtRoles?: Maybe<Array<EnumInviteDistrictRoles>>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inviteType?: Maybe<EnumInviteInviteType>;
  invitedBy?: Maybe<User>;
  remindedAt?: Maybe<Scalars['DateTime']['output']>;
  remindersSent?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<EnumInviteStatus>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InviteAFriendSlidesInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InviteCreateInput = {
  district?: InputMaybe<DistrictWhereUniqueInput>;
  districtRoles?: InputMaybe<Array<EnumInviteDistrictRoles>>;
  email: Scalars['String']['input'];
  inviteType: EnumInviteInviteType;
  invitedBy: UserWhereUniqueInput;
  remindedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remindersSent?: InputMaybe<Scalars['Float']['input']>;
  status: EnumInviteStatus;
};

export type InviteCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
};

export type InviteCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
};

export type InviteListRelationFilter = {
  every?: InputMaybe<InviteWhereInput>;
  none?: InputMaybe<InviteWhereInput>;
  some?: InputMaybe<InviteWhereInput>;
};

export type InviteOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  districtRoles?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviteType?: InputMaybe<SortOrder>;
  invitedById?: InputMaybe<SortOrder>;
  remindedAt?: InputMaybe<SortOrder>;
  remindersSent?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type InviteUpdateInput = {
  district?: InputMaybe<DistrictWhereUniqueInput>;
  districtRoles?: InputMaybe<Array<EnumInviteDistrictRoles>>;
  email?: InputMaybe<Scalars['String']['input']>;
  inviteType?: InputMaybe<EnumInviteInviteType>;
  invitedBy?: InputMaybe<UserWhereUniqueInput>;
  remindedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remindersSent?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumInviteStatus>;
};

export type InviteUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  set?: InputMaybe<Array<InviteWhereUniqueInput>>;
};

export type InviteUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<InviteWhereUniqueInput>>;
  set?: InputMaybe<Array<InviteWhereUniqueInput>>;
};

export type InviteWhereInput = {
  district?: InputMaybe<DistrictWhereUniqueInput>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  inviteType?: InputMaybe<EnumInviteInviteType>;
  invitedBy?: InputMaybe<UserWhereUniqueInput>;
  remindedAt?: InputMaybe<DateTimeNullableFilter>;
  remindersSent?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumInviteStatus>;
};

export type InviteWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type IsActivateEligibleInput = {
  userId: Scalars['String']['input'];
};

export type JsonFilter = {
  equals?: InputMaybe<Scalars['JSONObject']['input']>;
  not?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type MakeUserActiveInput = {
  assignSeat: Scalars['Boolean']['input'];
  districtId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MetaQueryPayload = {
  __typename?: 'MetaQueryPayload';
  count: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite: Scalars['Boolean']['output'];
  activateUserWithPassword: UserClientResponse;
  activateUserWithSSO: UserClientResponse;
  addTemplateToUser: Resource;
  aiChatInterfaceInput: Scalars['Boolean']['output'];
  aiChatInterfaceSuggestionResponse: Scalars['Boolean']['output'];
  aiContentAssistant: Scalars['Boolean']['output'];
  aiToolFieldAutofill: Scalars['Boolean']['output'];
  aiToolFinalOutput: Scalars['Boolean']['output'];
  archiveResource: Resource;
  assignClassSchedules: Scalars['Boolean']['output'];
  authenticateUserGoogleAddOn: UserClientResponse;
  changeActiveUserStatus: Scalars['Boolean']['output'];
  changeUserLicense: Scalars['Boolean']['output'];
  changeUserLicenseBulk: Scalars['Boolean']['output'];
  completeOnboarding: Scalars['Boolean']['output'];
  completeReferralAction: Scalars['Boolean']['output'];
  completeToolStep: AiTool;
  convertMarkdownToPDF: Scalars['String']['output'];
  createAiFavorite: AiFavorite;
  createAiFeedback: AiFeedback;
  createAiTool: AiTool;
  createAiToolParticipant: AiToolParticipant;
  createAiToolStep: AiToolStep;
  createAlternateSchedule: AlternateSchedule;
  createAsset: Asset;
  createAuditLog: AuditLog;
  createBlock: Block;
  createBlockSchedule: BlockSchedule;
  createBotConversation: BotConversation;
  createBotConversationEntry: BotConversationEntry;
  createBotConversationParticipant: BotConversationParticipant;
  createCalendar: Calendar;
  createCalendarDay: CalendarDay;
  createCalendarEntry: CalendarEntry;
  createCalendarSchedule: CalendarSchedule;
  createClassV2: ClassV2;
  createCourse: Course;
  createCourseV2: CourseV2;
  createDepartment: Department;
  createDistrict: District;
  createDistrictUserAdminPortal: User;
  createDistrictUserAlaynaPortal: User;
  createDistrictWithDrive: District;
  createDrive: Drive;
  createEdlinkIntegration: EdlinkIntegration;
  createEdlinkLog: EdlinkLog;
  createEdlinkProvider: EdlinkProvider;
  createEdlinkSource: EdlinkSource;
  createEnrollment: Enrollment;
  createEvent: Event;
  createFavorite: Favorite;
  createInvite: Invite;
  createPeriod: Period;
  createPermission: Permission;
  createPlanner: Planner;
  createPlannerDate: PlannerDate;
  createPlannerRevision: PlannerRevision;
  createReferral: Referral;
  createReferralReward: ReferralReward;
  createRefreshToken: Scalars['Boolean']['output'];
  createResource: Resource;
  createResourceSchedule: ResourceSchedule;
  createRotationDay: RotationDay;
  createRotationSchedule: RotationSchedule;
  createRotationScheduleWithCalendar: RotationSchedule;
  createSchedule: Schedule;
  createSchool: School;
  createSection: Section;
  createSectionForClass: SectionV2;
  createSectionV2: SectionV2;
  createSession: Session;
  createSlide: Slide;
  createSlideshow: Slide;
  createStripeCheckoutSession: Scalars['String']['output'];
  createSubject: Subject;
  createUser: User;
  createVersion: Version;
  deleteActivity: Scalars['Boolean']['output'];
  deleteAiFavorite: AiFavorite;
  deleteAiFeedback: AiFeedback;
  deleteAiTool: AiTool;
  deleteAiToolParticipant: AiToolParticipant;
  deleteAiToolStep: AiToolStep;
  deleteAlternateSchedule: AlternateSchedule;
  deleteAsset: Asset;
  deleteAttachment: Scalars['Boolean']['output'];
  deleteAuditLog: AuditLog;
  deleteBlock: Block;
  deleteBlockSchedule: BlockSchedule;
  deleteBotConversation: BotConversation;
  deleteBotConversationEntry: BotConversationEntry;
  deleteBotConversationParticipant: BotConversationParticipant;
  deleteCalendar: Calendar;
  deleteCalendarDay: CalendarDay;
  deleteCalendarEntry: CalendarEntry;
  deleteCalendarSchedule: CalendarSchedule;
  deleteClassV2: ClassV2;
  deleteCourse: Course;
  deleteCourseV2: CourseV2;
  deleteDepartment: Department;
  deleteDistrict: District;
  deleteDrive: Drive;
  deleteEdlinkIntegration: EdlinkIntegration;
  deleteEdlinkLog: EdlinkLog;
  deleteEdlinkProvider: EdlinkProvider;
  deleteEdlinkSource: EdlinkSource;
  deleteEnrollment: Enrollment;
  deleteEvent: Event;
  deleteFavorite: Favorite;
  deleteInvite: Invite;
  deletePeriod: Period;
  deletePermission: Permission;
  deletePlanner: Planner;
  deletePlannerDate: PlannerDate;
  deletePlannerRevision: PlannerRevision;
  deleteReferral: Referral;
  deleteReferralReward: ReferralReward;
  deleteResource: Resource;
  deleteResourceSchedule: ResourceSchedule;
  deleteRotationDay: RotationDay;
  deleteRotationSchedule: RotationSchedule;
  deleteSchedule: Schedule;
  deleteSchool: School;
  deleteSection: Section;
  deleteSectionV2: SectionV2;
  deleteSession: Session;
  deleteSlide: Slide;
  deleteSlideshow: Scalars['Boolean']['output'];
  deleteSubject: Subject;
  deleteUser: User;
  deleteVersion: Version;
  duplicateResource: Resource;
  editAiToolImage: EditImageResponse;
  exportMarkdownToGoogleDoc: GoogleExportResponse;
  exportMarkdownToGoogleForm: GoogleExportResponse;
  finishEnterpriseOnboarding: Scalars['Boolean']['output'];
  finishSlidesOnboarding: Scalars['Boolean']['output'];
  generateStepOutput: Scalars['Boolean']['output'];
  handleApiSignOut: Scalars['Boolean']['output'];
  initAiTool: AiTool;
  initResource: Resource;
  inviteAFriendSlides: Scalars['Boolean']['output'];
  inviteCollaborators: Scalars['Boolean']['output'];
  isActivateEligible: Scalars['Boolean']['output'];
  isEdlinkUser: Scalars['Boolean']['output'];
  linkForEmbedding: Asset;
  loginAlaynaPortal: UserClientResponse;
  loginWithEdlink: UserClientResponse;
  loginWithEdlinkAdminPortal: UserClientResponse;
  loginWithEmail: UserClientResponse;
  makeUserActive: Scalars['Boolean']['output'];
  makeUserActiveAlaynaPortal: Scalars['Boolean']['output'];
  makeUsersActiveBulk: Scalars['Boolean']['output'];
  makeUsersActiveBulkAlaynaPortal: Scalars['Boolean']['output'];
  markActivityComplete: Scalars['Boolean']['output'];
  markAiToolComplete: AiTool;
  markAiToolDeleted: AiTool;
  markBotConversationComplete: BotConversation;
  markBotConversationDeleted: BotConversation;
  modifyCalendarDay: CalendarDay;
  moveResource: Resource;
  newBotConversation: BotConversation;
  newBotConversationEntry: BotConversationEntry;
  permanentlyDeleteResource: Resource;
  populateAlternateDaySchedules: Scalars['Boolean']['output'];
  populateBlockSchedules: Scalars['Boolean']['output'];
  populateCalendarSchedules: Scalars['Boolean']['output'];
  populateRotationDays: Scalars['Boolean']['output'];
  publishResource: Resource;
  redirectToStripeCustomerPortal: Scalars['String']['output'];
  referAFriend: Scalars['Boolean']['output'];
  referralLinkSignUp: Scalars['Boolean']['output'];
  referralSignupCompleted: Scalars['Boolean']['output'];
  regenerateBotConversationEntry: BotConversationEntry;
  reinitializeRotationDayPreview: ReinitializeRotationDayPreview;
  resendVerificationEmail: Scalars['Boolean']['output'];
  resetPasswordWithEmail: Scalars['Boolean']['output'];
  resourceGeneratorEdit: Scalars['Boolean']['output'];
  restoreAiTool: AiTool;
  restoreBotConversation: BotConversation;
  restoreResource: Resource;
  retrySlideCreation: Slide;
  revokeAllGoogleDriveIntegrations: Scalars['Boolean']['output'];
  revokeTokenForUser: Scalars['Boolean']['output'];
  sendOnboardingInvite: Scalars['Boolean']['output'];
  sendReferralEmailInvites: Scalars['Boolean']['output'];
  setFirstAndLastDayEvents: FirstLastDayResponse;
  setNewPassword: Scalars['Boolean']['output'];
  signUpAlaynaPortal: UserClientResponse;
  signUpWithEmail: UserClientResponse;
  signUpWithEmailForAI: UserClientResponse;
  skipInitTool: AiTool;
  subscribeToNewsletter: Scalars['Boolean']['output'];
  templatizeResource: Resource;
  trackWeeklyReportClick: Scalars['Boolean']['output'];
  unmarkAiToolComplete: AiTool;
  unmarkBotConversationComplete: BotConversation;
  unpublishResource: Resource;
  unsubscribeFromWeeklyReports: Scalars['Boolean']['output'];
  updateAiFavorite: AiFavorite;
  updateAiFeedback: AiFeedback;
  updateAiTool: AiTool;
  updateAiToolParticipant: AiToolParticipant;
  updateAiToolStep: AiToolStep;
  updateAlternateSchedule: AlternateSchedule;
  updateAsset: Asset;
  updateAuditLog: AuditLog;
  updateBlock: Block;
  updateBlockSchedule: BlockSchedule;
  updateBotConversation: BotConversation;
  updateBotConversationEntry: BotConversationEntry;
  updateBotConversationParticipant: BotConversationParticipant;
  updateCalendar: Calendar;
  updateCalendarDay: CalendarDay;
  updateCalendarEntry: CalendarEntry;
  updateCalendarSchedule: CalendarSchedule;
  updateClassV2: ClassV2;
  updateCourse: Course;
  updateCourseV2: CourseV2;
  updateDepartment: Department;
  updateDistrict: District;
  updateDrive: Drive;
  updateEdlinkIntegration: EdlinkIntegration;
  updateEdlinkLog: EdlinkLog;
  updateEdlinkProvider: EdlinkProvider;
  updateEdlinkSource: EdlinkSource;
  updateEnrollment: Enrollment;
  updateEvent: Event;
  updateFavorite: Favorite;
  updateInvite: Invite;
  updatePassword: Scalars['Boolean']['output'];
  updatePeriod: Period;
  updatePermission: Permission;
  updatePlanner: Planner;
  updatePlannerDate: PlannerDate;
  updatePlannerRevision: PlannerRevision;
  updateReferral: Referral;
  updateReferralReward: ReferralReward;
  updateResource: Resource;
  updateResourceAttributes: Resource;
  updateResourceSchedule: ResourceSchedule;
  updateRotationDay: RotationDay;
  updateRotationSchedule: RotationSchedule;
  updateSchedule: Schedule;
  updateSchool: School;
  updateSection: Section;
  updateSectionV2: SectionV2;
  updateSession: Session;
  updateSlide: Slide;
  updateSubject: Subject;
  updateUser: User;
  updateUserDetails: Scalars['Boolean']['output'];
  updateUserDistrictRole: Scalars['Boolean']['output'];
  updateVersion: Version;
  updateWithImport: Resource;
  updateWithTemplate: Resource;
  upgradeSubscription: Scalars['Boolean']['output'];
  utilizeImport: Resource;
  utilizeTemplate: Resource;
  verifyEmail: Scalars['Boolean']['output'];
};


export type MutationAcceptInviteArgs = {
  inviteInput: AcceptInviteDetails;
};


export type MutationActivateUserWithPasswordArgs = {
  activateUserWithPasswordInput: ActivateUserWithPasswordInput;
};


export type MutationActivateUserWithSsoArgs = {
  activateUserWithSSOInput: ActivateUserWithSso;
};


export type MutationAddTemplateToUserArgs = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationAiChatInterfaceInputArgs = {
  where: AiChatInterfaceInput;
};


export type MutationAiChatInterfaceSuggestionResponseArgs = {
  where: AiChatInterfaceSuggestionResponseInput;
};


export type MutationAiContentAssistantArgs = {
  data: AiAssistantInput;
};


export type MutationAiToolFieldAutofillArgs = {
  where: AiAutofillInput;
};


export type MutationAiToolFinalOutputArgs = {
  where: FinalStepOutputInput;
};


export type MutationArchiveResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationAssignClassSchedulesArgs = {
  classIds: Array<Scalars['String']['input']>;
  rotationScheduleId: Scalars['String']['input'];
};


export type MutationAuthenticateUserGoogleAddOnArgs = {
  googleSlidesAddOnCredentials: GoogleSlidesAddOnCredentials;
};


export type MutationChangeActiveUserStatusArgs = {
  activeUserStatusInput: ActiveUserStatusInput;
};


export type MutationChangeUserLicenseArgs = {
  userLicenseActiveInput: UserLicenseActiveInput;
};


export type MutationChangeUserLicenseBulkArgs = {
  bulkLicenseActiveInput: BulkLicenseActiveInput;
};


export type MutationCompleteOnboardingArgs = {
  onboardingInput: OnboardingInput;
};


export type MutationCompleteReferralActionArgs = {
  referralCompleteActionArgs: ReferralCompleteActionArgs;
};


export type MutationCompleteToolStepArgs = {
  data: CompleteToolStepInput;
};


export type MutationConvertMarkdownToPdfArgs = {
  fileName: Scalars['String']['input'];
  markdown: Scalars['String']['input'];
};


export type MutationCreateAiFavoriteArgs = {
  data: AiFavoriteCreateInput;
};


export type MutationCreateAiFeedbackArgs = {
  data: AiFeedbackCreateInput;
};


export type MutationCreateAiToolArgs = {
  data: AiToolCreateInput;
};


export type MutationCreateAiToolParticipantArgs = {
  data: AiToolParticipantCreateInput;
};


export type MutationCreateAiToolStepArgs = {
  data: AiToolStepCreateInput;
};


export type MutationCreateAlternateScheduleArgs = {
  data: AlternateScheduleCreateInput;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateAuditLogArgs = {
  data: AuditLogCreateInput;
};


export type MutationCreateBlockArgs = {
  data: BlockCreateInput;
};


export type MutationCreateBlockScheduleArgs = {
  data: BlockScheduleCreateInput;
};


export type MutationCreateBotConversationArgs = {
  data: BotConversationCreateInput;
};


export type MutationCreateBotConversationEntryArgs = {
  data: BotConversationEntryCreateInput;
};


export type MutationCreateBotConversationParticipantArgs = {
  data: BotConversationParticipantCreateInput;
};


export type MutationCreateCalendarArgs = {
  data: CalendarCreateInput;
};


export type MutationCreateCalendarDayArgs = {
  data: CalendarDayCreateInput;
};


export type MutationCreateCalendarEntryArgs = {
  data: CalendarEntryCreateInput;
};


export type MutationCreateCalendarScheduleArgs = {
  data: CalendarScheduleCreateInput;
};


export type MutationCreateClassV2Args = {
  data: ClassV2CreateInput;
};


export type MutationCreateCourseArgs = {
  data: CourseCreateInput;
};


export type MutationCreateCourseV2Args = {
  data: CourseV2CreateInput;
};


export type MutationCreateDepartmentArgs = {
  data: DepartmentCreateInput;
};


export type MutationCreateDistrictArgs = {
  data: DistrictCreateInput;
};


export type MutationCreateDistrictUserAdminPortalArgs = {
  data: UserCreateInput;
};


export type MutationCreateDistrictUserAlaynaPortalArgs = {
  data: UserCreateInput;
};


export type MutationCreateDistrictWithDriveArgs = {
  data: DistrictCreateInput;
};


export type MutationCreateDriveArgs = {
  data: DriveCreateInput;
};


export type MutationCreateEdlinkIntegrationArgs = {
  data: EdlinkIntegrationCreateInput;
};


export type MutationCreateEdlinkLogArgs = {
  data: EdlinkLogCreateInput;
};


export type MutationCreateEdlinkProviderArgs = {
  data: EdlinkProviderCreateInput;
};


export type MutationCreateEdlinkSourceArgs = {
  data: EdlinkSourceCreateInput;
};


export type MutationCreateEnrollmentArgs = {
  data: EnrollmentCreateInput;
};


export type MutationCreateEventArgs = {
  data: EventCreateInput;
};


export type MutationCreateFavoriteArgs = {
  data: FavoriteCreateInput;
};


export type MutationCreateInviteArgs = {
  data: InviteCreateInput;
};


export type MutationCreatePeriodArgs = {
  data: PeriodCreateInput;
};


export type MutationCreatePermissionArgs = {
  data: PermissionCreateInput;
};


export type MutationCreatePlannerArgs = {
  data: PlannerCreateInput;
};


export type MutationCreatePlannerDateArgs = {
  data: PlannerDateCreateInput;
};


export type MutationCreatePlannerRevisionArgs = {
  data: PlannerRevisionCreateInput;
};


export type MutationCreateReferralArgs = {
  data: ReferralCreateInput;
};


export type MutationCreateReferralRewardArgs = {
  data: ReferralRewardCreateInput;
};


export type MutationCreateRefreshTokenArgs = {
  tokenInput: GetTokenInput;
};


export type MutationCreateResourceArgs = {
  data: ResourceCreateInput;
};


export type MutationCreateResourceScheduleArgs = {
  data: ResourceScheduleCreateInput;
};


export type MutationCreateRotationDayArgs = {
  data: RotationDayCreateInput;
};


export type MutationCreateRotationScheduleArgs = {
  data: RotationScheduleCreateInput;
};


export type MutationCreateRotationScheduleWithCalendarArgs = {
  data: RotationScheduleCreateInput;
};


export type MutationCreateScheduleArgs = {
  data: ScheduleCreateInput;
};


export type MutationCreateSchoolArgs = {
  data: SchoolCreateInput;
};


export type MutationCreateSectionArgs = {
  data: SectionCreateInput;
};


export type MutationCreateSectionForClassArgs = {
  data: SectionV2CreateInput;
};


export type MutationCreateSectionV2Args = {
  data: SectionV2CreateInput;
};


export type MutationCreateSessionArgs = {
  data: SessionCreateInput;
};


export type MutationCreateSlideArgs = {
  data: SlideCreateInput;
};


export type MutationCreateSlideshowArgs = {
  slideshowCreateInput: SlideshowCreateInput;
};


export type MutationCreateStripeCheckoutSessionArgs = {
  input: StripeCheckoutInput;
};


export type MutationCreateSubjectArgs = {
  data: SubjectCreateInput;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateVersionArgs = {
  data: VersionCreateInput;
};


export type MutationDeleteActivityArgs = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationDeleteAiFavoriteArgs = {
  where: AiFavoriteWhereUniqueInput;
};


export type MutationDeleteAiFeedbackArgs = {
  where: AiFeedbackWhereUniqueInput;
};


export type MutationDeleteAiToolArgs = {
  where: AiToolWhereUniqueInput;
};


export type MutationDeleteAiToolParticipantArgs = {
  where: AiToolParticipantWhereUniqueInput;
};


export type MutationDeleteAiToolStepArgs = {
  where: AiToolStepWhereUniqueInput;
};


export type MutationDeleteAlternateScheduleArgs = {
  where: AlternateScheduleWhereUniqueInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAuditLogArgs = {
  where: AuditLogWhereUniqueInput;
};


export type MutationDeleteBlockArgs = {
  where: BlockWhereUniqueInput;
};


export type MutationDeleteBlockScheduleArgs = {
  where: BlockScheduleWhereUniqueInput;
};


export type MutationDeleteBotConversationArgs = {
  where: BotConversationWhereUniqueInput;
};


export type MutationDeleteBotConversationEntryArgs = {
  where: BotConversationEntryWhereUniqueInput;
};


export type MutationDeleteBotConversationParticipantArgs = {
  where: BotConversationParticipantWhereUniqueInput;
};


export type MutationDeleteCalendarArgs = {
  where: CalendarWhereUniqueInput;
};


export type MutationDeleteCalendarDayArgs = {
  where: CalendarDayWhereUniqueInput;
};


export type MutationDeleteCalendarEntryArgs = {
  where: CalendarEntryWhereUniqueInput;
};


export type MutationDeleteCalendarScheduleArgs = {
  where: CalendarScheduleWhereUniqueInput;
};


export type MutationDeleteClassV2Args = {
  where: ClassV2WhereUniqueInput;
};


export type MutationDeleteCourseArgs = {
  where: CourseWhereUniqueInput;
};


export type MutationDeleteCourseV2Args = {
  where: CourseV2WhereUniqueInput;
};


export type MutationDeleteDepartmentArgs = {
  where: DepartmentWhereUniqueInput;
};


export type MutationDeleteDistrictArgs = {
  where: DistrictWhereUniqueInput;
};


export type MutationDeleteDriveArgs = {
  where: DriveWhereUniqueInput;
};


export type MutationDeleteEdlinkIntegrationArgs = {
  where: EdlinkIntegrationWhereUniqueInput;
};


export type MutationDeleteEdlinkLogArgs = {
  where: EdlinkLogWhereUniqueInput;
};


export type MutationDeleteEdlinkProviderArgs = {
  where: EdlinkProviderWhereUniqueInput;
};


export type MutationDeleteEdlinkSourceArgs = {
  where: EdlinkSourceWhereUniqueInput;
};


export type MutationDeleteEnrollmentArgs = {
  where: EnrollmentWhereUniqueInput;
};


export type MutationDeleteEventArgs = {
  where: EventWhereUniqueInput;
};


export type MutationDeleteFavoriteArgs = {
  where: FavoriteWhereUniqueInput;
};


export type MutationDeleteInviteArgs = {
  where: InviteWhereUniqueInput;
};


export type MutationDeletePeriodArgs = {
  where: PeriodWhereUniqueInput;
};


export type MutationDeletePermissionArgs = {
  where: PermissionWhereUniqueInput;
};


export type MutationDeletePlannerArgs = {
  where: PlannerWhereUniqueInput;
};


export type MutationDeletePlannerDateArgs = {
  where: PlannerDateWhereUniqueInput;
};


export type MutationDeletePlannerRevisionArgs = {
  where: PlannerRevisionWhereUniqueInput;
};


export type MutationDeleteReferralArgs = {
  where: ReferralWhereUniqueInput;
};


export type MutationDeleteReferralRewardArgs = {
  where: ReferralRewardWhereUniqueInput;
};


export type MutationDeleteResourceArgs = {
  where: ResourceWhereUniqueInput;
};


export type MutationDeleteResourceScheduleArgs = {
  where: ResourceScheduleWhereUniqueInput;
};


export type MutationDeleteRotationDayArgs = {
  where: RotationDayWhereUniqueInput;
};


export type MutationDeleteRotationScheduleArgs = {
  where: RotationScheduleWhereUniqueInput;
};


export type MutationDeleteScheduleArgs = {
  where: ScheduleWhereUniqueInput;
};


export type MutationDeleteSchoolArgs = {
  where: SchoolWhereUniqueInput;
};


export type MutationDeleteSectionArgs = {
  where: SectionWhereUniqueInput;
};


export type MutationDeleteSectionV2Args = {
  where: SectionV2WhereUniqueInput;
};


export type MutationDeleteSessionArgs = {
  where: SessionWhereUniqueInput;
};


export type MutationDeleteSlideArgs = {
  where: SlideWhereUniqueInput;
};


export type MutationDeleteSlideshowArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSubjectArgs = {
  where: SubjectWhereUniqueInput;
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteVersionArgs = {
  where: VersionWhereUniqueInput;
};


export type MutationDuplicateResourceArgs = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationEditAiToolImageArgs = {
  data: EditImageInput;
};


export type MutationExportMarkdownToGoogleDocArgs = {
  exportMarkdownToGoogleDocsInput: ExportMarkdownToGoogleDocInput;
};


export type MutationExportMarkdownToGoogleFormArgs = {
  exportMarkdownToGoogleFormsInput: ExportMarkdownToGoogleFormInput;
};


export type MutationFinishEnterpriseOnboardingArgs = {
  credentials: EnterpriseOnboardingCredentials;
};


export type MutationFinishSlidesOnboardingArgs = {
  slidesOnboardingInput: SlidesOnboardingInputType;
};


export type MutationGenerateStepOutputArgs = {
  where: GenerateStepOutputInput;
};


export type MutationHandleApiSignOutArgs = {
  tokenInput: RemoveTokenInput;
};


export type MutationInitAiToolArgs = {
  data: InitToolInput;
};


export type MutationInitResourceArgs = {
  data: ResourceInitInput;
};


export type MutationInviteAFriendSlidesArgs = {
  inviteAFriendSlidesInput: InviteAFriendSlidesInput;
};


export type MutationInviteCollaboratorsArgs = {
  collaboratorsInput: CollaboratorsInput;
};


export type MutationIsActivateEligibleArgs = {
  isActiveEligibleInput: IsActivateEligibleInput;
};


export type MutationIsEdlinkUserArgs = {
  email: Scalars['String']['input'];
};


export type MutationLinkForEmbeddingArgs = {
  data: AssetCreateInput;
};


export type MutationLoginAlaynaPortalArgs = {
  credentials: Credentials;
};


export type MutationLoginWithEdlinkArgs = {
  credentials: EdlinkCredentials;
};


export type MutationLoginWithEdlinkAdminPortalArgs = {
  credentials: EdlinkCredentials;
};


export type MutationLoginWithEmailArgs = {
  credentials: Credentials;
};


export type MutationMakeUserActiveArgs = {
  makeUserActiveInput: MakeUserActiveInput;
};


export type MutationMakeUserActiveAlaynaPortalArgs = {
  makeUserActiveInput: MakeUserActiveInput;
};


export type MutationMakeUsersActiveBulkArgs = {
  bulkUserActiveInput: BulkUserActiveInput;
};


export type MutationMakeUsersActiveBulkAlaynaPortalArgs = {
  bulkUserActiveInput: BulkUserActiveInput;
};


export type MutationMarkActivityCompleteArgs = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationMarkAiToolCompleteArgs = {
  where: AiToolWhereUniqueInput;
};


export type MutationMarkAiToolDeletedArgs = {
  where: AiToolWhereUniqueInput;
};


export type MutationMarkBotConversationCompleteArgs = {
  where: BotConversationWhereUniqueInput;
};


export type MutationMarkBotConversationDeletedArgs = {
  where: BotConversationWhereUniqueInput;
};


export type MutationModifyCalendarDayArgs = {
  calendarDay: CalendarDayWhereUniqueInput;
  data: UpdateCalendarDayInput;
};


export type MutationMoveResourceArgs = {
  driveId: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationNewBotConversationArgs = {
  data: NewBotConversationInput;
};


export type MutationNewBotConversationEntryArgs = {
  data: NewConversationEntryInput;
};


export type MutationPermanentlyDeleteResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationPopulateAlternateDaySchedulesArgs = {
  alternateSchedule: AlternateScheduleWhereUniqueInput;
  data: Array<CreateAlternateScheduleInput>;
};


export type MutationPopulateBlockSchedulesArgs = {
  block: BlockWhereUniqueInput;
  data: Array<CreateBlockScheduleInput>;
};


export type MutationPopulateCalendarSchedulesArgs = {
  data: Array<CreateCalendarScheduleInput>;
  section: SectionV2WhereUniqueInput;
  session: SessionWhereUniqueInput;
};


export type MutationPopulateRotationDaysArgs = {
  data: Array<CreateRotationDayInput>;
  rotationSchedule: RotationScheduleWhereUniqueInput;
};


export type MutationPublishResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationReferAFriendArgs = {
  referralInput: ReferralInput;
};


export type MutationReferralLinkSignUpArgs = {
  referralLinkSignUpInput: ReferralLinkSignUpInput;
};


export type MutationReferralSignupCompletedArgs = {
  product: Scalars['String']['input'];
  referralCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRegenerateBotConversationEntryArgs = {
  data: RegenerateConversationEntryInput;
};


export type MutationReinitializeRotationDayPreviewArgs = {
  calendarDay: CalendarDayWhereUniqueInput;
  rotationDay: RotationDayWhereUniqueInput;
};


export type MutationResendVerificationEmailArgs = {
  userId: Scalars['String']['input'];
};


export type MutationResetPasswordWithEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResourceGeneratorEditArgs = {
  where: AiResourceGeneratorEditInput;
};


export type MutationRestoreAiToolArgs = {
  where: AiToolWhereUniqueInput;
};


export type MutationRestoreBotConversationArgs = {
  where: BotConversationWhereUniqueInput;
};


export type MutationRestoreResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRetrySlideCreationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeTokenForUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSendOnboardingInviteArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSendReferralEmailInvitesArgs = {
  referralEmailInviteArgs: ReferralEmailInvitesArgs;
};


export type MutationSetFirstAndLastDayEventsArgs = {
  data: FirstLastDaysInput;
};


export type MutationSetNewPasswordArgs = {
  passwordInput: PasswordInput;
};


export type MutationSignUpAlaynaPortalArgs = {
  credentials: Credentials;
};


export type MutationSignUpWithEmailArgs = {
  credentials: Credentials;
};


export type MutationSignUpWithEmailForAiArgs = {
  credentials: Credentials;
};


export type MutationSkipInitToolArgs = {
  data: InitToolInput;
};


export type MutationSubscribeToNewsletterArgs = {
  newsletterArgs: NewsLetterArgs;
};


export type MutationTemplatizeResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationTrackWeeklyReportClickArgs = {
  destination: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUnmarkAiToolCompleteArgs = {
  where: AiToolWhereUniqueInput;
};


export type MutationUnmarkBotConversationCompleteArgs = {
  where: BotConversationWhereUniqueInput;
};


export type MutationUnpublishResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnsubscribeFromWeeklyReportsArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUpdateAiFavoriteArgs = {
  data: AiFavoriteUpdateInput;
  where: AiFavoriteWhereUniqueInput;
};


export type MutationUpdateAiFeedbackArgs = {
  data: AiFeedbackUpdateInput;
  where: AiFeedbackWhereUniqueInput;
};


export type MutationUpdateAiToolArgs = {
  data: AiToolUpdateInput;
  where: AiToolWhereUniqueInput;
};


export type MutationUpdateAiToolParticipantArgs = {
  data: AiToolParticipantUpdateInput;
  where: AiToolParticipantWhereUniqueInput;
};


export type MutationUpdateAiToolStepArgs = {
  data: AiToolStepUpdateInput;
  where: AiToolStepWhereUniqueInput;
};


export type MutationUpdateAlternateScheduleArgs = {
  data: AlternateScheduleUpdateInput;
  where: AlternateScheduleWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateAuditLogArgs = {
  data: AuditLogUpdateInput;
  where: AuditLogWhereUniqueInput;
};


export type MutationUpdateBlockArgs = {
  data: BlockUpdateInput;
  where: BlockWhereUniqueInput;
};


export type MutationUpdateBlockScheduleArgs = {
  data: BlockScheduleUpdateInput;
  where: BlockScheduleWhereUniqueInput;
};


export type MutationUpdateBotConversationArgs = {
  data: BotConversationUpdateInput;
  where: BotConversationWhereUniqueInput;
};


export type MutationUpdateBotConversationEntryArgs = {
  data: BotConversationEntryUpdateInput;
  where: BotConversationEntryWhereUniqueInput;
};


export type MutationUpdateBotConversationParticipantArgs = {
  data: BotConversationParticipantUpdateInput;
  where: BotConversationParticipantWhereUniqueInput;
};


export type MutationUpdateCalendarArgs = {
  data: CalendarUpdateInput;
  where: CalendarWhereUniqueInput;
};


export type MutationUpdateCalendarDayArgs = {
  data: CalendarDayUpdateInput;
  where: CalendarDayWhereUniqueInput;
};


export type MutationUpdateCalendarEntryArgs = {
  data: CalendarEntryUpdateInput;
  where: CalendarEntryWhereUniqueInput;
};


export type MutationUpdateCalendarScheduleArgs = {
  data: CalendarScheduleUpdateInput;
  where: CalendarScheduleWhereUniqueInput;
};


export type MutationUpdateClassV2Args = {
  data: ClassV2UpdateInput;
  where: ClassV2WhereUniqueInput;
};


export type MutationUpdateCourseArgs = {
  data: CourseUpdateInput;
  where: CourseWhereUniqueInput;
};


export type MutationUpdateCourseV2Args = {
  data: CourseV2UpdateInput;
  where: CourseV2WhereUniqueInput;
};


export type MutationUpdateDepartmentArgs = {
  data: DepartmentUpdateInput;
  where: DepartmentWhereUniqueInput;
};


export type MutationUpdateDistrictArgs = {
  data: DistrictUpdateInput;
  where: DistrictWhereUniqueInput;
};


export type MutationUpdateDriveArgs = {
  data: DriveUpdateInput;
  where: DriveWhereUniqueInput;
};


export type MutationUpdateEdlinkIntegrationArgs = {
  data: EdlinkIntegrationUpdateInput;
  where: EdlinkIntegrationWhereUniqueInput;
};


export type MutationUpdateEdlinkLogArgs = {
  data: EdlinkLogUpdateInput;
  where: EdlinkLogWhereUniqueInput;
};


export type MutationUpdateEdlinkProviderArgs = {
  data: EdlinkProviderUpdateInput;
  where: EdlinkProviderWhereUniqueInput;
};


export type MutationUpdateEdlinkSourceArgs = {
  data: EdlinkSourceUpdateInput;
  where: EdlinkSourceWhereUniqueInput;
};


export type MutationUpdateEnrollmentArgs = {
  data: EnrollmentUpdateInput;
  where: EnrollmentWhereUniqueInput;
};


export type MutationUpdateEventArgs = {
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
};


export type MutationUpdateFavoriteArgs = {
  data: FavoriteUpdateInput;
  where: FavoriteWhereUniqueInput;
};


export type MutationUpdateInviteArgs = {
  data: InviteUpdateInput;
  where: InviteWhereUniqueInput;
};


export type MutationUpdatePasswordArgs = {
  credentials: UpdatePasswordCredentials;
};


export type MutationUpdatePeriodArgs = {
  data: PeriodUpdateInput;
  where: PeriodWhereUniqueInput;
};


export type MutationUpdatePermissionArgs = {
  data: PermissionUpdateInput;
  where: PermissionWhereUniqueInput;
};


export type MutationUpdatePlannerArgs = {
  data: PlannerUpdateInput;
  where: PlannerWhereUniqueInput;
};


export type MutationUpdatePlannerDateArgs = {
  data: PlannerDateUpdateInput;
  where: PlannerDateWhereUniqueInput;
};


export type MutationUpdatePlannerRevisionArgs = {
  data: PlannerRevisionUpdateInput;
  where: PlannerRevisionWhereUniqueInput;
};


export type MutationUpdateReferralArgs = {
  data: ReferralUpdateInput;
  where: ReferralWhereUniqueInput;
};


export type MutationUpdateReferralRewardArgs = {
  data: ReferralRewardUpdateInput;
  where: ReferralRewardWhereUniqueInput;
};


export type MutationUpdateResourceArgs = {
  data: ResourceUpdateInput;
  where: ResourceWhereUniqueInput;
};


export type MutationUpdateResourceAttributesArgs = {
  data: ResourceAttributesInput;
  where: ResourceWhereUniqueInput;
};


export type MutationUpdateResourceScheduleArgs = {
  data: ResourceScheduleUpdateInput;
  where: ResourceScheduleWhereUniqueInput;
};


export type MutationUpdateRotationDayArgs = {
  data: RotationDayUpdateInput;
  where: RotationDayWhereUniqueInput;
};


export type MutationUpdateRotationScheduleArgs = {
  data: RotationScheduleUpdateInput;
  where: RotationScheduleWhereUniqueInput;
};


export type MutationUpdateScheduleArgs = {
  data: ScheduleUpdateInput;
  where: ScheduleWhereUniqueInput;
};


export type MutationUpdateSchoolArgs = {
  data: SchoolUpdateInput;
  where: SchoolWhereUniqueInput;
};


export type MutationUpdateSectionArgs = {
  data: SectionUpdateInput;
  where: SectionWhereUniqueInput;
};


export type MutationUpdateSectionV2Args = {
  data: SectionV2UpdateInput;
  where: SectionV2WhereUniqueInput;
};


export type MutationUpdateSessionArgs = {
  data: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};


export type MutationUpdateSlideArgs = {
  data: SlideUpdateInput;
  where: SlideWhereUniqueInput;
};


export type MutationUpdateSubjectArgs = {
  data: SubjectUpdateInput;
  where: SubjectWhereUniqueInput;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserDetailsArgs = {
  userDetailsInput: UserDetailsInput;
};


export type MutationUpdateUserDistrictRoleArgs = {
  updateUserDistrictRoleInput: UpdateUserDistrictRoleInput;
};


export type MutationUpdateVersionArgs = {
  data: VersionUpdateInput;
  where: VersionWhereUniqueInput;
};


export type MutationUpdateWithImportArgs = {
  args: ResourceAttributesInput;
  id: Scalars['String']['input'];
  importId: Scalars['String']['input'];
};


export type MutationUpdateWithTemplateArgs = {
  id: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationUpgradeSubscriptionArgs = {
  input: StripeCheckoutInput;
};


export type MutationUtilizeImportArgs = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  sectionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUtilizeTemplateArgs = {
  courseId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  sectionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyEmailArgs = {
  userId: Scalars['String']['input'];
};

export type NewBotConversationInput = {
  entry: Scalars['JSON']['input'];
  user: UserWhereUniqueInput;
};

export type NewConversationEntryInput = {
  conversation: BotConversationWhereUniqueInput;
  entry: Scalars['JSON']['input'];
  user: UserWhereUniqueInput;
};

export type NewsLetterArgs = {
  email: Scalars['String']['input'];
};

export type OnboardingInput = {
  avatarUrl: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  discoveryChannel?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  focusAreas: Array<Scalars['String']['input']>;
  gradeLevel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  userDistrictRoles: Array<EnumUserDistrictRoles>;
};

export type OneDriveAttachmentInput = {
  feature: EnumFeaturePreset;
  fileId?: InputMaybe<Scalars['String']['input']>;
  processingOptions?: InputMaybe<ProcessingOptionsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OneDriveInput = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordInput = {
  currentPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type Period = {
  __typename?: 'Period';
  course?: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  end: Scalars['String']['output'];
  id: Scalars['String']['output'];
  schedule?: Maybe<Schedule>;
  section?: Maybe<Section>;
  start: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PeriodCreateInput = {
  course: CourseWhereUniqueInput;
  end: Scalars['String']['input'];
  schedule: ScheduleWhereUniqueInput;
  section: SectionWhereUniqueInput;
  start: Scalars['String']['input'];
};

export type PeriodCreateNestedManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
};

export type PeriodCreateNestedManyWithoutSchedulesInput = {
  connect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
};

export type PeriodCreateNestedManyWithoutSectionsInput = {
  connect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
};

export type PeriodListRelationFilter = {
  every?: InputMaybe<PeriodWhereInput>;
  none?: InputMaybe<PeriodWhereInput>;
  some?: InputMaybe<PeriodWhereInput>;
};

export type PeriodOrderByInput = {
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  end?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  scheduleId?: InputMaybe<SortOrder>;
  sectionId?: InputMaybe<SortOrder>;
  start?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PeriodUpdateInput = {
  course?: InputMaybe<CourseWhereUniqueInput>;
  end?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ScheduleWhereUniqueInput>;
  section?: InputMaybe<SectionWhereUniqueInput>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type PeriodUpdateManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
  set?: InputMaybe<Array<PeriodWhereUniqueInput>>;
};

export type PeriodUpdateManyWithoutSchedulesInput = {
  connect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
  set?: InputMaybe<Array<PeriodWhereUniqueInput>>;
};

export type PeriodUpdateManyWithoutSectionsInput = {
  connect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PeriodWhereUniqueInput>>;
  set?: InputMaybe<Array<PeriodWhereUniqueInput>>;
};

export type PeriodWhereInput = {
  course?: InputMaybe<CourseWhereUniqueInput>;
  end?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  schedule?: InputMaybe<ScheduleWhereUniqueInput>;
  section?: InputMaybe<SectionWhereUniqueInput>;
  start?: InputMaybe<StringFilter>;
};

export type PeriodWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Permission = {
  __typename?: 'Permission';
  createdAt: Scalars['DateTime']['output'];
  drive?: Maybe<Drive>;
  id: Scalars['String']['output'];
  permissionType?: Maybe<EnumPermissionPermissionType>;
  resource?: Maybe<Resource>;
  role?: Maybe<EnumPermissionRole>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type PermissionCreateInput = {
  drive?: InputMaybe<DriveWhereUniqueInput>;
  permissionType: EnumPermissionPermissionType;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
  role: EnumPermissionRole;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type PermissionCreateNestedManyWithoutDrivesInput = {
  connect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
};

export type PermissionCreateNestedManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
};

export type PermissionCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
};

export type PermissionListRelationFilter = {
  every?: InputMaybe<PermissionWhereInput>;
  none?: InputMaybe<PermissionWhereInput>;
  some?: InputMaybe<PermissionWhereInput>;
};

export type PermissionOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  driveId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  permissionType?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type PermissionUpdateInput = {
  drive?: InputMaybe<DriveWhereUniqueInput>;
  permissionType?: InputMaybe<EnumPermissionPermissionType>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
  role?: InputMaybe<EnumPermissionRole>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type PermissionUpdateManyWithoutDrivesInput = {
  connect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<PermissionWhereUniqueInput>>;
};

export type PermissionUpdateManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<PermissionWhereUniqueInput>>;
};

export type PermissionUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<PermissionWhereUniqueInput>>;
};

export type PermissionWhereInput = {
  drive?: InputMaybe<DriveWhereUniqueInput>;
  id?: InputMaybe<StringFilter>;
  permissionType?: InputMaybe<EnumPermissionPermissionType>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
  role?: InputMaybe<EnumPermissionRole>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type PermissionWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Planner = {
  __typename?: 'Planner';
  courses: Array<Course>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isOnboarding?: Maybe<Scalars['Boolean']['output']>;
  plannerRevisions: Array<PlannerRevision>;
  resources: Array<Resource>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  user?: Maybe<User>;
  version?: Maybe<Scalars['Float']['output']>;
};


export type PlannerCoursesArgs = {
  orderBy?: InputMaybe<Array<CourseOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CourseWhereInput>;
};


export type PlannerPlannerRevisionsArgs = {
  orderBy?: InputMaybe<Array<PlannerRevisionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PlannerRevisionWhereInput>;
};


export type PlannerResourcesArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};

export type PlannerCreateInput = {
  courses?: InputMaybe<CourseCreateNestedManyWithoutPlannersInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  plannerRevisions?: InputMaybe<PlannerRevisionCreateNestedManyWithoutPlannersInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutPlannersInput>;
  urlId: Scalars['String']['input'];
  user: UserWhereUniqueInput;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type PlannerCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<PlannerWhereUniqueInput>>;
};

export type PlannerDate = {
  __typename?: 'PlannerDate';
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  planner?: Maybe<PlannerRevision>;
  rotationDay?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlannerDateCreateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  planner: PlannerRevisionWhereUniqueInput;
  rotationDay?: InputMaybe<Scalars['Float']['input']>;
};

export type PlannerDateCreateNestedManyWithoutPlannerRevisionsInput = {
  connect?: InputMaybe<Array<PlannerDateWhereUniqueInput>>;
};

export type PlannerDateListRelationFilter = {
  every?: InputMaybe<PlannerDateWhereInput>;
  none?: InputMaybe<PlannerDateWhereInput>;
  some?: InputMaybe<PlannerDateWhereInput>;
};

export type PlannerDateOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  plannerId?: InputMaybe<SortOrder>;
  rotationDay?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PlannerDateUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
  rotationDay?: InputMaybe<Scalars['Float']['input']>;
};

export type PlannerDateUpdateManyWithoutPlannerRevisionsInput = {
  connect?: InputMaybe<Array<PlannerDateWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PlannerDateWhereUniqueInput>>;
  set?: InputMaybe<Array<PlannerDateWhereUniqueInput>>;
};

export type PlannerDateWhereInput = {
  date?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
  rotationDay?: InputMaybe<IntNullableFilter>;
};

export type PlannerDateWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type PlannerListRelationFilter = {
  every?: InputMaybe<PlannerWhereInput>;
  none?: InputMaybe<PlannerWhereInput>;
  some?: InputMaybe<PlannerWhereInput>;
};

export type PlannerOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isOnboarding?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export type PlannerRevision = {
  __typename?: 'PlannerRevision';
  calendars: Array<Calendar>;
  createdAt: Scalars['DateTime']['output'];
  daysOfWeek?: Maybe<Array<EnumPlannerRevisionDaysOfWeek>>;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  planner?: Maybe<Planner>;
  plannerDates: Array<PlannerDate>;
  rotationNumber?: Maybe<Scalars['Float']['output']>;
  rotationSchedules: Array<RotationSchedule>;
  scheduleType?: Maybe<EnumPlannerRevisionScheduleType>;
  schedules: Array<Schedule>;
  startDate: Scalars['DateTime']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PlannerRevisionCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type PlannerRevisionPlannerDatesArgs = {
  orderBy?: InputMaybe<Array<PlannerDateOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PlannerDateWhereInput>;
};


export type PlannerRevisionRotationSchedulesArgs = {
  orderBy?: InputMaybe<Array<RotationScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<RotationScheduleWhereInput>;
};


export type PlannerRevisionSchedulesArgs = {
  orderBy?: InputMaybe<Array<ScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ScheduleWhereInput>;
};

export type PlannerRevisionCreateInput = {
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutPlannerRevisionsInput>;
  daysOfWeek?: InputMaybe<Array<EnumPlannerRevisionDaysOfWeek>>;
  endDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  planner: PlannerWhereUniqueInput;
  plannerDates?: InputMaybe<PlannerDateCreateNestedManyWithoutPlannerRevisionsInput>;
  rotationNumber?: InputMaybe<Scalars['Float']['input']>;
  rotationSchedules?: InputMaybe<RotationScheduleCreateNestedManyWithoutPlannerRevisionsInput>;
  scheduleType: EnumPlannerRevisionScheduleType;
  schedules?: InputMaybe<ScheduleCreateNestedManyWithoutPlannerRevisionsInput>;
  startDate: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PlannerRevisionCreateNestedManyWithoutPlannersInput = {
  connect?: InputMaybe<Array<PlannerRevisionWhereUniqueInput>>;
};

export type PlannerRevisionListRelationFilter = {
  every?: InputMaybe<PlannerRevisionWhereInput>;
  none?: InputMaybe<PlannerRevisionWhereInput>;
  some?: InputMaybe<PlannerRevisionWhereInput>;
};

export type PlannerRevisionOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  daysOfWeek?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  plannerId?: InputMaybe<SortOrder>;
  rotationNumber?: InputMaybe<SortOrder>;
  scheduleType?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PlannerRevisionUpdateInput = {
  calendars?: InputMaybe<CalendarUpdateManyWithoutPlannerRevisionsInput>;
  daysOfWeek?: InputMaybe<Array<EnumPlannerRevisionDaysOfWeek>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planner?: InputMaybe<PlannerWhereUniqueInput>;
  plannerDates?: InputMaybe<PlannerDateUpdateManyWithoutPlannerRevisionsInput>;
  rotationNumber?: InputMaybe<Scalars['Float']['input']>;
  rotationSchedules?: InputMaybe<RotationScheduleUpdateManyWithoutPlannerRevisionsInput>;
  scheduleType?: InputMaybe<EnumPlannerRevisionScheduleType>;
  schedules?: InputMaybe<ScheduleUpdateManyWithoutPlannerRevisionsInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PlannerRevisionUpdateManyWithoutPlannersInput = {
  connect?: InputMaybe<Array<PlannerRevisionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PlannerRevisionWhereUniqueInput>>;
  set?: InputMaybe<Array<PlannerRevisionWhereUniqueInput>>;
};

export type PlannerRevisionWhereInput = {
  calendars?: InputMaybe<CalendarListRelationFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  planner?: InputMaybe<PlannerWhereUniqueInput>;
  plannerDates?: InputMaybe<PlannerDateListRelationFilter>;
  rotationNumber?: InputMaybe<IntNullableFilter>;
  rotationSchedules?: InputMaybe<RotationScheduleListRelationFilter>;
  scheduleType?: InputMaybe<EnumPlannerRevisionScheduleType>;
  schedules?: InputMaybe<ScheduleListRelationFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
};

export type PlannerRevisionWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type PlannerUpdateInput = {
  courses?: InputMaybe<CourseUpdateManyWithoutPlannersInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  plannerRevisions?: InputMaybe<PlannerRevisionUpdateManyWithoutPlannersInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutPlannersInput>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type PlannerUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<PlannerWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<PlannerWhereUniqueInput>>;
  set?: InputMaybe<Array<PlannerWhereUniqueInput>>;
};

export type PlannerWhereInput = {
  courses?: InputMaybe<CourseListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isOnboarding?: InputMaybe<BooleanNullableFilter>;
  plannerRevisions?: InputMaybe<PlannerRevisionListRelationFilter>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  urlId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
  version?: InputMaybe<FloatNullableFilter>;
};

export type PlannerWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type ProcessingOptionsInput = {
  hasHandwriting?: InputMaybe<Scalars['Boolean']['input']>;
  processImages?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  _aiFavoritesMeta: MetaQueryPayload;
  _aiFeedbacksMeta: MetaQueryPayload;
  _aiToolParticipantsMeta: MetaQueryPayload;
  _aiToolStepsMeta: MetaQueryPayload;
  _aiToolsMeta: MetaQueryPayload;
  _alternateSchedulesMeta: MetaQueryPayload;
  _assetsMeta: MetaQueryPayload;
  _auditLogsMeta: MetaQueryPayload;
  _blockSchedulesMeta: MetaQueryPayload;
  _blocksMeta: MetaQueryPayload;
  _botConversationEntriesMeta: MetaQueryPayload;
  _botConversationParticipantsMeta: MetaQueryPayload;
  _botConversationsMeta: MetaQueryPayload;
  _calendarDaysMeta: MetaQueryPayload;
  _calendarEntriesMeta: MetaQueryPayload;
  _calendarSchedulesMeta: MetaQueryPayload;
  _calendarsMeta: MetaQueryPayload;
  _classV2sMeta: MetaQueryPayload;
  _courseV2sMeta: MetaQueryPayload;
  _coursesMeta: MetaQueryPayload;
  _curriculumToolsParticipantsMeta: MetaQueryPayload;
  _departmentsMeta: MetaQueryPayload;
  _districtsMeta: MetaQueryPayload;
  _drivesMeta: MetaQueryPayload;
  _edlinkIntegrationsMeta: MetaQueryPayload;
  _edlinkLogsMeta: MetaQueryPayload;
  _edlinkProvidersMeta: MetaQueryPayload;
  _edlinkSourcesMeta: MetaQueryPayload;
  _enrollmentsMeta: MetaQueryPayload;
  _eventsMeta: MetaQueryPayload;
  _favoritesMeta: MetaQueryPayload;
  _imageGeneratorParticipantsMeta: MetaQueryPayload;
  _invitesMeta: MetaQueryPayload;
  _periodsMeta: MetaQueryPayload;
  _permissionsMeta: MetaQueryPayload;
  _plannerDatesMeta: MetaQueryPayload;
  _plannerRevisionsMeta: MetaQueryPayload;
  _plannersMeta: MetaQueryPayload;
  _referralRewardsMeta: MetaQueryPayload;
  _referralsMeta: MetaQueryPayload;
  _resourceGeneratorParticipantsMeta: MetaQueryPayload;
  _resourceSchedulesMeta: MetaQueryPayload;
  _resourcesMeta: MetaQueryPayload;
  _rotationDaysMeta: MetaQueryPayload;
  _rotationSchedulesMeta: MetaQueryPayload;
  _schedulesMeta: MetaQueryPayload;
  _schoolsMeta: MetaQueryPayload;
  _sectionV2sMeta: MetaQueryPayload;
  _sectionsMeta: MetaQueryPayload;
  _sessionsMeta: MetaQueryPayload;
  _slidesMeta: MetaQueryPayload;
  _subjectsMeta: MetaQueryPayload;
  _usersMeta: MetaQueryPayload;
  _versionsMeta: MetaQueryPayload;
  aiFavorite?: Maybe<AiFavorite>;
  aiFavorites: Array<AiFavorite>;
  aiFeedback?: Maybe<AiFeedback>;
  aiFeedbacks: Array<AiFeedback>;
  aiTool?: Maybe<AiTool>;
  aiToolByUrlId?: Maybe<AiTool>;
  aiToolParticipant?: Maybe<AiToolParticipant>;
  aiToolParticipants: Array<AiToolParticipant>;
  aiToolStep?: Maybe<AiToolStep>;
  aiToolSteps: Array<AiToolStep>;
  aiTools: Array<AiTool>;
  alternateSchedule?: Maybe<AlternateSchedule>;
  alternateSchedules: Array<AlternateSchedule>;
  asset?: Maybe<Asset>;
  assets: Array<Asset>;
  auditLog?: Maybe<AuditLog>;
  auditLogs: Array<AuditLog>;
  auditLogsForLimits: Array<AuditLog>;
  block?: Maybe<Block>;
  blockSchedule?: Maybe<BlockSchedule>;
  blockSchedules: Array<BlockSchedule>;
  blocks: Array<Block>;
  botConversation?: Maybe<BotConversation>;
  botConversationByUrlId?: Maybe<BotConversation>;
  botConversationEntries: Array<BotConversationEntry>;
  botConversationEntry?: Maybe<BotConversationEntry>;
  botConversationParticipant?: Maybe<BotConversationParticipant>;
  botConversationParticipants: Array<BotConversationParticipant>;
  botConversations: Array<BotConversation>;
  calendar?: Maybe<Calendar>;
  calendarByUrlId?: Maybe<Calendar>;
  calendarDay?: Maybe<CalendarDay>;
  calendarDays: Array<CalendarDay>;
  calendarEntries: Array<CalendarEntry>;
  calendarEntry?: Maybe<CalendarEntry>;
  calendarSchedule?: Maybe<CalendarSchedule>;
  calendarSchedules: Array<CalendarSchedule>;
  calendars: Array<Calendar>;
  checkEnterpriseOboardingValidity: Scalars['Boolean']['output'];
  checkUpdatePasswordPageValidity: Scalars['Boolean']['output'];
  classV2?: Maybe<ClassV2>;
  classV2s: Array<ClassV2>;
  course?: Maybe<Course>;
  courseV2?: Maybe<CourseV2>;
  courseV2s: Array<CourseV2>;
  courses: Array<Course>;
  curriculumToolsParticipants: Array<AiToolParticipant>;
  department?: Maybe<Department>;
  departments: Array<Department>;
  district?: Maybe<District>;
  districts: Array<District>;
  drive?: Maybe<Drive>;
  drives: Array<Drive>;
  edlinkIntegration?: Maybe<EdlinkIntegration>;
  edlinkIntegrations: Array<EdlinkIntegration>;
  edlinkLog?: Maybe<EdlinkLog>;
  edlinkLogs: Array<EdlinkLog>;
  edlinkProvider?: Maybe<EdlinkProvider>;
  edlinkProviders: Array<EdlinkProvider>;
  edlinkSource?: Maybe<EdlinkSource>;
  edlinkSources: Array<EdlinkSource>;
  enrollment?: Maybe<Enrollment>;
  enrollments: Array<Enrollment>;
  event?: Maybe<Event>;
  events: Array<Event>;
  favorite?: Maybe<Favorite>;
  favorites: Array<Favorite>;
  getBotConversationHistory: Array<BotConversation>;
  getBotConversationHistoryCount: MetaQueryPayload;
  getChatByUrlId: BotConversation;
  getCourseSectionDates: CourseDatesList;
  getGeneratedSlides: SlideOutline;
  getOneDrive: Scalars['String']['output'];
  getRecentActivityItems: RecentActivityItemsResponse;
  getReferralInfo: ReferralInfo;
  getReferralLink: Scalars['String']['output'];
  getResourceFromToolStep: ResourceFromToolStepResponse;
  getSlideCounts: SlideCounts;
  getSlideCreationCounts: Scalars['Float']['output'];
  getSlideEditCounts: Scalars['Float']['output'];
  getStripeCustomerManagementURL: Scalars['String']['output'];
  getUser: UserObject;
  getUserByEmail?: Maybe<User>;
  imageGeneratorParticipants: Array<AiToolParticipant>;
  invite?: Maybe<Invite>;
  invites: Array<Invite>;
  invitesForEmail: Array<Invite>;
  period?: Maybe<Period>;
  periods: Array<Period>;
  permission?: Maybe<Permission>;
  permissions: Array<Permission>;
  planner?: Maybe<Planner>;
  plannerDate?: Maybe<PlannerDate>;
  plannerDates: Array<PlannerDate>;
  plannerRevision?: Maybe<PlannerRevision>;
  plannerRevisions: Array<PlannerRevision>;
  planners: Array<Planner>;
  pollCreateSlidesProgress: SlideProgressUpdate;
  processOneDriveAttachment: Asset;
  referral?: Maybe<Referral>;
  referralReward?: Maybe<ReferralReward>;
  referralRewards: Array<ReferralReward>;
  referrals: Array<Referral>;
  resource?: Maybe<Resource>;
  resourceByUrlId?: Maybe<Resource>;
  resourceGeneratorParticipants: Array<AiToolParticipant>;
  resourceSchedule?: Maybe<ResourceSchedule>;
  resourceSchedules: Array<ResourceSchedule>;
  resources: Array<Resource>;
  rotationDay?: Maybe<RotationDay>;
  rotationDays: Array<RotationDay>;
  rotationSchedule?: Maybe<RotationSchedule>;
  rotationSchedules: Array<RotationSchedule>;
  schedule?: Maybe<Schedule>;
  schedules: Array<Schedule>;
  school?: Maybe<School>;
  schools: Array<School>;
  section?: Maybe<Section>;
  sectionV2?: Maybe<SectionV2>;
  sectionV2s: Array<SectionV2>;
  sections: Array<Section>;
  session?: Maybe<Session>;
  sessions: Array<Session>;
  sharedResource?: Maybe<Resource>;
  sharedResources: Array<Resource>;
  slide?: Maybe<Slide>;
  slides: Array<Slide>;
  subject?: Maybe<Subject>;
  subjects: Array<Subject>;
  user?: Maybe<User>;
  users: Array<User>;
  verifyEmailHash: VerifyHashResponse;
  version?: Maybe<Version>;
  versions: Array<Version>;
};


export type Query_AiFavoritesMetaArgs = {
  where?: InputMaybe<AiFavoriteWhereInput>;
};


export type Query_AiFeedbacksMetaArgs = {
  where?: InputMaybe<AiFeedbackWhereInput>;
};


export type Query_AiToolParticipantsMetaArgs = {
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type Query_AiToolStepsMetaArgs = {
  where?: InputMaybe<AiToolStepWhereInput>;
};


export type Query_AiToolsMetaArgs = {
  where?: InputMaybe<AiToolWhereInput>;
};


export type Query_AlternateSchedulesMetaArgs = {
  where?: InputMaybe<AlternateScheduleWhereInput>;
};


export type Query_AssetsMetaArgs = {
  where?: InputMaybe<AssetWhereInput>;
};


export type Query_AuditLogsMetaArgs = {
  where?: InputMaybe<AuditLogWhereInput>;
};


export type Query_BlockSchedulesMetaArgs = {
  where?: InputMaybe<BlockScheduleWhereInput>;
};


export type Query_BlocksMetaArgs = {
  where?: InputMaybe<BlockWhereInput>;
};


export type Query_BotConversationEntriesMetaArgs = {
  where?: InputMaybe<BotConversationEntryWhereInput>;
};


export type Query_BotConversationParticipantsMetaArgs = {
  where?: InputMaybe<BotConversationParticipantWhereInput>;
};


export type Query_BotConversationsMetaArgs = {
  where?: InputMaybe<BotConversationWhereInput>;
};


export type Query_CalendarDaysMetaArgs = {
  where?: InputMaybe<CalendarDayWhereInput>;
};


export type Query_CalendarEntriesMetaArgs = {
  where?: InputMaybe<CalendarEntryWhereInput>;
};


export type Query_CalendarSchedulesMetaArgs = {
  where?: InputMaybe<CalendarScheduleWhereInput>;
};


export type Query_CalendarsMetaArgs = {
  where?: InputMaybe<CalendarWhereInput>;
};


export type Query_ClassV2sMetaArgs = {
  where?: InputMaybe<ClassV2WhereInput>;
};


export type Query_CourseV2sMetaArgs = {
  where?: InputMaybe<CourseV2WhereInput>;
};


export type Query_CoursesMetaArgs = {
  where?: InputMaybe<CourseWhereInput>;
};


export type Query_CurriculumToolsParticipantsMetaArgs = {
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type Query_DepartmentsMetaArgs = {
  where?: InputMaybe<DepartmentWhereInput>;
};


export type Query_DistrictsMetaArgs = {
  where?: InputMaybe<DistrictWhereInput>;
};


export type Query_DrivesMetaArgs = {
  where?: InputMaybe<DriveWhereInput>;
};


export type Query_EdlinkIntegrationsMetaArgs = {
  where?: InputMaybe<EdlinkIntegrationWhereInput>;
};


export type Query_EdlinkLogsMetaArgs = {
  where?: InputMaybe<EdlinkLogWhereInput>;
};


export type Query_EdlinkProvidersMetaArgs = {
  where?: InputMaybe<EdlinkProviderWhereInput>;
};


export type Query_EdlinkSourcesMetaArgs = {
  where?: InputMaybe<EdlinkSourceWhereInput>;
};


export type Query_EnrollmentsMetaArgs = {
  where?: InputMaybe<EnrollmentWhereInput>;
};


export type Query_EventsMetaArgs = {
  where?: InputMaybe<EventWhereInput>;
};


export type Query_FavoritesMetaArgs = {
  orderBy?: InputMaybe<Array<FavoriteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<FavoriteWhereInput>;
};


export type Query_ImageGeneratorParticipantsMetaArgs = {
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type Query_InvitesMetaArgs = {
  where?: InputMaybe<InviteWhereInput>;
};


export type Query_PeriodsMetaArgs = {
  orderBy?: InputMaybe<Array<PeriodOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PeriodWhereInput>;
};


export type Query_PermissionsMetaArgs = {
  where?: InputMaybe<PermissionWhereInput>;
};


export type Query_PlannerDatesMetaArgs = {
  orderBy?: InputMaybe<Array<PlannerDateOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PlannerDateWhereInput>;
};


export type Query_PlannerRevisionsMetaArgs = {
  where?: InputMaybe<PlannerRevisionWhereInput>;
};


export type Query_PlannersMetaArgs = {
  where?: InputMaybe<PlannerWhereInput>;
};


export type Query_ReferralRewardsMetaArgs = {
  where?: InputMaybe<ReferralRewardWhereInput>;
};


export type Query_ReferralsMetaArgs = {
  where?: InputMaybe<ReferralWhereInput>;
};


export type Query_ResourceGeneratorParticipantsMetaArgs = {
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type Query_ResourceSchedulesMetaArgs = {
  where?: InputMaybe<ResourceScheduleWhereInput>;
};


export type Query_ResourcesMetaArgs = {
  where?: InputMaybe<ResourceWhereInput>;
};


export type Query_RotationDaysMetaArgs = {
  where?: InputMaybe<RotationDayWhereInput>;
};


export type Query_RotationSchedulesMetaArgs = {
  where?: InputMaybe<RotationScheduleWhereInput>;
};


export type Query_SchedulesMetaArgs = {
  orderBy?: InputMaybe<Array<ScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ScheduleWhereInput>;
};


export type Query_SchoolsMetaArgs = {
  where?: InputMaybe<SchoolWhereInput>;
};


export type Query_SectionV2sMetaArgs = {
  where?: InputMaybe<SectionV2WhereInput>;
};


export type Query_SectionsMetaArgs = {
  where?: InputMaybe<SectionWhereInput>;
};


export type Query_SessionsMetaArgs = {
  where?: InputMaybe<SessionWhereInput>;
};


export type Query_SlidesMetaArgs = {
  where?: InputMaybe<SlideWhereInput>;
};


export type Query_SubjectsMetaArgs = {
  where?: InputMaybe<SubjectWhereInput>;
};


export type Query_UsersMetaArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type Query_VersionsMetaArgs = {
  where?: InputMaybe<VersionWhereInput>;
};


export type QueryAiFavoriteArgs = {
  where: AiFavoriteWhereUniqueInput;
};


export type QueryAiFavoritesArgs = {
  orderBy?: InputMaybe<Array<AiFavoriteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiFavoriteWhereInput>;
};


export type QueryAiFeedbackArgs = {
  where: AiFeedbackWhereUniqueInput;
};


export type QueryAiFeedbacksArgs = {
  orderBy?: InputMaybe<Array<AiFeedbackOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiFeedbackWhereInput>;
};


export type QueryAiToolArgs = {
  where: AiToolWhereUniqueInput;
};


export type QueryAiToolByUrlIdArgs = {
  where: AiToolUrlIdInput;
};


export type QueryAiToolParticipantArgs = {
  where: AiToolParticipantWhereUniqueInput;
};


export type QueryAiToolParticipantsArgs = {
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type QueryAiToolStepArgs = {
  where: AiToolStepWhereUniqueInput;
};


export type QueryAiToolStepsArgs = {
  orderBy?: InputMaybe<Array<AiToolStepOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolStepWhereInput>;
};


export type QueryAiToolsArgs = {
  orderBy?: InputMaybe<Array<AiToolOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolWhereInput>;
};


export type QueryAlternateScheduleArgs = {
  where: AlternateScheduleWhereUniqueInput;
};


export type QueryAlternateSchedulesArgs = {
  orderBy?: InputMaybe<Array<AlternateScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AlternateScheduleWhereInput>;
};


export type QueryAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type QueryAssetsArgs = {
  orderBy?: InputMaybe<Array<AssetOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAuditLogArgs = {
  where: AuditLogWhereUniqueInput;
};


export type QueryAuditLogsArgs = {
  orderBy?: InputMaybe<Array<AuditLogOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AuditLogWhereInput>;
};


export type QueryBlockArgs = {
  where: BlockWhereUniqueInput;
};


export type QueryBlockScheduleArgs = {
  where: BlockScheduleWhereUniqueInput;
};


export type QueryBlockSchedulesArgs = {
  orderBy?: InputMaybe<Array<BlockScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BlockScheduleWhereInput>;
};


export type QueryBlocksArgs = {
  orderBy?: InputMaybe<Array<BlockOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BlockWhereInput>;
};


export type QueryBotConversationArgs = {
  where: BotConversationWhereUniqueInput;
};


export type QueryBotConversationByUrlIdArgs = {
  where: BotConversationUrlIdInput;
};


export type QueryBotConversationEntriesArgs = {
  orderBy?: InputMaybe<Array<BotConversationEntryOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BotConversationEntryWhereInput>;
};


export type QueryBotConversationEntryArgs = {
  where: BotConversationEntryWhereUniqueInput;
};


export type QueryBotConversationParticipantArgs = {
  where: BotConversationParticipantWhereUniqueInput;
};


export type QueryBotConversationParticipantsArgs = {
  orderBy?: InputMaybe<Array<BotConversationParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BotConversationParticipantWhereInput>;
};


export type QueryBotConversationsArgs = {
  orderBy?: InputMaybe<Array<BotConversationOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BotConversationWhereInput>;
};


export type QueryCalendarArgs = {
  where: CalendarWhereUniqueInput;
};


export type QueryCalendarByUrlIdArgs = {
  where: CalendarUrlIdInput;
};


export type QueryCalendarDayArgs = {
  where: CalendarDayWhereUniqueInput;
};


export type QueryCalendarDaysArgs = {
  orderBy?: InputMaybe<Array<CalendarDayOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarDayWhereInput>;
};


export type QueryCalendarEntriesArgs = {
  orderBy?: InputMaybe<Array<CalendarEntryOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarEntryWhereInput>;
};


export type QueryCalendarEntryArgs = {
  where: CalendarEntryWhereUniqueInput;
};


export type QueryCalendarScheduleArgs = {
  where: CalendarScheduleWhereUniqueInput;
};


export type QueryCalendarSchedulesArgs = {
  orderBy?: InputMaybe<Array<CalendarScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarScheduleWhereInput>;
};


export type QueryCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type QueryCheckEnterpriseOboardingValidityArgs = {
  userId: Scalars['String']['input'];
};


export type QueryCheckUpdatePasswordPageValidityArgs = {
  token: Scalars['String']['input'];
};


export type QueryClassV2Args = {
  where: ClassV2WhereUniqueInput;
};


export type QueryClassV2sArgs = {
  orderBy?: InputMaybe<Array<ClassV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ClassV2WhereInput>;
};


export type QueryCourseArgs = {
  where: CourseWhereUniqueInput;
};


export type QueryCourseV2Args = {
  where: CourseV2WhereUniqueInput;
};


export type QueryCourseV2sArgs = {
  orderBy?: InputMaybe<Array<CourseV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CourseV2WhereInput>;
};


export type QueryCoursesArgs = {
  orderBy?: InputMaybe<Array<CourseOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CourseWhereInput>;
};


export type QueryCurriculumToolsParticipantsArgs = {
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type QueryDepartmentArgs = {
  where: DepartmentWhereUniqueInput;
};


export type QueryDepartmentsArgs = {
  orderBy?: InputMaybe<Array<DepartmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DepartmentWhereInput>;
};


export type QueryDistrictArgs = {
  where: DistrictWhereUniqueInput;
};


export type QueryDistrictsArgs = {
  orderBy?: InputMaybe<Array<DistrictOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DistrictWhereInput>;
};


export type QueryDriveArgs = {
  where: DriveWhereUniqueInput;
};


export type QueryDrivesArgs = {
  orderBy?: InputMaybe<Array<DriveOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DriveWhereInput>;
};


export type QueryEdlinkIntegrationArgs = {
  where: EdlinkIntegrationWhereUniqueInput;
};


export type QueryEdlinkIntegrationsArgs = {
  orderBy?: InputMaybe<Array<EdlinkIntegrationOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkIntegrationWhereInput>;
};


export type QueryEdlinkLogArgs = {
  where: EdlinkLogWhereUniqueInput;
};


export type QueryEdlinkLogsArgs = {
  orderBy?: InputMaybe<Array<EdlinkLogOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkLogWhereInput>;
};


export type QueryEdlinkProviderArgs = {
  where: EdlinkProviderWhereUniqueInput;
};


export type QueryEdlinkProvidersArgs = {
  orderBy?: InputMaybe<Array<EdlinkProviderOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkProviderWhereInput>;
};


export type QueryEdlinkSourceArgs = {
  where: EdlinkSourceWhereUniqueInput;
};


export type QueryEdlinkSourcesArgs = {
  orderBy?: InputMaybe<Array<EdlinkSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EdlinkSourceWhereInput>;
};


export type QueryEnrollmentArgs = {
  where: EnrollmentWhereUniqueInput;
};


export type QueryEnrollmentsArgs = {
  orderBy?: InputMaybe<Array<EnrollmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EnrollmentWhereInput>;
};


export type QueryEventArgs = {
  where: EventWhereUniqueInput;
};


export type QueryEventsArgs = {
  orderBy?: InputMaybe<Array<EventOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryFavoriteArgs = {
  where: FavoriteWhereUniqueInput;
};


export type QueryFavoritesArgs = {
  orderBy?: InputMaybe<Array<FavoriteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<FavoriteWhereInput>;
};


export type QueryGetBotConversationHistoryArgs = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetChatByUrlIdArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryGetCourseSectionDatesArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetGeneratedSlidesArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetOneDriveArgs = {
  oneDriveInput: OneDriveInput;
};


export type QueryGetRecentActivityItemsArgs = {
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetReferralInfoArgs = {
  referralInfoArgs: ReferralInfoArgs;
};


export type QueryGetReferralLinkArgs = {
  product: Scalars['String']['input'];
};


export type QueryGetResourceFromToolStepArgs = {
  resourceKey: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
  toolId: Scalars['String']['input'];
  trackId: Scalars['String']['input'];
};


export type QueryGetSlideCountsArgs = {
  timezone: Scalars['String']['input'];
};


export type QueryGetSlideCreationCountsArgs = {
  timezone: Scalars['String']['input'];
};


export type QueryGetSlideEditCountsArgs = {
  timezone: Scalars['String']['input'];
};


export type QueryGetStripeCustomerManagementUrlArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetUserByEmailArgs = {
  userEmailInput: UserEmailInput;
};


export type QueryImageGeneratorParticipantsArgs = {
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type QueryInviteArgs = {
  where: InviteWhereUniqueInput;
};


export type QueryInvitesArgs = {
  orderBy?: InputMaybe<Array<InviteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<InviteWhereInput>;
};


export type QueryInvitesForEmailArgs = {
  orderBy?: InputMaybe<Array<InviteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<InviteWhereInput>;
};


export type QueryPeriodArgs = {
  where: PeriodWhereUniqueInput;
};


export type QueryPeriodsArgs = {
  orderBy?: InputMaybe<Array<PeriodOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PeriodWhereInput>;
};


export type QueryPermissionArgs = {
  where: PermissionWhereUniqueInput;
};


export type QueryPermissionsArgs = {
  orderBy?: InputMaybe<Array<PermissionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryPlannerArgs = {
  where: PlannerWhereUniqueInput;
};


export type QueryPlannerDateArgs = {
  where: PlannerDateWhereUniqueInput;
};


export type QueryPlannerDatesArgs = {
  orderBy?: InputMaybe<Array<PlannerDateOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PlannerDateWhereInput>;
};


export type QueryPlannerRevisionArgs = {
  where: PlannerRevisionWhereUniqueInput;
};


export type QueryPlannerRevisionsArgs = {
  orderBy?: InputMaybe<Array<PlannerRevisionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PlannerRevisionWhereInput>;
};


export type QueryPlannersArgs = {
  orderBy?: InputMaybe<Array<PlannerOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PlannerWhereInput>;
};


export type QueryPollCreateSlidesProgressArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryProcessOneDriveAttachmentArgs = {
  oneDriveAttachmentInput: OneDriveAttachmentInput;
};


export type QueryReferralArgs = {
  where: ReferralWhereUniqueInput;
};


export type QueryReferralRewardArgs = {
  where: ReferralRewardWhereUniqueInput;
};


export type QueryReferralRewardsArgs = {
  orderBy?: InputMaybe<Array<ReferralRewardOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ReferralRewardWhereInput>;
};


export type QueryReferralsArgs = {
  orderBy?: InputMaybe<Array<ReferralOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ReferralWhereInput>;
};


export type QueryResourceArgs = {
  where: ResourceWhereUniqueInput;
};


export type QueryResourceByUrlIdArgs = {
  where: ResourceUrlIdInput;
};


export type QueryResourceGeneratorParticipantsArgs = {
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type QueryResourceScheduleArgs = {
  where: ResourceScheduleWhereUniqueInput;
};


export type QueryResourceSchedulesArgs = {
  orderBy?: InputMaybe<Array<ResourceScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceScheduleWhereInput>;
};


export type QueryResourcesArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type QueryRotationDayArgs = {
  where: RotationDayWhereUniqueInput;
};


export type QueryRotationDaysArgs = {
  orderBy?: InputMaybe<Array<RotationDayOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<RotationDayWhereInput>;
};


export type QueryRotationScheduleArgs = {
  where: RotationScheduleWhereUniqueInput;
};


export type QueryRotationSchedulesArgs = {
  orderBy?: InputMaybe<Array<RotationScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<RotationScheduleWhereInput>;
};


export type QueryScheduleArgs = {
  where: ScheduleWhereUniqueInput;
};


export type QuerySchedulesArgs = {
  orderBy?: InputMaybe<Array<ScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ScheduleWhereInput>;
};


export type QuerySchoolArgs = {
  where: SchoolWhereUniqueInput;
};


export type QuerySchoolsArgs = {
  orderBy?: InputMaybe<Array<SchoolOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SchoolWhereInput>;
};


export type QuerySectionArgs = {
  where: SectionWhereUniqueInput;
};


export type QuerySectionV2Args = {
  where: SectionV2WhereUniqueInput;
};


export type QuerySectionV2sArgs = {
  orderBy?: InputMaybe<Array<SectionV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SectionV2WhereInput>;
};


export type QuerySectionsArgs = {
  orderBy?: InputMaybe<Array<SectionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type QuerySessionArgs = {
  where: SessionWhereUniqueInput;
};


export type QuerySessionsArgs = {
  orderBy?: InputMaybe<Array<SessionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QuerySharedResourceArgs = {
  where: ResourceUrlIdInput;
};


export type QuerySharedResourcesArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type QuerySlideArgs = {
  where: SlideWhereUniqueInput;
};


export type QuerySlidesArgs = {
  orderBy?: InputMaybe<Array<SlideOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SlideWhereInput>;
};


export type QuerySubjectArgs = {
  where: SubjectWhereUniqueInput;
};


export type QuerySubjectsArgs = {
  orderBy?: InputMaybe<Array<SubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SubjectWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<Array<UserOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVerifyEmailHashArgs = {
  emailHashInput: EmailHashInput;
};


export type QueryVersionArgs = {
  where: VersionWhereUniqueInput;
};


export type QueryVersionsArgs = {
  orderBy?: InputMaybe<Array<VersionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<VersionWhereInput>;
};

export enum QueryMode {
  Default = 'Default',
  Insensitive = 'Insensitive'
}

export type RecentActivityItem = {
  __typename?: 'RecentActivityItem';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: EnumRecentActivityItemType;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type RecentActivityItemsResponse = {
  __typename?: 'RecentActivityItemsResponse';
  hasMore: Scalars['Boolean']['output'];
  items: Array<RecentActivityItem>;
  nextCursor?: Maybe<Scalars['DateTime']['output']>;
};

export type Referral = {
  __typename?: 'Referral';
  createdAt: Scalars['DateTime']['output'];
  durationInDays: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  pendingAction?: Maybe<EnumReferralPendingAction>;
  productType: Scalars['String']['output'];
  referralRewards: Array<ReferralReward>;
  referred?: Maybe<User>;
  referrer?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ReferralReferralRewardsArgs = {
  orderBy?: InputMaybe<Array<ReferralRewardOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ReferralRewardWhereInput>;
};

export type ReferralActionsPending = {
  __typename?: 'ReferralActionsPending';
  createSlideshow: Scalars['Boolean']['output'];
  finishOnboarding: Scalars['Boolean']['output'];
  useChat: Scalars['Boolean']['output'];
};

export type ReferralCompleteActionArgs = {
  pendingAction: EnumReferralPendingAction;
};

export type ReferralCreateInput = {
  durationInDays: Scalars['Float']['input'];
  pendingAction?: InputMaybe<EnumReferralPendingAction>;
  productType: Scalars['String']['input'];
  referralRewards?: InputMaybe<ReferralRewardCreateNestedManyWithoutReferralsInput>;
  referred: UserWhereUniqueInput;
  referrer: UserWhereUniqueInput;
};

export type ReferralCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<ReferralWhereUniqueInput>>;
};

export type ReferralEmailInvitesArgs = {
  emails: Array<Scalars['String']['input']>;
  product: Scalars['String']['input'];
};

export type ReferralInfo = {
  __typename?: 'ReferralInfo';
  benefitsInDollars: Scalars['String']['output'];
  freeTrialDays: Scalars['String']['output'];
  product: Scalars['String']['output'];
  referrerName: Scalars['String']['output'];
};

export type ReferralInfoArgs = {
  product?: InputMaybe<Scalars['String']['input']>;
  referralCode: Scalars['String']['input'];
};

export type ReferralInput = {
  emails: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ReferralLinkSignUpInput = {
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  newUserId: Scalars['String']['input'];
  referredBy: Scalars['String']['input'];
};

export type ReferralListRelationFilter = {
  every?: InputMaybe<ReferralWhereInput>;
  none?: InputMaybe<ReferralWhereInput>;
  some?: InputMaybe<ReferralWhereInput>;
};

export type ReferralOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  durationInDays?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pendingAction?: InputMaybe<SortOrder>;
  productType?: InputMaybe<SortOrder>;
  referredId?: InputMaybe<SortOrder>;
  referrerId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ReferralReward = {
  __typename?: 'ReferralReward';
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  referral?: Maybe<Referral>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<EnumReferralRewardStatus>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type ReferralRewardCreateInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  productType: Scalars['String']['input'];
  referral: ReferralWhereUniqueInput;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: EnumReferralRewardStatus;
  user: UserWhereUniqueInput;
};

export type ReferralRewardCreateNestedManyWithoutReferralsInput = {
  connect?: InputMaybe<Array<ReferralRewardWhereUniqueInput>>;
};

export type ReferralRewardCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<ReferralRewardWhereUniqueInput>>;
};

export type ReferralRewardListRelationFilter = {
  every?: InputMaybe<ReferralRewardWhereInput>;
  none?: InputMaybe<ReferralRewardWhereInput>;
  some?: InputMaybe<ReferralRewardWhereInput>;
};

export type ReferralRewardOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productType?: InputMaybe<SortOrder>;
  referralId?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type ReferralRewardUpdateInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  referral?: InputMaybe<ReferralWhereUniqueInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<EnumReferralRewardStatus>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type ReferralRewardUpdateManyWithoutReferralsInput = {
  connect?: InputMaybe<Array<ReferralRewardWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ReferralRewardWhereUniqueInput>>;
  set?: InputMaybe<Array<ReferralRewardWhereUniqueInput>>;
};

export type ReferralRewardUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<ReferralRewardWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ReferralRewardWhereUniqueInput>>;
  set?: InputMaybe<Array<ReferralRewardWhereUniqueInput>>;
};

export type ReferralRewardWhereInput = {
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  productType?: InputMaybe<StringFilter>;
  referral?: InputMaybe<ReferralWhereUniqueInput>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumReferralRewardStatus>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type ReferralRewardWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type ReferralUpdateInput = {
  durationInDays?: InputMaybe<Scalars['Float']['input']>;
  pendingAction?: InputMaybe<EnumReferralPendingAction>;
  productType?: InputMaybe<Scalars['String']['input']>;
  referralRewards?: InputMaybe<ReferralRewardUpdateManyWithoutReferralsInput>;
  referred?: InputMaybe<UserWhereUniqueInput>;
  referrer?: InputMaybe<UserWhereUniqueInput>;
};

export type ReferralUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<ReferralWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ReferralWhereUniqueInput>>;
  set?: InputMaybe<Array<ReferralWhereUniqueInput>>;
};

export type ReferralWhereInput = {
  durationInDays?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  pendingAction?: InputMaybe<EnumReferralPendingAction>;
  productType?: InputMaybe<StringFilter>;
  referralRewards?: InputMaybe<ReferralRewardListRelationFilter>;
  referred?: InputMaybe<UserWhereUniqueInput>;
  referrer?: InputMaybe<UserWhereUniqueInput>;
};

export type ReferralWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type RegenerateConversationEntryInput = {
  conversationEntry: BotConversationEntryWhereUniqueInput;
  user: UserWhereUniqueInput;
};

export type ReinitializeRotationChange = {
  __typename?: 'ReinitializeRotationChange';
  beforeDate?: Maybe<Scalars['DateTime']['output']>;
  change?: Maybe<EnumReinitializeRotationDayChange>;
  date: Scalars['DateTime']['output'];
  rotationDay: RotationDay;
  shiftAmount?: Maybe<Scalars['Float']['output']>;
};

export type ReinitializeRotationDayPreview = {
  __typename?: 'ReinitializeRotationDayPreview';
  changes: Array<ReinitializeRotationChange>;
  firstDate: Scalars['DateTime']['output'];
  lastDate: Scalars['DateTime']['output'];
};

export type RemoveTokenInput = {
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Resource = {
  __typename?: 'Resource';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  assets: Array<Asset>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  canEdit: Scalars['Boolean']['output'];
  canMoveOutsideDrive: Scalars['Boolean']['output'];
  canMoveWithinDrive: Scalars['Boolean']['output'];
  canTrash: Scalars['Boolean']['output'];
  children: Array<Resource>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  course?: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  drive?: Maybe<Drive>;
  editorVersion?: Maybe<Scalars['Float']['output']>;
  favorites: Array<Favorite>;
  id: Scalars['String']['output'];
  isOnboarding?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedBy?: Maybe<User>;
  mimeType?: Maybe<Scalars['String']['output']>;
  parents: Array<Resource>;
  permissions: Array<Permission>;
  planner?: Maybe<Planner>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<User>;
  resourceSchedules: Array<ResourceSchedule>;
  resourceType?: Maybe<EnumResourceResourceType>;
  schedule?: Maybe<Scalars['JSON']['output']>;
  standards?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['JSON']['output']>;
  template?: Maybe<Resource>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tracking?: Maybe<Scalars['JSON']['output']>;
  units?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  usedAsTemplate: Array<Resource>;
  user?: Maybe<User>;
  version?: Maybe<Scalars['Float']['output']>;
};


export type ResourceAssetsArgs = {
  orderBy?: InputMaybe<Array<AssetOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type ResourceChildrenArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type ResourceFavoritesArgs = {
  orderBy?: InputMaybe<Array<FavoriteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<FavoriteWhereInput>;
};


export type ResourceParentsArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type ResourcePermissionsArgs = {
  orderBy?: InputMaybe<Array<PermissionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type ResourceResourceSchedulesArgs = {
  orderBy?: InputMaybe<Array<ResourceScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceScheduleWhereInput>;
};


export type ResourceUsedAsTemplateArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceAttributesInput = {
  schedule?: InputMaybe<Scalars['JSON']['input']>;
  standards?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
  tracking?: InputMaybe<Scalars['JSON']['input']>;
  units?: InputMaybe<Scalars['JSON']['input']>;
};

export type ResourceCreateInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  assets?: InputMaybe<AssetCreateNestedManyWithoutResourcesInput>;
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  children?: InputMaybe<ResourceCreateNestedManyWithoutResourcesInput>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  drive?: InputMaybe<DriveWhereUniqueInput>;
  editorVersion?: InputMaybe<Scalars['Float']['input']>;
  favorites?: InputMaybe<FavoriteCreateNestedManyWithoutResourcesInput>;
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedBy?: InputMaybe<UserWhereUniqueInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  parents?: InputMaybe<ResourceCreateNestedManyWithoutResourcesInput>;
  permissions?: InputMaybe<PermissionCreateNestedManyWithoutResourcesInput>;
  planner?: InputMaybe<PlannerWhereUniqueInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<UserWhereUniqueInput>;
  resourceSchedules?: InputMaybe<ResourceScheduleCreateNestedManyWithoutResourcesInput>;
  resourceType: EnumResourceResourceType;
  schedule?: InputMaybe<Scalars['JSON']['input']>;
  standards?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['JSON']['input']>;
  template?: InputMaybe<ResourceWhereUniqueInput>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tracking?: InputMaybe<Scalars['JSON']['input']>;
  units?: InputMaybe<Scalars['JSON']['input']>;
  urlId: Scalars['String']['input'];
  usedAsTemplate?: InputMaybe<ResourceCreateNestedManyWithoutResourcesInput>;
  user: UserWhereUniqueInput;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type ResourceCreateNestedManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceCreateNestedManyWithoutDrivesInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceCreateNestedManyWithoutPlannersInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceCreateNestedManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceFromToolStepResponse = {
  __typename?: 'ResourceFromToolStepResponse';
  content?: Maybe<Scalars['JSON']['output']>;
  loading: Scalars['Boolean']['output'];
  resourceKey: Scalars['String']['output'];
  trackId: Scalars['String']['output'];
};

export type ResourceInitInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  drive?: InputMaybe<DriveWhereUniqueInput>;
  editorVersion?: InputMaybe<Scalars['Float']['input']>;
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedBy?: InputMaybe<UserWhereUniqueInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  parents?: InputMaybe<ResourceCreateNestedManyWithoutResourcesInput>;
  permissions?: InputMaybe<PermissionCreateNestedManyWithoutResourcesInput>;
  planner?: InputMaybe<PlannerWhereUniqueInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<UserWhereUniqueInput>;
  resourceType: EnumResourceResourceType;
  schedule?: InputMaybe<Scalars['JSON']['input']>;
  template?: InputMaybe<ResourceWhereUniqueInput>;
  title: Scalars['String']['input'];
  usedAsTemplate?: InputMaybe<ResourceCreateNestedManyWithoutResourcesInput>;
  user: UserWhereUniqueInput;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type ResourceListRelationFilter = {
  every?: InputMaybe<ResourceWhereInput>;
  none?: InputMaybe<ResourceWhereInput>;
  some?: InputMaybe<ResourceWhereInput>;
};

export type ResourceOrderByInput = {
  archivedAt?: InputMaybe<SortOrder>;
  attributes?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  driveId?: InputMaybe<SortOrder>;
  editorVersion?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isOnboarding?: InputMaybe<SortOrder>;
  isTemplate?: InputMaybe<SortOrder>;
  lastModifiedById?: InputMaybe<SortOrder>;
  mimeType?: InputMaybe<SortOrder>;
  plannerId?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrder>;
  publishedById?: InputMaybe<SortOrder>;
  resourceType?: InputMaybe<SortOrder>;
  schedule?: InputMaybe<SortOrder>;
  standards?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  templateId?: InputMaybe<SortOrder>;
  thumbnail?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  tracking?: InputMaybe<SortOrder>;
  units?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export type ResourceSchedule = {
  __typename?: 'ResourceSchedule';
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<Event>;
  id: Scalars['String']['output'];
  resource?: Maybe<Resource>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ResourceScheduleCreateInput = {
  event: EventWhereUniqueInput;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
};

export type ResourceScheduleCreateNestedManyWithoutEventsInput = {
  connect?: InputMaybe<Array<ResourceScheduleWhereUniqueInput>>;
};

export type ResourceScheduleCreateNestedManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<ResourceScheduleWhereUniqueInput>>;
};

export type ResourceScheduleListRelationFilter = {
  every?: InputMaybe<ResourceScheduleWhereInput>;
  none?: InputMaybe<ResourceScheduleWhereInput>;
  some?: InputMaybe<ResourceScheduleWhereInput>;
};

export type ResourceScheduleOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  eventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  resourceId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ResourceScheduleUpdateInput = {
  event?: InputMaybe<EventWhereUniqueInput>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
};

export type ResourceScheduleUpdateManyWithoutEventsInput = {
  connect?: InputMaybe<Array<ResourceScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ResourceScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceScheduleWhereUniqueInput>>;
};

export type ResourceScheduleUpdateManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<ResourceScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ResourceScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceScheduleWhereUniqueInput>>;
};

export type ResourceScheduleWhereInput = {
  event?: InputMaybe<EventWhereUniqueInput>;
  id?: InputMaybe<StringFilter>;
  resource?: InputMaybe<ResourceWhereUniqueInput>;
};

export type ResourceScheduleWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type ResourceUpdateInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  assets?: InputMaybe<AssetUpdateManyWithoutResourcesInput>;
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  children?: InputMaybe<ResourceUpdateManyWithoutResourcesInput>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  drive?: InputMaybe<DriveWhereUniqueInput>;
  editorVersion?: InputMaybe<Scalars['Float']['input']>;
  favorites?: InputMaybe<FavoriteUpdateManyWithoutResourcesInput>;
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedBy?: InputMaybe<UserWhereUniqueInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  parents?: InputMaybe<ResourceUpdateManyWithoutResourcesInput>;
  permissions?: InputMaybe<PermissionUpdateManyWithoutResourcesInput>;
  planner?: InputMaybe<PlannerWhereUniqueInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<UserWhereUniqueInput>;
  resourceSchedules?: InputMaybe<ResourceScheduleUpdateManyWithoutResourcesInput>;
  resourceType?: InputMaybe<EnumResourceResourceType>;
  schedule?: InputMaybe<Scalars['JSON']['input']>;
  standards?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['JSON']['input']>;
  template?: InputMaybe<ResourceWhereUniqueInput>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['JSON']['input']>;
  units?: InputMaybe<Scalars['JSON']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  usedAsTemplate?: InputMaybe<ResourceUpdateManyWithoutResourcesInput>;
  user?: InputMaybe<UserWhereUniqueInput>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type ResourceUpdateManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceUpdateManyWithoutDrivesInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceUpdateManyWithoutPlannersInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceUpdateManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
};

export type ResourceUrlIdInput = {
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  urlId: Scalars['String']['input'];
};

export type ResourceWhereInput = {
  archivedAt?: InputMaybe<DateTimeNullableFilter>;
  assets?: InputMaybe<AssetListRelationFilter>;
  attributes?: InputMaybe<JsonFilter>;
  children?: InputMaybe<ResourceListRelationFilter>;
  content?: InputMaybe<JsonFilter>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  drive?: InputMaybe<DriveWhereUniqueInput>;
  editorVersion?: InputMaybe<FloatNullableFilter>;
  favorites?: InputMaybe<FavoriteListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  isOnboarding?: InputMaybe<BooleanNullableFilter>;
  isTemplate?: InputMaybe<BooleanNullableFilter>;
  lastModifiedBy?: InputMaybe<UserWhereUniqueInput>;
  mimeType?: InputMaybe<StringNullableFilter>;
  parents?: InputMaybe<ResourceListRelationFilter>;
  permissions?: InputMaybe<PermissionListRelationFilter>;
  planner?: InputMaybe<PlannerWhereUniqueInput>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  publishedBy?: InputMaybe<UserWhereUniqueInput>;
  resourceSchedules?: InputMaybe<ResourceScheduleListRelationFilter>;
  resourceType?: InputMaybe<EnumResourceResourceType>;
  schedule?: InputMaybe<JsonFilter>;
  standards?: InputMaybe<JsonFilter>;
  status?: InputMaybe<JsonFilter>;
  template?: InputMaybe<ResourceWhereUniqueInput>;
  thumbnail?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  tracking?: InputMaybe<JsonFilter>;
  units?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  urlId?: InputMaybe<StringFilter>;
  usedAsTemplate?: InputMaybe<ResourceListRelationFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
  version?: InputMaybe<FloatNullableFilter>;
};

export type ResourceWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type RotationDay = {
  __typename?: 'RotationDay';
  abbreviation: Scalars['String']['output'];
  blockSchedules: Array<BlockSchedule>;
  calendarDays: Array<CalendarDay>;
  calendarSchedules: Array<CalendarSchedule>;
  createdAt: Scalars['DateTime']['output'];
  dayIndex: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rotationSchedule?: Maybe<RotationSchedule>;
  updatedAt: Scalars['DateTime']['output'];
};


export type RotationDayBlockSchedulesArgs = {
  orderBy?: InputMaybe<Array<BlockScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BlockScheduleWhereInput>;
};


export type RotationDayCalendarDaysArgs = {
  orderBy?: InputMaybe<Array<CalendarDayOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarDayWhereInput>;
};


export type RotationDayCalendarSchedulesArgs = {
  orderBy?: InputMaybe<Array<CalendarScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarScheduleWhereInput>;
};

export type RotationDayCreateInput = {
  abbreviation: Scalars['String']['input'];
  blockSchedules?: InputMaybe<BlockScheduleCreateNestedManyWithoutRotationDaysInput>;
  calendarDays?: InputMaybe<CalendarDayCreateNestedManyWithoutRotationDaysInput>;
  calendarSchedules?: InputMaybe<CalendarScheduleCreateNestedManyWithoutRotationDaysInput>;
  dayIndex: Scalars['Float']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  rotationSchedule: RotationScheduleWhereUniqueInput;
};

export type RotationDayCreateNestedManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<RotationDayWhereUniqueInput>>;
};

export type RotationDayListRelationFilter = {
  every?: InputMaybe<RotationDayWhereInput>;
  none?: InputMaybe<RotationDayWhereInput>;
  some?: InputMaybe<RotationDayWhereInput>;
};

export type RotationDayOrderByInput = {
  abbreviation?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dayIndex?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rotationScheduleId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RotationDayUpdateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  blockSchedules?: InputMaybe<BlockScheduleUpdateManyWithoutRotationDaysInput>;
  calendarDays?: InputMaybe<CalendarDayUpdateManyWithoutRotationDaysInput>;
  calendarSchedules?: InputMaybe<CalendarScheduleUpdateManyWithoutRotationDaysInput>;
  dayIndex?: InputMaybe<Scalars['Float']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type RotationDayUpdateManyWithoutRotationSchedulesInput = {
  connect?: InputMaybe<Array<RotationDayWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<RotationDayWhereUniqueInput>>;
  set?: InputMaybe<Array<RotationDayWhereUniqueInput>>;
};

export type RotationDayWhereInput = {
  abbreviation?: InputMaybe<StringFilter>;
  blockSchedules?: InputMaybe<BlockScheduleListRelationFilter>;
  calendarDays?: InputMaybe<CalendarDayListRelationFilter>;
  calendarSchedules?: InputMaybe<CalendarScheduleListRelationFilter>;
  dayIndex?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  rotationSchedule?: InputMaybe<RotationScheduleWhereUniqueInput>;
};

export type RotationDayWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type RotationSchedule = {
  __typename?: 'RotationSchedule';
  alternateSchedules: Array<AlternateSchedule>;
  blocks: Array<Block>;
  calendarDays: Array<CalendarDay>;
  calendars: Array<Calendar>;
  createdAt: Scalars['DateTime']['output'];
  daysOfWeek?: Maybe<Array<EnumRotationScheduleDaysOfWeek>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  gradeLevels?: Maybe<Array<EnumRotationScheduleGradeLevels>>;
  id: Scalars['String']['output'];
  isWeeklyRotation?: Maybe<Scalars['Boolean']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  planner?: Maybe<PlannerRevision>;
  rotationDays: Array<RotationDay>;
  session?: Maybe<Session>;
  skipNoSchoolDays?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type RotationScheduleAlternateSchedulesArgs = {
  orderBy?: InputMaybe<Array<AlternateScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AlternateScheduleWhereInput>;
};


export type RotationScheduleBlocksArgs = {
  orderBy?: InputMaybe<Array<BlockOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BlockWhereInput>;
};


export type RotationScheduleCalendarDaysArgs = {
  orderBy?: InputMaybe<Array<CalendarDayOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarDayWhereInput>;
};


export type RotationScheduleCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type RotationScheduleRotationDaysArgs = {
  orderBy?: InputMaybe<Array<RotationDayOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<RotationDayWhereInput>;
};

export type RotationScheduleCreateInput = {
  alternateSchedules?: InputMaybe<AlternateScheduleCreateNestedManyWithoutRotationSchedulesInput>;
  blocks?: InputMaybe<BlockCreateNestedManyWithoutRotationSchedulesInput>;
  calendarDays?: InputMaybe<CalendarDayCreateNestedManyWithoutRotationSchedulesInput>;
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutRotationSchedulesInput>;
  daysOfWeek?: InputMaybe<Array<EnumRotationScheduleDaysOfWeek>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gradeLevels?: InputMaybe<Array<EnumRotationScheduleGradeLevels>>;
  isWeeklyRotation?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
  rotationDays?: InputMaybe<RotationDayCreateNestedManyWithoutRotationSchedulesInput>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  skipNoSchoolDays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RotationScheduleCreateNestedManyWithoutPlannerRevisionsInput = {
  connect?: InputMaybe<Array<RotationScheduleWhereUniqueInput>>;
};

export type RotationScheduleCreateNestedManyWithoutSessionsInput = {
  connect?: InputMaybe<Array<RotationScheduleWhereUniqueInput>>;
};

export type RotationScheduleListRelationFilter = {
  every?: InputMaybe<RotationScheduleWhereInput>;
  none?: InputMaybe<RotationScheduleWhereInput>;
  some?: InputMaybe<RotationScheduleWhereInput>;
};

export type RotationScheduleOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  daysOfWeek?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  gradeLevels?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isWeeklyRotation?: InputMaybe<SortOrder>;
  locked?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  plannerId?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrder>;
  skipNoSchoolDays?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RotationScheduleUpdateInput = {
  alternateSchedules?: InputMaybe<AlternateScheduleUpdateManyWithoutRotationSchedulesInput>;
  blocks?: InputMaybe<BlockUpdateManyWithoutRotationSchedulesInput>;
  calendarDays?: InputMaybe<CalendarDayUpdateManyWithoutRotationSchedulesInput>;
  calendars?: InputMaybe<CalendarUpdateManyWithoutRotationSchedulesInput>;
  daysOfWeek?: InputMaybe<Array<EnumRotationScheduleDaysOfWeek>>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gradeLevels?: InputMaybe<Array<EnumRotationScheduleGradeLevels>>;
  isWeeklyRotation?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
  rotationDays?: InputMaybe<RotationDayUpdateManyWithoutRotationSchedulesInput>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  skipNoSchoolDays?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RotationScheduleUpdateManyWithoutPlannerRevisionsInput = {
  connect?: InputMaybe<Array<RotationScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<RotationScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<RotationScheduleWhereUniqueInput>>;
};

export type RotationScheduleUpdateManyWithoutSessionsInput = {
  connect?: InputMaybe<Array<RotationScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<RotationScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<RotationScheduleWhereUniqueInput>>;
};

export type RotationScheduleWhereInput = {
  alternateSchedules?: InputMaybe<AlternateScheduleListRelationFilter>;
  blocks?: InputMaybe<BlockListRelationFilter>;
  calendarDays?: InputMaybe<CalendarDayListRelationFilter>;
  calendars?: InputMaybe<CalendarListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isWeeklyRotation?: InputMaybe<BooleanNullableFilter>;
  locked?: InputMaybe<BooleanNullableFilter>;
  name?: InputMaybe<StringFilter>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
  rotationDays?: InputMaybe<RotationDayListRelationFilter>;
  session?: InputMaybe<SessionWhereUniqueInput>;
  skipNoSchoolDays?: InputMaybe<BooleanNullableFilter>;
};

export type RotationScheduleWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Schedule = {
  __typename?: 'Schedule';
  createdAt: Scalars['DateTime']['output'];
  day: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  periods: Array<Period>;
  planner?: Maybe<PlannerRevision>;
  updatedAt: Scalars['DateTime']['output'];
};


export type SchedulePeriodsArgs = {
  orderBy?: InputMaybe<Array<PeriodOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PeriodWhereInput>;
};

export type ScheduleCreateInput = {
  day: Scalars['Float']['input'];
  periods?: InputMaybe<PeriodCreateNestedManyWithoutSchedulesInput>;
  planner: PlannerRevisionWhereUniqueInput;
};

export type ScheduleCreateNestedManyWithoutPlannerRevisionsInput = {
  connect?: InputMaybe<Array<ScheduleWhereUniqueInput>>;
};

export type ScheduleListRelationFilter = {
  every?: InputMaybe<ScheduleWhereInput>;
  none?: InputMaybe<ScheduleWhereInput>;
  some?: InputMaybe<ScheduleWhereInput>;
};

export type ScheduleOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  day?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  plannerId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ScheduleUpdateInput = {
  day?: InputMaybe<Scalars['Float']['input']>;
  periods?: InputMaybe<PeriodUpdateManyWithoutSchedulesInput>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
};

export type ScheduleUpdateManyWithoutPlannerRevisionsInput = {
  connect?: InputMaybe<Array<ScheduleWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<ScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<ScheduleWhereUniqueInput>>;
};

export type ScheduleWhereInput = {
  day?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  periods?: InputMaybe<PeriodListRelationFilter>;
  planner?: InputMaybe<PlannerRevisionWhereUniqueInput>;
};

export type ScheduleWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type School = {
  __typename?: 'School';
  address?: Maybe<Scalars['JSON']['output']>;
  calendars: Array<Calendar>;
  classes: Array<ClassV2>;
  courses: Array<CourseV2>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  departments: Array<Department>;
  district?: Maybe<District>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  gradeLevels?: Maybe<Array<EnumSchoolGradeLevels>>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  sessions: Array<Session>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  users: Array<User>;
};


export type SchoolCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type SchoolClassesArgs = {
  orderBy?: InputMaybe<Array<ClassV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ClassV2WhereInput>;
};


export type SchoolCoursesArgs = {
  orderBy?: InputMaybe<Array<CourseV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CourseV2WhereInput>;
};


export type SchoolDepartmentsArgs = {
  orderBy?: InputMaybe<Array<DepartmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DepartmentWhereInput>;
};


export type SchoolSessionsArgs = {
  orderBy?: InputMaybe<Array<SessionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type SchoolUsersArgs = {
  orderBy?: InputMaybe<Array<UserOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export type SchoolCreateInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutSchoolsInput>;
  classes?: InputMaybe<ClassV2CreateNestedManyWithoutSchoolsInput>;
  courses?: InputMaybe<CourseV2CreateNestedManyWithoutSchoolsInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departments?: InputMaybe<DepartmentCreateNestedManyWithoutSchoolsInput>;
  district: DistrictWhereUniqueInput;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  gradeLevels?: InputMaybe<Array<EnumSchoolGradeLevels>>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutSchoolsInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId: Scalars['String']['input'];
  users?: InputMaybe<UserCreateNestedManyWithoutSchoolsInput>;
};

export type SchoolCreateNestedManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SchoolCreateNestedManyWithoutDepartmentsInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SchoolCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SchoolCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SchoolListRelationFilter = {
  every?: InputMaybe<SchoolWhereInput>;
  none?: InputMaybe<SchoolWhereInput>;
  some?: InputMaybe<SchoolWhereInput>;
};

export type SchoolOrderByInput = {
  address?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  gradeLevels?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
};

export type SchoolUpdateInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  calendars?: InputMaybe<CalendarUpdateManyWithoutSchoolsInput>;
  classes?: InputMaybe<ClassV2UpdateManyWithoutSchoolsInput>;
  courses?: InputMaybe<CourseV2UpdateManyWithoutSchoolsInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departments?: InputMaybe<DepartmentUpdateManyWithoutSchoolsInput>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  gradeLevels?: InputMaybe<Array<EnumSchoolGradeLevels>>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  sessions?: InputMaybe<SessionUpdateManyWithoutSchoolsInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<UserUpdateManyWithoutSchoolsInput>;
};

export type SchoolUpdateManyWithoutCalendarsInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SchoolUpdateManyWithoutDepartmentsInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SchoolUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SchoolUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SchoolWhereInput = {
  address?: InputMaybe<JsonFilter>;
  calendars?: InputMaybe<CalendarListRelationFilter>;
  classes?: InputMaybe<ClassV2ListRelationFilter>;
  courses?: InputMaybe<CourseV2ListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  departments?: InputMaybe<DepartmentListRelationFilter>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  properties?: InputMaybe<JsonFilter>;
  sessions?: InputMaybe<SessionListRelationFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  urlId?: InputMaybe<StringFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type SchoolWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Section = {
  __typename?: 'Section';
  calendars: Array<Calendar>;
  color: Scalars['String']['output'];
  course?: Maybe<Course>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  periods: Array<Period>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  user?: Maybe<User>;
};


export type SectionCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type SectionPeriodsArgs = {
  orderBy?: InputMaybe<Array<PeriodOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PeriodWhereInput>;
};

export type SectionCreateInput = {
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutSectionsInput>;
  color: Scalars['String']['input'];
  course: CourseWhereUniqueInput;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  periods?: InputMaybe<PeriodCreateNestedManyWithoutSectionsInput>;
  urlId: Scalars['String']['input'];
  user: UserWhereUniqueInput;
};

export type SectionCreateNestedManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<SectionWhereUniqueInput>>;
};

export type SectionCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SectionWhereUniqueInput>>;
};

export type SectionDate = {
  __typename?: 'SectionDate';
  dates: Array<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
};

export type SectionListRelationFilter = {
  every?: InputMaybe<SectionWhereInput>;
  none?: InputMaybe<SectionWhereInput>;
  some?: InputMaybe<SectionWhereInput>;
};

export type SectionOrderByInput = {
  color?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type SectionUpdateInput = {
  calendars?: InputMaybe<CalendarUpdateManyWithoutSectionsInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<PeriodUpdateManyWithoutSectionsInput>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type SectionUpdateManyWithoutCoursesInput = {
  connect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  set?: InputMaybe<Array<SectionWhereUniqueInput>>;
};

export type SectionUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SectionWhereUniqueInput>>;
  set?: InputMaybe<Array<SectionWhereUniqueInput>>;
};

export type SectionV2 = {
  __typename?: 'SectionV2';
  calendars: Array<Calendar>;
  classV2?: Maybe<ClassV2>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  enrollments: Array<Enrollment>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  state?: Maybe<EnumSectionV2State>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
};


export type SectionV2CalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type SectionV2EnrollmentsArgs = {
  orderBy?: InputMaybe<Array<EnrollmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EnrollmentWhereInput>;
};

export type SectionV2CreateInput = {
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutSectionV2sInput>;
  classV2: ClassV2WhereUniqueInput;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  enrollments?: InputMaybe<EnrollmentCreateNestedManyWithoutSectionV2sInput>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  state: EnumSectionV2State;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId: Scalars['String']['input'];
};

export type SectionV2CreateNestedManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<SectionV2WhereUniqueInput>>;
};

export type SectionV2ListRelationFilter = {
  every?: InputMaybe<SectionV2WhereInput>;
  none?: InputMaybe<SectionV2WhereInput>;
  some?: InputMaybe<SectionV2WhereInput>;
};

export type SectionV2OrderByInput = {
  classV2Id?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
};

export type SectionV2UpdateInput = {
  calendars?: InputMaybe<CalendarUpdateManyWithoutSectionV2sInput>;
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  enrollments?: InputMaybe<EnrollmentUpdateManyWithoutSectionV2sInput>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<EnumSectionV2State>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
};

export type SectionV2UpdateManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<SectionV2WhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SectionV2WhereUniqueInput>>;
  set?: InputMaybe<Array<SectionV2WhereUniqueInput>>;
};

export type SectionV2WhereInput = {
  calendars?: InputMaybe<CalendarListRelationFilter>;
  classV2?: InputMaybe<ClassV2WhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  enrollments?: InputMaybe<EnrollmentListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  properties?: InputMaybe<JsonFilter>;
  state?: InputMaybe<EnumSectionV2State>;
  timezone?: InputMaybe<StringNullableFilter>;
  urlId?: InputMaybe<StringFilter>;
};

export type SectionV2WhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type SectionWhereInput = {
  calendars?: InputMaybe<CalendarListRelationFilter>;
  color?: InputMaybe<StringFilter>;
  course?: InputMaybe<CourseWhereUniqueInput>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  periods?: InputMaybe<PeriodListRelationFilter>;
  urlId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
};

export type SectionWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Session = {
  __typename?: 'Session';
  calendars: Array<Calendar>;
  classes: Array<ClassV2>;
  courses: Array<CourseV2>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  district?: Maybe<District>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  rotationSchedules: Array<RotationSchedule>;
  school?: Maybe<School>;
  sessionType?: Maybe<EnumSessionSessionType>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<EnumSessionState>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
};


export type SessionCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type SessionClassesArgs = {
  orderBy?: InputMaybe<Array<ClassV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ClassV2WhereInput>;
};


export type SessionCoursesArgs = {
  orderBy?: InputMaybe<Array<CourseV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CourseV2WhereInput>;
};


export type SessionRotationSchedulesArgs = {
  orderBy?: InputMaybe<Array<RotationScheduleOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<RotationScheduleWhereInput>;
};

export type SessionCreateInput = {
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutSessionsInput>;
  classes?: InputMaybe<ClassV2CreateNestedManyWithoutSessionsInput>;
  courses?: InputMaybe<CourseV2CreateNestedManyWithoutSessionsInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  district: DistrictWhereUniqueInput;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
  rotationSchedules?: InputMaybe<RotationScheduleCreateNestedManyWithoutSessionsInput>;
  school?: InputMaybe<SchoolWhereUniqueInput>;
  sessionType: EnumSessionSessionType;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state: EnumSessionState;
  urlId: Scalars['String']['input'];
};

export type SessionCreateNestedManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
};

export type SessionCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
};

export type SessionCreateNestedManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
};

export type SessionListRelationFilter = {
  every?: InputMaybe<SessionWhereInput>;
  none?: InputMaybe<SessionWhereInput>;
  some?: InputMaybe<SessionWhereInput>;
};

export type SessionOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  schoolId?: InputMaybe<SortOrder>;
  sessionType?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
};

export type SessionUpdateInput = {
  calendars?: InputMaybe<CalendarUpdateManyWithoutSessionsInput>;
  classes?: InputMaybe<ClassV2UpdateManyWithoutSessionsInput>;
  courses?: InputMaybe<CourseV2UpdateManyWithoutSessionsInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  rotationSchedules?: InputMaybe<RotationScheduleUpdateManyWithoutSessionsInput>;
  school?: InputMaybe<SchoolWhereUniqueInput>;
  sessionType?: InputMaybe<EnumSessionSessionType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<EnumSessionState>;
  urlId?: InputMaybe<Scalars['String']['input']>;
};

export type SessionUpdateManyWithoutClassV2sInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  set?: InputMaybe<Array<SessionWhereUniqueInput>>;
};

export type SessionUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  set?: InputMaybe<Array<SessionWhereUniqueInput>>;
};

export type SessionUpdateManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  set?: InputMaybe<Array<SessionWhereUniqueInput>>;
};

export type SessionWhereInput = {
  calendars?: InputMaybe<CalendarListRelationFilter>;
  classes?: InputMaybe<ClassV2ListRelationFilter>;
  courses?: InputMaybe<CourseV2ListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  name?: InputMaybe<StringFilter>;
  properties?: InputMaybe<JsonFilter>;
  rotationSchedules?: InputMaybe<RotationScheduleListRelationFilter>;
  school?: InputMaybe<SchoolWhereUniqueInput>;
  sessionType?: InputMaybe<EnumSessionSessionType>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  state?: InputMaybe<EnumSessionState>;
  urlId?: InputMaybe<StringFilter>;
};

export type SessionWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type Slide = {
  __typename?: 'Slide';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creationProgress?: Maybe<Scalars['JSON']['output']>;
  creationType?: Maybe<EnumSlideCreationType>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorLogs?: Maybe<Scalars['JSON']['output']>;
  generatedData?: Maybe<Scalars['JSON']['output']>;
  googleId?: Maybe<Scalars['String']['output']>;
  googleURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inputData: Scalars['JSON']['output'];
  interviewLogs?: Maybe<Scalars['JSON']['output']>;
  slidesOutlineLogs?: Maybe<Scalars['JSON']['output']>;
  slidesWritingLogs?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<EnumSlideStatus>;
  title: Scalars['String']['output'];
  tokenUsage?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urlId: Scalars['String']['output'];
  user?: Maybe<User>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type SlideCounts = {
  __typename?: 'SlideCounts';
  advanceOptionsCreationsLast7Days: Scalars['Float']['output'];
  fileAttachmentCreationsLast7Days: Scalars['Float']['output'];
  slidesLast7Days: Scalars['Float']['output'];
  slidesLast24Hours: Scalars['Float']['output'];
};

export type SlideCreateInput = {
  creationProgress?: InputMaybe<Scalars['JSON']['input']>;
  creationType: EnumSlideCreationType;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorLogs?: InputMaybe<Scalars['JSON']['input']>;
  generatedData?: InputMaybe<Scalars['JSON']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleURL?: InputMaybe<Scalars['String']['input']>;
  inputData: Scalars['JSON']['input'];
  interviewLogs?: InputMaybe<Scalars['JSON']['input']>;
  slidesOutlineLogs?: InputMaybe<Scalars['JSON']['input']>;
  slidesWritingLogs?: InputMaybe<Scalars['JSON']['input']>;
  status: EnumSlideStatus;
  title: Scalars['String']['input'];
  tokenUsage?: InputMaybe<Scalars['JSON']['input']>;
  urlId: Scalars['String']['input'];
  user: UserWhereUniqueInput;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type SlideCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SlideWhereUniqueInput>>;
};

export type SlideListRelationFilter = {
  every?: InputMaybe<SlideWhereInput>;
  none?: InputMaybe<SlideWhereInput>;
  some?: InputMaybe<SlideWhereInput>;
};

export type SlideOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  creationProgress?: InputMaybe<SortOrder>;
  creationType?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  errorLogs?: InputMaybe<SortOrder>;
  generatedData?: InputMaybe<SortOrder>;
  googleId?: InputMaybe<SortOrder>;
  googleURL?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inputData?: InputMaybe<SortOrder>;
  interviewLogs?: InputMaybe<SortOrder>;
  slidesOutlineLogs?: InputMaybe<SortOrder>;
  slidesWritingLogs?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  tokenUsage?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urlId?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export type SlideOutline = {
  __typename?: 'SlideOutline';
  slides: Scalars['JSON']['output'];
};

export type SlideProgressUpdate = {
  __typename?: 'SlideProgressUpdate';
  error?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Float']['output'];
  state: Scalars['String']['output'];
};

export type SlideUpdateInput = {
  creationProgress?: InputMaybe<Scalars['JSON']['input']>;
  creationType?: InputMaybe<EnumSlideCreationType>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorLogs?: InputMaybe<Scalars['JSON']['input']>;
  generatedData?: InputMaybe<Scalars['JSON']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleURL?: InputMaybe<Scalars['String']['input']>;
  inputData?: InputMaybe<Scalars['JSON']['input']>;
  interviewLogs?: InputMaybe<Scalars['JSON']['input']>;
  slidesOutlineLogs?: InputMaybe<Scalars['JSON']['input']>;
  slidesWritingLogs?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EnumSlideStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  tokenUsage?: InputMaybe<Scalars['JSON']['input']>;
  urlId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type SlideUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SlideWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SlideWhereUniqueInput>>;
  set?: InputMaybe<Array<SlideWhereUniqueInput>>;
};

export type SlideWhereInput = {
  creationProgress?: InputMaybe<JsonFilter>;
  creationType?: InputMaybe<EnumSlideCreationType>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  errorLogs?: InputMaybe<JsonFilter>;
  generatedData?: InputMaybe<JsonFilter>;
  googleId?: InputMaybe<StringNullableFilter>;
  googleURL?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inputData?: InputMaybe<JsonFilter>;
  interviewLogs?: InputMaybe<JsonFilter>;
  slidesOutlineLogs?: InputMaybe<JsonFilter>;
  slidesWritingLogs?: InputMaybe<JsonFilter>;
  status?: InputMaybe<EnumSlideStatus>;
  title?: InputMaybe<StringFilter>;
  tokenUsage?: InputMaybe<JsonFilter>;
  urlId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
  version?: InputMaybe<IntNullableFilter>;
};

export type SlideWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type SlidesOnboardingInputType = {
  country?: InputMaybe<Scalars['String']['input']>;
  discoveryChannel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  slidesOnboardingData?: InputMaybe<Scalars['JSON']['input']>;
};

export type SlideshowCreateInput = {
  aiGeneratedImages?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentIds?: InputMaybe<Scalars['JSON']['input']>;
  browsingMode?: InputMaybe<Scalars['Boolean']['input']>;
  copyrightFreeImages?: InputMaybe<Scalars['Boolean']['input']>;
  creationType: EnumSlideCreationType;
  description?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleURL?: InputMaybe<Scalars['String']['input']>;
  numberOfSlides?: InputMaybe<Scalars['Float']['input']>;
  outputLength?: InputMaybe<Scalars['String']['input']>;
  slideBySlideOutline?: InputMaybe<Scalars['JSON']['input']>;
  speakerNotes?: InputMaybe<Scalars['Boolean']['input']>;
  speakerNotesPrompt?: InputMaybe<Scalars['String']['input']>;
  targetGradeLevel?: InputMaybe<Scalars['String']['input']>;
  theme: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum SortOrder {
  Asc = 'Asc',
  Desc = 'Desc'
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCheckoutInput = {
  numberOfSeats: Scalars['Float']['input'];
  paymentInterval: EnumSubscriptionInterval;
  subscriptionType: EnumUserSubscriptionType;
};

export type Subject = {
  __typename?: 'Subject';
  cedsCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  courses: Array<CourseV2>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Department>;
  description?: Maybe<Scalars['String']['output']>;
  district?: Maybe<District>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type SubjectCoursesArgs = {
  orderBy?: InputMaybe<Array<CourseV2OrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CourseV2WhereInput>;
};

export type SubjectCreateInput = {
  cedsCode?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<CourseV2CreateNestedManyWithoutSubjectsInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  department: DepartmentWhereUniqueInput;
  description?: InputMaybe<Scalars['String']['input']>;
  district: DistrictWhereUniqueInput;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['JSON']['input']>;
};

export type SubjectCreateNestedManyWithoutDepartmentsInput = {
  connect?: InputMaybe<Array<SubjectWhereUniqueInput>>;
};

export type SubjectCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<SubjectWhereUniqueInput>>;
};

export type SubjectListRelationFilter = {
  every?: InputMaybe<SubjectWhereInput>;
  none?: InputMaybe<SubjectWhereInput>;
  some?: InputMaybe<SubjectWhereInput>;
};

export type SubjectOrderByInput = {
  cedsCode?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  departmentId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SubjectUpdateInput = {
  cedsCode?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<CourseV2UpdateManyWithoutSubjectsInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<DepartmentWhereUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
};

export type SubjectUpdateManyWithoutDepartmentsInput = {
  connect?: InputMaybe<Array<SubjectWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SubjectWhereUniqueInput>>;
  set?: InputMaybe<Array<SubjectWhereUniqueInput>>;
};

export type SubjectUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<SubjectWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SubjectWhereUniqueInput>>;
  set?: InputMaybe<Array<SubjectWhereUniqueInput>>;
};

export type SubjectWhereInput = {
  cedsCode?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  courses?: InputMaybe<CourseV2ListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  department?: InputMaybe<DepartmentWhereUniqueInput>;
  description?: InputMaybe<StringNullableFilter>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  name?: InputMaybe<StringFilter>;
  properties?: InputMaybe<JsonFilter>;
};

export type SubjectWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type UpdateCalendarDayInput = {
  alternateSchedule?: InputMaybe<AlternateScheduleWhereUniqueInput>;
  changeType?: InputMaybe<EnumCalendarDayChangeType>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reinitializeRotationDays?: InputMaybe<Scalars['Boolean']['input']>;
  rotationDay?: InputMaybe<RotationDayWhereUniqueInput>;
};

export type UpdatePasswordCredentials = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type UpdateUserDistrictRoleInput = {
  districtId: Scalars['String']['input'];
  districtRoles: Array<EnumUserDistrictRoles>;
  userId: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Scalars['JSON']['output']>;
  aiFavorites: Array<AiFavorite>;
  aiFeedbacks: Array<AiFeedback>;
  aiToolParticipants: Array<AiToolParticipant>;
  assets: Array<Asset>;
  auditLogs: Array<AuditLog>;
  authProvider?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  botConversationEntries: Array<BotConversationEntry>;
  botConversationParticipants: Array<BotConversationParticipant>;
  calendarEntries: Array<CalendarEntry>;
  calendars: Array<Calendar>;
  chatCount: Scalars['Float']['output'];
  chatQuotaRemindersSent?: Maybe<Scalars['Float']['output']>;
  chatwootIdentifierHash?: Maybe<Scalars['String']['output']>;
  copilotFreeTrialEnd?: Maybe<Scalars['DateTime']['output']>;
  copilotOnboardingData?: Maybe<Scalars['JSON']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  courses: Array<Course>;
  createdAt: Scalars['DateTime']['output'];
  createdDistrict?: Maybe<District>;
  crmId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  demographics?: Maybe<Scalars['JSON']['output']>;
  departments: Array<Department>;
  discoveryChannel?: Maybe<Scalars['String']['output']>;
  district?: Maybe<District>;
  districtRoles?: Maybe<Array<EnumUserDistrictRoles>>;
  drives: Array<Drive>;
  edlinkId?: Maybe<Scalars['String']['output']>;
  edlinkTokens?: Maybe<Scalars['JSON']['output']>;
  email: Scalars['String']['output'];
  enrollments: Array<Enrollment>;
  enterprisePlan?: Maybe<EnterprisePlan>;
  enterpriseUser: Scalars['Boolean']['output'];
  favorites: Array<Favorite>;
  firstName?: Maybe<Scalars['String']['output']>;
  freeTrialEnd?: Maybe<Scalars['DateTime']['output']>;
  freeTrialStart?: Maybe<Scalars['DateTime']['output']>;
  gradeLevels?: Maybe<Array<EnumUserGradeLevels>>;
  id: Scalars['String']['output'];
  identifiers?: Maybe<Scalars['JSON']['output']>;
  imageGeneratorCount: Scalars['Float']['output'];
  instantResourcesCount: Scalars['Float']['output'];
  integrations?: Maybe<Scalars['JSON']['output']>;
  invitedCollaborators: Scalars['Boolean']['output'];
  invites: Array<Invite>;
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<EnumUserLanguage>;
  lastModifiedResources: Array<Resource>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSignedIn?: Maybe<Scalars['DateTime']['output']>;
  legacyDistrict?: Maybe<District>;
  middleName?: Maybe<Scalars['String']['output']>;
  onboardedAt?: Maybe<Scalars['DateTime']['output']>;
  permissions: Array<Permission>;
  planners: Array<Planner>;
  properties?: Maybe<Scalars['JSON']['output']>;
  publishedResources: Array<Resource>;
  referralActionsPending?: Maybe<ReferralActionsPending>;
  referralCode?: Maybe<Scalars['String']['output']>;
  resources: Array<Resource>;
  roles: Scalars['JSON']['output'];
  schools: Array<School>;
  sections: Array<Section>;
  slides: Array<Slide>;
  slidesFreeTrialEnd?: Maybe<Scalars['DateTime']['output']>;
  slidesOnboardedAt?: Maybe<Scalars['DateTime']['output']>;
  slidesOnboardingData?: Maybe<Scalars['JSON']['output']>;
  slidesPreferences?: Maybe<Scalars['JSON']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
  subscriptionHistory?: Maybe<Scalars['JSON']['output']>;
  subscriptionInterval?: Maybe<EnumUserSubscriptionInterval>;
  subscriptionType?: Maybe<EnumUserSubscriptionType>;
  teamMemberCount: Scalars['Float']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  toolCount: Scalars['Float']['output'];
  toolQuotaRemindersSent?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userRole?: Maybe<EnumUserUserRole>;
  username: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  versions: Array<Version>;
};


export type UserAiFavoritesArgs = {
  orderBy?: InputMaybe<Array<AiFavoriteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiFavoriteWhereInput>;
};


export type UserAiFeedbacksArgs = {
  orderBy?: InputMaybe<Array<AiFeedbackOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiFeedbackWhereInput>;
};


export type UserAiToolParticipantsArgs = {
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AiToolParticipantWhereInput>;
};


export type UserAssetsArgs = {
  orderBy?: InputMaybe<Array<AssetOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type UserAuditLogsArgs = {
  orderBy?: InputMaybe<Array<AuditLogOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<AuditLogWhereInput>;
};


export type UserBotConversationEntriesArgs = {
  orderBy?: InputMaybe<Array<BotConversationEntryOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BotConversationEntryWhereInput>;
};


export type UserBotConversationParticipantsArgs = {
  orderBy?: InputMaybe<Array<BotConversationParticipantOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<BotConversationParticipantWhereInput>;
};


export type UserCalendarEntriesArgs = {
  orderBy?: InputMaybe<Array<CalendarEntryOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarEntryWhereInput>;
};


export type UserCalendarsArgs = {
  orderBy?: InputMaybe<Array<CalendarOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CalendarWhereInput>;
};


export type UserCoursesArgs = {
  orderBy?: InputMaybe<Array<CourseOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<CourseWhereInput>;
};


export type UserDepartmentsArgs = {
  orderBy?: InputMaybe<Array<DepartmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DepartmentWhereInput>;
};


export type UserDrivesArgs = {
  orderBy?: InputMaybe<Array<DriveOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<DriveWhereInput>;
};


export type UserEnrollmentsArgs = {
  orderBy?: InputMaybe<Array<EnrollmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<EnrollmentWhereInput>;
};


export type UserFavoritesArgs = {
  orderBy?: InputMaybe<Array<FavoriteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<FavoriteWhereInput>;
};


export type UserInvitesArgs = {
  orderBy?: InputMaybe<Array<InviteOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<InviteWhereInput>;
};


export type UserLastModifiedResourcesArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type UserPermissionsArgs = {
  orderBy?: InputMaybe<Array<PermissionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type UserPlannersArgs = {
  orderBy?: InputMaybe<Array<PlannerOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<PlannerWhereInput>;
};


export type UserPublishedResourcesArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type UserResourcesArgs = {
  orderBy?: InputMaybe<Array<ResourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type UserSchoolsArgs = {
  orderBy?: InputMaybe<Array<SchoolOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SchoolWhereInput>;
};


export type UserSectionsArgs = {
  orderBy?: InputMaybe<Array<SectionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SectionWhereInput>;
};


export type UserSlidesArgs = {
  orderBy?: InputMaybe<Array<SlideOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<SlideWhereInput>;
};


export type UserVersionsArgs = {
  orderBy?: InputMaybe<Array<VersionOrderByInput>>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  where?: InputMaybe<VersionWhereInput>;
};

export type UserClientResponse = {
  __typename?: 'UserClientResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserObject>;
};

export type UserCreateInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  aiFavorites?: InputMaybe<AiFavoriteCreateNestedManyWithoutUsersInput>;
  aiFeedbacks?: InputMaybe<AiFeedbackCreateNestedManyWithoutUsersInput>;
  aiToolParticipants?: InputMaybe<AiToolParticipantCreateNestedManyWithoutUsersInput>;
  assets?: InputMaybe<AssetCreateNestedManyWithoutUsersInput>;
  auditLogs?: InputMaybe<AuditLogCreateNestedManyWithoutUsersInput>;
  authProvider?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  botConversationEntries?: InputMaybe<BotConversationEntryCreateNestedManyWithoutUsersInput>;
  botConversationParticipants?: InputMaybe<BotConversationParticipantCreateNestedManyWithoutUsersInput>;
  calendarEntries?: InputMaybe<CalendarEntryCreateNestedManyWithoutUsersInput>;
  calendars?: InputMaybe<CalendarCreateNestedManyWithoutUsersInput>;
  chatQuotaRemindersSent?: InputMaybe<Scalars['Float']['input']>;
  copilotFreeTrialEnd?: InputMaybe<Scalars['DateTime']['input']>;
  copilotOnboardingData?: InputMaybe<Scalars['JSON']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<CourseCreateNestedManyWithoutUsersInput>;
  createdDistrict?: InputMaybe<DistrictWhereUniqueInput>;
  crmId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  demographics?: InputMaybe<Scalars['JSON']['input']>;
  departments?: InputMaybe<DepartmentCreateNestedManyWithoutUsersInput>;
  discoveryChannel?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  districtRoles?: InputMaybe<Array<EnumUserDistrictRoles>>;
  drives?: InputMaybe<DriveCreateNestedManyWithoutUsersInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  edlinkTokens?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  enrollments?: InputMaybe<EnrollmentCreateNestedManyWithoutUsersInput>;
  favorites?: InputMaybe<FavoriteCreateNestedManyWithoutUsersInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeTrialEnd?: InputMaybe<Scalars['DateTime']['input']>;
  freeTrialStart?: InputMaybe<Scalars['DateTime']['input']>;
  givenReferrals?: InputMaybe<ReferralCreateNestedManyWithoutUsersInput>;
  gradeLevels?: InputMaybe<Array<EnumUserGradeLevels>>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  integrations?: InputMaybe<Scalars['JSON']['input']>;
  invites?: InputMaybe<InviteCreateNestedManyWithoutUsersInput>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<EnumUserLanguage>;
  lastModifiedResources?: InputMaybe<ResourceCreateNestedManyWithoutUsersInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastSignedIn?: InputMaybe<Scalars['DateTime']['input']>;
  legacyDistrict?: InputMaybe<DistrictWhereUniqueInput>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<PermissionCreateNestedManyWithoutUsersInput>;
  planners?: InputMaybe<PlannerCreateNestedManyWithoutUsersInput>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  publishedResources?: InputMaybe<ResourceCreateNestedManyWithoutUsersInput>;
  receivedReferrals?: InputMaybe<ReferralCreateNestedManyWithoutUsersInput>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referralRewards?: InputMaybe<ReferralRewardCreateNestedManyWithoutUsersInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutUsersInput>;
  roles: Scalars['JSON']['input'];
  schools?: InputMaybe<SchoolCreateNestedManyWithoutUsersInput>;
  sections?: InputMaybe<SectionCreateNestedManyWithoutUsersInput>;
  slides?: InputMaybe<SlideCreateNestedManyWithoutUsersInput>;
  slidesFreeTrialEnd?: InputMaybe<Scalars['DateTime']['input']>;
  slidesOnboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slidesOnboardingData?: InputMaybe<Scalars['JSON']['input']>;
  slidesPreferences?: InputMaybe<Scalars['JSON']['input']>;
  subscription?: InputMaybe<Scalars['JSON']['input']>;
  subscriptionHistory?: InputMaybe<Scalars['JSON']['input']>;
  subscriptionInterval?: InputMaybe<EnumUserSubscriptionInterval>;
  subscriptionType?: InputMaybe<EnumUserSubscriptionType>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  toolQuotaRemindersSent?: InputMaybe<Scalars['Float']['input']>;
  userRole?: InputMaybe<EnumUserUserRole>;
  username: Scalars['String']['input'];
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  versions?: InputMaybe<VersionCreateNestedManyWithoutUsersInput>;
};

export type UserCreateNestedManyWithoutDepartmentsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateNestedManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateNestedManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserDetailsInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  districtRoles?: InputMaybe<Array<EnumUserDistrictRoles>>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
};

export type UserEmailInput = {
  email: Scalars['String']['input'];
};

export type UserLicenseActiveInput = {
  assignSeat: Scalars['Boolean']['input'];
  districtId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserObject = {
  __typename?: 'UserObject';
  authProvider?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrations?: Maybe<Scalars['JSON']['output']>;
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSignedIn?: Maybe<Scalars['DateTime']['output']>;
  roles: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userRole?: Maybe<EnumUserUserRole>;
  username: Scalars['String']['output'];
};

export type UserOrderByInput = {
  address?: InputMaybe<SortOrder>;
  authProvider?: InputMaybe<SortOrder>;
  avatarUrl?: InputMaybe<SortOrder>;
  chatQuotaRemindersSent?: InputMaybe<SortOrder>;
  copilotFreeTrialEnd?: InputMaybe<SortOrder>;
  copilotOnboardingData?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdDistrictId?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  demographics?: InputMaybe<SortOrder>;
  discoveryChannel?: InputMaybe<SortOrder>;
  districtId?: InputMaybe<SortOrder>;
  districtRoles?: InputMaybe<SortOrder>;
  edlinkId?: InputMaybe<SortOrder>;
  edlinkTokens?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  freeTrialEnd?: InputMaybe<SortOrder>;
  freeTrialStart?: InputMaybe<SortOrder>;
  gradeLevels?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identifiers?: InputMaybe<SortOrder>;
  integrations?: InputMaybe<SortOrder>;
  isOnboarded?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  lastSignedIn?: InputMaybe<SortOrder>;
  legacyDistrictId?: InputMaybe<SortOrder>;
  middleName?: InputMaybe<SortOrder>;
  onboardedAt?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  properties?: InputMaybe<SortOrder>;
  referralCode?: InputMaybe<SortOrder>;
  roles?: InputMaybe<SortOrder>;
  slidesFreeTrialEnd?: InputMaybe<SortOrder>;
  slidesOnboardedAt?: InputMaybe<SortOrder>;
  slidesOnboardingData?: InputMaybe<SortOrder>;
  slidesPreferences?: InputMaybe<SortOrder>;
  subscription?: InputMaybe<SortOrder>;
  subscriptionHistory?: InputMaybe<SortOrder>;
  subscriptionInterval?: InputMaybe<SortOrder>;
  subscriptionType?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  toolQuotaRemindersSent?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userRole?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  verifiedAt?: InputMaybe<SortOrder>;
};

export type UserUpdateInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  aiFavorites?: InputMaybe<AiFavoriteUpdateManyWithoutUsersInput>;
  aiFeedbacks?: InputMaybe<AiFeedbackUpdateManyWithoutUsersInput>;
  aiToolParticipants?: InputMaybe<AiToolParticipantUpdateManyWithoutUsersInput>;
  assets?: InputMaybe<AssetUpdateManyWithoutUsersInput>;
  auditLogs?: InputMaybe<AuditLogUpdateManyWithoutUsersInput>;
  authProvider?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  botConversationEntries?: InputMaybe<BotConversationEntryUpdateManyWithoutUsersInput>;
  botConversationParticipants?: InputMaybe<BotConversationParticipantUpdateManyWithoutUsersInput>;
  calendarEntries?: InputMaybe<CalendarEntryUpdateManyWithoutUsersInput>;
  calendars?: InputMaybe<CalendarUpdateManyWithoutUsersInput>;
  chatQuotaRemindersSent?: InputMaybe<Scalars['Float']['input']>;
  copilotFreeTrialEnd?: InputMaybe<Scalars['DateTime']['input']>;
  copilotOnboardingData?: InputMaybe<Scalars['JSON']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<CourseUpdateManyWithoutUsersInput>;
  createdDistrict?: InputMaybe<DistrictWhereUniqueInput>;
  crmId?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  demographics?: InputMaybe<Scalars['JSON']['input']>;
  departments?: InputMaybe<DepartmentUpdateManyWithoutUsersInput>;
  discoveryChannel?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  districtRoles?: InputMaybe<Array<EnumUserDistrictRoles>>;
  drives?: InputMaybe<DriveUpdateManyWithoutUsersInput>;
  edlinkId?: InputMaybe<Scalars['String']['input']>;
  edlinkTokens?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollments?: InputMaybe<EnrollmentUpdateManyWithoutUsersInput>;
  favorites?: InputMaybe<FavoriteUpdateManyWithoutUsersInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeTrialEnd?: InputMaybe<Scalars['DateTime']['input']>;
  freeTrialStart?: InputMaybe<Scalars['DateTime']['input']>;
  givenReferrals?: InputMaybe<ReferralUpdateManyWithoutUsersInput>;
  gradeLevels?: InputMaybe<Array<EnumUserGradeLevels>>;
  identifiers?: InputMaybe<Scalars['JSON']['input']>;
  integrations?: InputMaybe<Scalars['JSON']['input']>;
  invites?: InputMaybe<InviteUpdateManyWithoutUsersInput>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<EnumUserLanguage>;
  lastModifiedResources?: InputMaybe<ResourceUpdateManyWithoutUsersInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastSignedIn?: InputMaybe<Scalars['DateTime']['input']>;
  legacyDistrict?: InputMaybe<DistrictWhereUniqueInput>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<PermissionUpdateManyWithoutUsersInput>;
  planners?: InputMaybe<PlannerUpdateManyWithoutUsersInput>;
  properties?: InputMaybe<Scalars['JSON']['input']>;
  publishedResources?: InputMaybe<ResourceUpdateManyWithoutUsersInput>;
  receivedReferrals?: InputMaybe<ReferralUpdateManyWithoutUsersInput>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referralRewards?: InputMaybe<ReferralRewardUpdateManyWithoutUsersInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutUsersInput>;
  roles?: InputMaybe<Scalars['JSON']['input']>;
  schools?: InputMaybe<SchoolUpdateManyWithoutUsersInput>;
  sections?: InputMaybe<SectionUpdateManyWithoutUsersInput>;
  slides?: InputMaybe<SlideUpdateManyWithoutUsersInput>;
  slidesFreeTrialEnd?: InputMaybe<Scalars['DateTime']['input']>;
  slidesOnboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slidesOnboardingData?: InputMaybe<Scalars['JSON']['input']>;
  slidesPreferences?: InputMaybe<Scalars['JSON']['input']>;
  subscription?: InputMaybe<Scalars['JSON']['input']>;
  subscriptionHistory?: InputMaybe<Scalars['JSON']['input']>;
  subscriptionInterval?: InputMaybe<EnumUserSubscriptionInterval>;
  subscriptionType?: InputMaybe<EnumUserSubscriptionType>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  toolQuotaRemindersSent?: InputMaybe<Scalars['Float']['input']>;
  userRole?: InputMaybe<EnumUserUserRole>;
  username?: InputMaybe<Scalars['String']['input']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  versions?: InputMaybe<VersionUpdateManyWithoutUsersInput>;
};

export type UserUpdateManyWithoutDepartmentsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateManyWithoutDistrictsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserWhereInput = {
  address?: InputMaybe<JsonFilter>;
  aiFavorites?: InputMaybe<AiFavoriteListRelationFilter>;
  aiFeedbacks?: InputMaybe<AiFeedbackListRelationFilter>;
  aiToolParticipants?: InputMaybe<AiToolParticipantListRelationFilter>;
  assets?: InputMaybe<AssetListRelationFilter>;
  auditLogs?: InputMaybe<AuditLogListRelationFilter>;
  authProvider?: InputMaybe<StringNullableFilter>;
  avatarUrl?: InputMaybe<StringNullableFilter>;
  botConversationEntries?: InputMaybe<BotConversationEntryListRelationFilter>;
  botConversationParticipants?: InputMaybe<BotConversationParticipantListRelationFilter>;
  calendarEntries?: InputMaybe<CalendarEntryListRelationFilter>;
  calendars?: InputMaybe<CalendarListRelationFilter>;
  chatQuotaRemindersSent?: InputMaybe<IntNullableFilter>;
  copilotFreeTrialEnd?: InputMaybe<DateTimeNullableFilter>;
  copilotOnboardingData?: InputMaybe<JsonFilter>;
  country?: InputMaybe<StringNullableFilter>;
  courses?: InputMaybe<CourseListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdDistrict?: InputMaybe<DistrictWhereUniqueInput>;
  crmId?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  demographics?: InputMaybe<JsonFilter>;
  departments?: InputMaybe<DepartmentListRelationFilter>;
  discoveryChannel?: InputMaybe<StringNullableFilter>;
  district?: InputMaybe<DistrictWhereUniqueInput>;
  districtRoles?: InputMaybe<EnumEnumUserDistrictRolesNullableListFilterInput>;
  drives?: InputMaybe<DriveListRelationFilter>;
  edlinkId?: InputMaybe<StringNullableFilter>;
  edlinkTokens?: InputMaybe<JsonFilter>;
  email?: InputMaybe<StringFilter>;
  enrollments?: InputMaybe<EnrollmentListRelationFilter>;
  favorites?: InputMaybe<FavoriteListRelationFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  freeTrialEnd?: InputMaybe<DateTimeNullableFilter>;
  freeTrialStart?: InputMaybe<DateTimeNullableFilter>;
  givenReferrals?: InputMaybe<ReferralListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  identifiers?: InputMaybe<JsonFilter>;
  integrations?: InputMaybe<JsonFilter>;
  invites?: InputMaybe<InviteListRelationFilter>;
  isOnboarded?: InputMaybe<BooleanNullableFilter>;
  language?: InputMaybe<EnumUserLanguage>;
  lastModifiedResources?: InputMaybe<ResourceListRelationFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  lastSignedIn?: InputMaybe<DateTimeNullableFilter>;
  legacyDistrict?: InputMaybe<DistrictWhereUniqueInput>;
  middleName?: InputMaybe<StringNullableFilter>;
  onboardedAt?: InputMaybe<DateTimeNullableFilter>;
  permissions?: InputMaybe<PermissionListRelationFilter>;
  planners?: InputMaybe<PlannerListRelationFilter>;
  properties?: InputMaybe<JsonFilter>;
  publishedResources?: InputMaybe<ResourceListRelationFilter>;
  receivedReferrals?: InputMaybe<ReferralListRelationFilter>;
  referralCode?: InputMaybe<StringNullableFilter>;
  referralRewards?: InputMaybe<ReferralRewardListRelationFilter>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  schools?: InputMaybe<SchoolListRelationFilter>;
  sections?: InputMaybe<SectionListRelationFilter>;
  slides?: InputMaybe<SlideListRelationFilter>;
  slidesFreeTrialEnd?: InputMaybe<DateTimeNullableFilter>;
  slidesOnboardedAt?: InputMaybe<DateTimeNullableFilter>;
  slidesOnboardingData?: InputMaybe<JsonFilter>;
  slidesPreferences?: InputMaybe<JsonFilter>;
  subscription?: InputMaybe<JsonFilter>;
  subscriptionHistory?: InputMaybe<JsonFilter>;
  subscriptionInterval?: InputMaybe<EnumUserSubscriptionInterval>;
  subscriptionType?: InputMaybe<EnumUserSubscriptionType>;
  timezone?: InputMaybe<StringNullableFilter>;
  toolQuotaRemindersSent?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userRole?: InputMaybe<EnumUserUserRole>;
  username?: InputMaybe<StringFilter>;
  verifiedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<VersionListRelationFilter>;
};

export type UserWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type VerifyHashResponse = {
  __typename?: 'VerifyHashResponse';
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<Scalars['Boolean']['output']>;
};

export type Version = {
  __typename?: 'Version';
  actionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  versionNumber: Scalars['Float']['output'];
};

export type VersionCreateInput = {
  actionId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
  user: UserWhereUniqueInput;
  versionNumber: Scalars['Float']['input'];
};

export type VersionCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
};

export type VersionListRelationFilter = {
  every?: InputMaybe<VersionWhereInput>;
  none?: InputMaybe<VersionWhereInput>;
  some?: InputMaybe<VersionWhereInput>;
};

export type VersionOrderByInput = {
  actionId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  versionNumber?: InputMaybe<SortOrder>;
};

export type VersionUpdateInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  user?: InputMaybe<UserWhereUniqueInput>;
  versionNumber?: InputMaybe<Scalars['Float']['input']>;
};

export type VersionUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<VersionWhereUniqueInput>>;
  set?: InputMaybe<Array<VersionWhereUniqueInput>>;
};

export type VersionWhereInput = {
  actionId?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserWhereUniqueInput>;
  versionNumber?: InputMaybe<IntFilter>;
};

export type VersionWhereUniqueInput = {
  id: Scalars['String']['input'];
};

export type CreateAiFeedbackMutationVariables = Exact<{
  data: AiFeedbackCreateInput;
}>;


export type CreateAiFeedbackMutation = { __typename?: 'Mutation', createAiFeedback: { __typename?: 'AiFeedback', createdAt: any, id: string, aiContext?: any | null, entity?: EnumAiFeedbackEntity | null, entityId?: string | null, feedback: any, parentEntityId?: string | null, runId: string, updatedAt: any, user?: { __typename?: 'User', id: string } | null } };

export type UpdateAiFeedbackMutationVariables = Exact<{
  where: AiFeedbackWhereUniqueInput;
  data: AiFeedbackUpdateInput;
}>;


export type UpdateAiFeedbackMutation = { __typename?: 'Mutation', updateAiFeedback: { __typename?: 'AiFeedback', createdAt: any, id: string, aiContext?: any | null, entity?: EnumAiFeedbackEntity | null, entityId?: string | null, feedback: any, parentEntityId?: string | null, runId: string, updatedAt: any, user?: { __typename?: 'User', id: string } | null } };

export type GetAiFeedbackQueryVariables = Exact<{
  where: AiFeedbackWhereUniqueInput;
}>;


export type GetAiFeedbackQuery = { __typename?: 'Query', aiFeedback?: { __typename?: 'AiFeedback', createdAt: any, id: string, aiContext?: any | null, entity?: EnumAiFeedbackEntity | null, entityId?: string | null, feedback: any, parentEntityId?: string | null, runId: string, updatedAt: any, user?: { __typename?: 'User', id: string } | null } | null };

export type GetAiFeedbacksQueryVariables = Exact<{
  where: AiFeedbackWhereInput;
}>;


export type GetAiFeedbacksQuery = { __typename?: 'Query', aiFeedbacks: Array<{ __typename?: 'AiFeedback', createdAt: any, id: string, aiContext?: any | null, entity?: EnumAiFeedbackEntity | null, entityId?: string | null, feedback: any, parentEntityId?: string | null, runId: string, updatedAt: any, user?: { __typename?: 'User', id: string } | null }> };

export type InitAiToolMutationVariables = Exact<{
  data: InitToolInput;
}>;


export type InitAiToolMutation = { __typename?: 'Mutation', initAiTool: { __typename?: 'AiTool', createdAt: any, id: string, data?: any | null, initData: any, title: string, toolId: string, updatedAt: any, urlId: string, version?: number | null, aiToolParticipants: Array<{ __typename?: 'AiToolParticipant', createdAt: any, owner?: boolean | null, id: string, permissions?: Array<EnumAiToolParticipantPermissions> | null, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string, toolId: string } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, avatarUrl?: string | null } | null }>, aiToolSteps: Array<{ __typename?: 'AiToolStep', createdAt: any, data: any, id: string, stepId: string, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string } | null }> } };

export type UpdateAiToolMutationVariables = Exact<{
  data: AiToolUpdateInput;
  where: AiToolWhereUniqueInput;
}>;


export type UpdateAiToolMutation = { __typename?: 'Mutation', updateAiTool: { __typename?: 'AiTool', createdAt: any, id: string, data?: any | null, initData: any, title: string, toolId: string, updatedAt: any, urlId: string, version?: number | null, aiToolParticipants: Array<{ __typename?: 'AiToolParticipant', createdAt: any, owner?: boolean | null, id: string, permissions?: Array<EnumAiToolParticipantPermissions> | null, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string, toolId: string } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, avatarUrl?: string | null } | null }>, aiToolSteps: Array<{ __typename?: 'AiToolStep', createdAt: any, data: any, id: string, stepId: string, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string } | null }> } };

export type AiToolFieldAutofillMutationVariables = Exact<{
  where: AiAutofillInput;
}>;


export type AiToolFieldAutofillMutation = { __typename?: 'Mutation', aiToolFieldAutofill: boolean };

export type GenerateStepOutputMutationVariables = Exact<{
  where: GenerateStepOutputInput;
}>;


export type GenerateStepOutputMutation = { __typename?: 'Mutation', generateStepOutput: boolean };

export type CompleteToolStepMutationVariables = Exact<{
  data: CompleteToolStepInput;
}>;


export type CompleteToolStepMutation = { __typename?: 'Mutation', completeToolStep: { __typename?: 'AiTool', createdAt: any, id: string, data?: any | null, initData: any, title: string, toolId: string, updatedAt: any, urlId: string, version?: number | null, aiToolParticipants: Array<{ __typename?: 'AiToolParticipant', createdAt: any, owner?: boolean | null, id: string, permissions?: Array<EnumAiToolParticipantPermissions> | null, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string, toolId: string } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, avatarUrl?: string | null } | null }>, aiToolSteps: Array<{ __typename?: 'AiToolStep', createdAt: any, data: any, id: string, stepId: string, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string } | null }> } };

export type AiToolFinalOutputMutationVariables = Exact<{
  where: FinalStepOutputInput;
}>;


export type AiToolFinalOutputMutation = { __typename?: 'Mutation', aiToolFinalOutput: boolean };

export type AiChatInterfaceInputMutationVariables = Exact<{
  where: AiChatInterfaceInput;
}>;


export type AiChatInterfaceInputMutation = { __typename?: 'Mutation', aiChatInterfaceInput: boolean };

export type AiChatInterfaceSuggestionResponseMutationVariables = Exact<{
  where: AiChatInterfaceSuggestionResponseInput;
}>;


export type AiChatInterfaceSuggestionResponseMutation = { __typename?: 'Mutation', aiChatInterfaceSuggestionResponse: boolean };

export type ConvertMarkdownToPdfMutationVariables = Exact<{
  markdown: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type ConvertMarkdownToPdfMutation = { __typename?: 'Mutation', convertMarkdownToPDF: string };

export type ResourceGeneratorEditMutationVariables = Exact<{
  where: AiResourceGeneratorEditInput;
}>;


export type ResourceGeneratorEditMutation = { __typename?: 'Mutation', resourceGeneratorEdit: boolean };

export type CreateAiFavoriteMutationVariables = Exact<{
  data: AiFavoriteCreateInput;
}>;


export type CreateAiFavoriteMutation = { __typename?: 'Mutation', createAiFavorite: { __typename?: 'AiFavorite', id: string, createdAt: any, entityId: string, entityType?: EnumAiFavoriteEntityType | null, updatedAt: any, user?: { __typename?: 'User', id: string } | null } };

export type DeleteAiFavoriteMutationVariables = Exact<{
  where: AiFavoriteWhereUniqueInput;
}>;


export type DeleteAiFavoriteMutation = { __typename?: 'Mutation', deleteAiFavorite: { __typename?: 'AiFavorite', id: string, createdAt: any, entityId: string, entityType?: EnumAiFavoriteEntityType | null, updatedAt: any, user?: { __typename?: 'User', id: string } | null } };

export type DeleteAiToolMutationVariables = Exact<{
  where: AiToolWhereUniqueInput;
}>;


export type DeleteAiToolMutation = { __typename?: 'Mutation', markAiToolDeleted: { __typename?: 'AiTool', id: string, urlId: string, deletedAt?: any | null } };

export type RestoreAiToolMutationVariables = Exact<{
  where: AiToolWhereUniqueInput;
}>;


export type RestoreAiToolMutation = { __typename?: 'Mutation', restoreAiTool: { __typename?: 'AiTool', id: string, urlId: string, deletedAt?: any | null } };

export type MarkAiToolCompleteMutationVariables = Exact<{
  where: AiToolWhereUniqueInput;
}>;


export type MarkAiToolCompleteMutation = { __typename?: 'Mutation', markAiToolComplete: { __typename?: 'AiTool', id: string, urlId: string, completedAt?: any | null } };

export type UnmarkAiToolCompleteMutationVariables = Exact<{
  where: AiToolWhereUniqueInput;
}>;


export type UnmarkAiToolCompleteMutation = { __typename?: 'Mutation', unmarkAiToolComplete: { __typename?: 'AiTool', id: string, urlId: string, completedAt?: any | null } };

export type RenameAiToolMutationVariables = Exact<{
  where: AiToolWhereUniqueInput;
  data: AiToolUpdateInput;
}>;


export type RenameAiToolMutation = { __typename?: 'Mutation', updateAiTool: { __typename?: 'AiTool', id: string, urlId: string, title: string } };

export type EditAiToolImageMutationVariables = Exact<{
  data: EditImageInput;
}>;


export type EditAiToolImageMutation = { __typename?: 'Mutation', editAiToolImage: { __typename?: 'EditImageResponse', draftUrl: string } };

export type GetAiToolQueryVariables = Exact<{
  where: AiToolWhereUniqueInput;
}>;


export type GetAiToolQuery = { __typename?: 'Query', aiTool?: { __typename?: 'AiTool', createdAt: any, id: string, data?: any | null, initData: any, title: string, toolId: string, updatedAt: any, urlId: string, version?: number | null, aiToolParticipants: Array<{ __typename?: 'AiToolParticipant', createdAt: any, owner?: boolean | null, id: string, permissions?: Array<EnumAiToolParticipantPermissions> | null, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string, toolId: string } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, avatarUrl?: string | null } | null }>, aiToolSteps: Array<{ __typename?: 'AiToolStep', createdAt: any, data: any, id: string, stepId: string, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string } | null }> } | null };

export type GetAiToolByUrlIdQueryVariables = Exact<{
  where: AiToolUrlIdInput;
}>;


export type GetAiToolByUrlIdQuery = { __typename?: 'Query', aiToolByUrlId?: { __typename?: 'AiTool', createdAt: any, id: string, data?: any | null, initData: any, title: string, toolId: string, updatedAt: any, urlId: string, version?: number | null, completedAt?: any | null, deletedAt?: any | null, aiToolParticipants: Array<{ __typename?: 'AiToolParticipant', createdAt: any, owner?: boolean | null, id: string, permissions?: Array<EnumAiToolParticipantPermissions> | null, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string, toolId: string } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, avatarUrl?: string | null } | null }>, aiToolSteps: Array<{ __typename?: 'AiToolStep', createdAt: any, data: any, id: string, stepId: string, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string } | null }> } | null };

export type GetAiToolStepsQueryVariables = Exact<{
  where: AiToolStepWhereInput;
}>;


export type GetAiToolStepsQuery = { __typename?: 'Query', aiToolSteps: Array<{ __typename?: 'AiToolStep', createdAt: any, data: any, id: string, stepId: string, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string } | null }> };

export type GetAiToolParticipantsQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
}>;


export type GetAiToolParticipantsQuery = { __typename?: 'Query', aiToolParticipants: Array<{ __typename?: 'AiToolParticipant', createdAt: any, owner?: boolean | null, id: string, permissions?: Array<EnumAiToolParticipantPermissions> | null, updatedAt: any, aiTool?: { __typename?: 'AiTool', id: string, toolId: string } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, avatarUrl?: string | null } | null }> };

export type GetAiFavoritesQueryVariables = Exact<{
  where: AiFavoriteWhereInput;
}>;


export type GetAiFavoritesQuery = { __typename?: 'Query', aiFavorites: Array<{ __typename?: 'AiFavorite', id: string, createdAt: any, entityId: string, entityType?: EnumAiFavoriteEntityType | null, updatedAt: any, user?: { __typename?: 'User', id: string } | null }> };

export type GetAiToolsHistoryQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput> | AiToolParticipantOrderByInput>;
}>;


export type GetAiToolsHistoryQuery = { __typename?: 'Query', aiToolParticipants: Array<{ __typename?: 'AiToolParticipant', deletedAt?: any | null, id: string, updatedAt: any, owner?: boolean | null, permissions?: Array<EnumAiToolParticipantPermissions> | null, aiTool?: { __typename?: 'AiTool', id: string, title: string, toolId: string, urlId: string, createdAt: any, updatedAt: any } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, email: string } | null }> };

export type GetAiToolsHistoryCountQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
}>;


export type GetAiToolsHistoryCountQuery = { __typename?: 'Query', _aiToolParticipantsMeta: { __typename?: 'MetaQueryPayload', count: number } };

export type GetCurriculumToolsHistoryQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput> | AiToolParticipantOrderByInput>;
}>;


export type GetCurriculumToolsHistoryQuery = { __typename?: 'Query', curriculumToolsParticipants: Array<{ __typename?: 'AiToolParticipant', deletedAt?: any | null, id: string, updatedAt: any, owner?: boolean | null, permissions?: Array<EnumAiToolParticipantPermissions> | null, aiTool?: { __typename?: 'AiTool', id: string, title: string, toolId: string, urlId: string, createdAt: any, updatedAt: any, deletedAt?: any | null, completedAt?: any | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, email: string } | null }> };

export type GetCurriculumToolsHistoryCountQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
}>;


export type GetCurriculumToolsHistoryCountQuery = { __typename?: 'Query', _curriculumToolsParticipantsMeta: { __typename?: 'MetaQueryPayload', count: number } };

export type GetResourceGeneratorToolsHistoryQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput> | AiToolParticipantOrderByInput>;
}>;


export type GetResourceGeneratorToolsHistoryQuery = { __typename?: 'Query', resourceGeneratorParticipants: Array<{ __typename?: 'AiToolParticipant', deletedAt?: any | null, id: string, updatedAt: any, owner?: boolean | null, permissions?: Array<EnumAiToolParticipantPermissions> | null, aiTool?: { __typename?: 'AiTool', id: string, title: string, toolId: string, urlId: string, createdAt: any, updatedAt: any, deletedAt?: any | null, completedAt?: any | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, email: string } | null }> };

export type GetResourceGeneratorToolsHistoryCountQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
}>;


export type GetResourceGeneratorToolsHistoryCountQuery = { __typename?: 'Query', _resourceGeneratorParticipantsMeta: { __typename?: 'MetaQueryPayload', count: number } };

export type GetImageGeneratorToolsHistoryQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Array<AiToolParticipantOrderByInput> | AiToolParticipantOrderByInput>;
}>;


export type GetImageGeneratorToolsHistoryQuery = { __typename?: 'Query', imageGeneratorParticipants: Array<{ __typename?: 'AiToolParticipant', deletedAt?: any | null, id: string, updatedAt: any, owner?: boolean | null, permissions?: Array<EnumAiToolParticipantPermissions> | null, aiTool?: { __typename?: 'AiTool', id: string, title: string, toolId: string, urlId: string, createdAt: any, updatedAt: any, deletedAt?: any | null, completedAt?: any | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, email: string } | null }> };

export type GetImageGeneratorToolsHistoryCountQueryVariables = Exact<{
  where: AiToolParticipantWhereInput;
}>;


export type GetImageGeneratorToolsHistoryCountQuery = { __typename?: 'Query', _imageGeneratorParticipantsMeta: { __typename?: 'MetaQueryPayload', count: number } };

export type GetResourceFromToolStepQueryVariables = Exact<{
  toolId: Scalars['String']['input'];
  stepId: Scalars['String']['input'];
  trackId: Scalars['String']['input'];
  resourceKey: Scalars['String']['input'];
}>;


export type GetResourceFromToolStepQuery = { __typename?: 'Query', getResourceFromToolStep: { __typename?: 'ResourceFromToolStepResponse', trackId: string, resourceKey: string, content?: any | null, loading: boolean } };

export type CreateAssetMutationVariables = Exact<{
  data: AssetCreateInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAsset: { __typename?: 'Asset', id: string, key?: string | null, acl?: EnumAssetAcl | null, contentType?: string | null, size?: number | null, content?: any | null, assetType?: EnumAssetAssetType | null, createdAt: any, updatedAt: any, expiresAt?: any | null, deletedAt?: string | null, vectorEmbeddings?: EnumAssetVectorEmbeddings | null, user?: { __typename?: 'User', id: string } | null, course?: { __typename?: 'Course', id: string } | null, resource?: { __typename?: 'Resource', id: string } | null } };

export type UpdateAssetMutationVariables = Exact<{
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
}>;


export type UpdateAssetMutation = { __typename?: 'Mutation', updateAsset: { __typename?: 'Asset', id: string, key?: string | null, acl?: EnumAssetAcl | null, contentType?: string | null, size?: number | null, content?: any | null, assetType?: EnumAssetAssetType | null, createdAt: any, updatedAt: any, expiresAt?: any | null, deletedAt?: string | null, vectorEmbeddings?: EnumAssetVectorEmbeddings | null, user?: { __typename?: 'User', id: string } | null, course?: { __typename?: 'Course', id: string } | null, resource?: { __typename?: 'Resource', id: string } | null } };

export type DeleteAttachmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAttachmentMutation = { __typename?: 'Mutation', deleteAttachment: boolean };

export type LinkForEmbeddingMutationVariables = Exact<{
  data: AssetCreateInput;
}>;


export type LinkForEmbeddingMutation = { __typename?: 'Mutation', linkForEmbedding: { __typename?: 'Asset', id: string, key?: string | null, acl?: EnumAssetAcl | null, contentType?: string | null, size?: number | null, content?: any | null, assetType?: EnumAssetAssetType | null, createdAt: any, updatedAt: any, expiresAt?: any | null, deletedAt?: string | null, vectorEmbeddings?: EnumAssetVectorEmbeddings | null, user?: { __typename?: 'User', id: string } | null, course?: { __typename?: 'Course', id: string } | null, resource?: { __typename?: 'Resource', id: string } | null } };

export type GetAttachmentsCountQueryVariables = Exact<{
  where: AssetWhereInput;
}>;


export type GetAttachmentsCountQuery = { __typename?: 'Query', _assetsMeta: { __typename?: 'MetaQueryPayload', count: number } };

export type GetAttachmentsQueryVariables = Exact<{
  where: AssetWhereInput;
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
  orderBy?: InputMaybe<Array<AssetOrderByInput> | AssetOrderByInput>;
}>;


export type GetAttachmentsQuery = { __typename?: 'Query', assets: Array<{ __typename?: 'Asset', id: string, key?: string | null, acl?: EnumAssetAcl | null, contentType?: string | null, size?: number | null, content?: any | null, assetType?: EnumAssetAssetType | null, createdAt: any, updatedAt: any, expiresAt?: any | null, deletedAt?: string | null, vectorEmbeddings?: EnumAssetVectorEmbeddings | null, user?: { __typename?: 'User', id: string } | null, course?: { __typename?: 'Course', id: string } | null, resource?: { __typename?: 'Resource', id: string } | null }> };

export type GetAssetsQueryVariables = Exact<{
  where: AssetWhereInput;
}>;


export type GetAssetsQuery = { __typename?: 'Query', assets: Array<{ __typename?: 'Asset', id: string, key?: string | null, acl?: EnumAssetAcl | null, contentType?: string | null, size?: number | null, content?: any | null, assetType?: EnumAssetAssetType | null, createdAt: any, updatedAt: any, deletedAt?: string | null, expiresAt?: any | null, vectorEmbeddings?: EnumAssetVectorEmbeddings | null, user?: { __typename?: 'User', id: string } | null, course?: { __typename?: 'Course', id: string } | null, resource?: { __typename?: 'Resource', id: string } | null }> };

export type CreateAuditLogMutationVariables = Exact<{
  data: AuditLogCreateInput;
}>;


export type CreateAuditLogMutation = { __typename?: 'Mutation', createAuditLog: { __typename?: 'AuditLog', actionId: string, actionType: string, createdAt: any, details: any, id: string, updatedAt: any, user?: { __typename?: 'User', id: string } | null } };

export type GetAuditLogsQueryVariables = Exact<{
  where: AuditLogWhereInput;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', auditLogs: Array<{ __typename?: 'AuditLog', actionId: string, actionType: string, createdAt: any, details: any, id: string, updatedAt: any, user?: { __typename?: 'User', id: string } | null }> };

export type GetAuditLogsForLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuditLogsForLimitsQuery = { __typename?: 'Query', auditLogsForLimits: Array<{ __typename?: 'AuditLog', actionId: string, actionType: string, createdAt: any, details: any, id: string, updatedAt: any, user?: { __typename?: 'User', id: string } | null }> };

export type LoginWithEmailIdMutationVariables = Exact<{
  credentials: Credentials;
}>;


export type LoginWithEmailIdMutation = { __typename?: 'Mutation', loginWithEmail: { __typename?: 'UserClientResponse', accessToken?: string | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName?: string | null, lastName?: string | null, username: string, roles: Array<string>, userRole?: EnumUserUserRole | null, isOnboarded?: boolean | null, avatarUrl?: string | null, integrations?: any | null } | null } };

export type SignUpWithEmailIdMutationVariables = Exact<{
  credentials: Credentials;
}>;


export type SignUpWithEmailIdMutation = { __typename?: 'Mutation', signUpWithEmailForAI: { __typename?: 'UserClientResponse', accessToken?: string | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName?: string | null, lastName?: string | null, roles: Array<string>, userRole?: EnumUserUserRole | null, isOnboarded?: boolean | null, avatarUrl?: string | null, integrations?: any | null } | null } };

export type ResetPasswordWithEmailIdMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordWithEmailIdMutation = { __typename?: 'Mutation', resetPasswordWithEmail: boolean };

export type CompleteOnboardingMutationVariables = Exact<{
  onboardingInput: OnboardingInput;
}>;


export type CompleteOnboardingMutation = { __typename?: 'Mutation', completeOnboarding: boolean };

export type UpdatePasswordWithEmailIdMutationVariables = Exact<{
  credentials: UpdatePasswordCredentials;
}>;


export type UpdatePasswordWithEmailIdMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type SetNewPasswordMutationVariables = Exact<{
  passwordInput: PasswordInput;
}>;


export type SetNewPasswordMutation = { __typename?: 'Mutation', setNewPassword: boolean };

export type ReferAFriendMutationVariables = Exact<{
  referralInput: ReferralInput;
}>;


export type ReferAFriendMutation = { __typename?: 'Mutation', referAFriend: boolean };

export type VerifyEmailMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: boolean };

export type ResendVerificationEmailMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: boolean };

export type CreateRefreshTokenMutationVariables = Exact<{
  tokenInput: GetTokenInput;
}>;


export type CreateRefreshTokenMutation = { __typename?: 'Mutation', createRefreshToken: boolean };

export type HandleApiSignOutMutationVariables = Exact<{
  tokenInput: RemoveTokenInput;
}>;


export type HandleApiSignOutMutation = { __typename?: 'Mutation', handleApiSignOut: boolean };

export type UpdateUserDistrictRoleMutationVariables = Exact<{
  updateUserDistrictRoleInput: UpdateUserDistrictRoleInput;
}>;


export type UpdateUserDistrictRoleMutation = { __typename?: 'Mutation', updateUserDistrictRole: boolean };

export type ReferralLinkSignUpMutationVariables = Exact<{
  referralLinkSignUpInput: ReferralLinkSignUpInput;
}>;


export type ReferralLinkSignUpMutation = { __typename?: 'Mutation', referralLinkSignUp: boolean };

export type IsActivateEligibleMutationVariables = Exact<{
  isActiveEligibleInput: IsActivateEligibleInput;
}>;


export type IsActivateEligibleMutation = { __typename?: 'Mutation', isActivateEligible: boolean };

export type ActivateUserWithPasswordMutationVariables = Exact<{
  activateUserWithPasswordInput: ActivateUserWithPasswordInput;
}>;


export type ActivateUserWithPasswordMutation = { __typename?: 'Mutation', activateUserWithPassword: { __typename?: 'UserClientResponse', accessToken?: string | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName?: string | null, lastName?: string | null, username: string, roles: Array<string>, userRole?: EnumUserUserRole | null, isOnboarded?: boolean | null, avatarUrl?: string | null, integrations?: any | null } | null } };

export type ActivateUserWithSsoMutationVariables = Exact<{
  activateUserWithSSOInput: ActivateUserWithSso;
}>;


export type ActivateUserWithSsoMutation = { __typename?: 'Mutation', activateUserWithSSO: { __typename?: 'UserClientResponse', accessToken?: string | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName?: string | null, lastName?: string | null, username: string, roles: Array<string>, userRole?: EnumUserUserRole | null, isOnboarded?: boolean | null, avatarUrl?: string | null, integrations?: any | null } | null } };

export type FinishEnterpriseOnboardingMutationVariables = Exact<{
  credentials: EnterpriseOnboardingCredentials;
}>;


export type FinishEnterpriseOnboardingMutation = { __typename?: 'Mutation', finishEnterpriseOnboarding: boolean };

export type LoginWithEdlinkMutationVariables = Exact<{
  credentials: EdlinkCredentials;
}>;


export type LoginWithEdlinkMutation = { __typename?: 'Mutation', loginWithEdlink: { __typename?: 'UserClientResponse', accessToken?: string | null, user?: { __typename?: 'UserObject', id: string, email: string, firstName?: string | null, lastName?: string | null, username: string, roles: Array<string>, userRole?: EnumUserUserRole | null, isOnboarded?: boolean | null, avatarUrl?: string | null, integrations?: any | null } | null } };

export type IsEdlinkUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type IsEdlinkUserMutation = { __typename?: 'Mutation', isEdlinkUser: boolean };

export type SubscribeToNewsletterMutationVariables = Exact<{
  newsletterArgs: NewsLetterArgs;
}>;


export type SubscribeToNewsletterMutation = { __typename?: 'Mutation', subscribeToNewsletter: boolean };

export type ExportMarkdownToGoogleDocMutationVariables = Exact<{
  exportMarkdownToGoogleDocsInput: ExportMarkdownToGoogleDocInput;
}>;


export type ExportMarkdownToGoogleDocMutation = { __typename?: 'Mutation', exportMarkdownToGoogleDoc: { __typename?: 'GoogleExportResponse', url?: string | null, error?: string | null } };

export type ExportMarkdownToGoogleFormMutationVariables = Exact<{
  exportMarkdownToGoogleFormsInput: ExportMarkdownToGoogleFormInput;
}>;


export type ExportMarkdownToGoogleFormMutation = { __typename?: 'Mutation', exportMarkdownToGoogleForm: { __typename?: 'GoogleExportResponse', url?: string | null, error?: string | null } };

export type ReferralSignupCompletedMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  referralCode: Scalars['String']['input'];
  product: Scalars['String']['input'];
}>;


export type ReferralSignupCompletedMutation = { __typename?: 'Mutation', referralSignupCompleted: boolean };

export type SendReferralEmailInvitesMutationVariables = Exact<{
  referralEmailInviteArgs: ReferralEmailInvitesArgs;
}>;


export type SendReferralEmailInvitesMutation = { __typename?: 'Mutation', sendReferralEmailInvites: boolean };

export type CompleteReferralActionMutationVariables = Exact<{
  referralCompleteActionArgs: ReferralCompleteActionArgs;
}>;


export type CompleteReferralActionMutation = { __typename?: 'Mutation', completeReferralAction: boolean };

export type MarkActivityCompleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type MarkActivityCompleteMutation = { __typename?: 'Mutation', markActivityComplete: boolean };

export type DeleteActivityMutationVariables = Exact<{
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type DeleteActivityMutation = { __typename?: 'Mutation', deleteActivity: boolean };

export type UnsubscribeFromWeeklyReportsMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UnsubscribeFromWeeklyReportsMutation = { __typename?: 'Mutation', unsubscribeFromWeeklyReports: boolean };

export type TrackWeeklyReportClickMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  destination: Scalars['String']['input'];
}>;


export type TrackWeeklyReportClickMutation = { __typename?: 'Mutation', trackWeeklyReportClick: boolean };

export type GetAuthUserQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type GetAuthUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, username: string, districtRoles?: Array<EnumUserDistrictRoles> | null, avatarUrl?: string | null, userRole?: EnumUserUserRole | null, isOnboarded?: boolean | null, createdAt: any, onboardedAt?: any | null, authProvider?: string | null, updatedAt: any, verifiedAt?: any | null, integrations?: any | null, language?: EnumUserLanguage | null, freeTrialStart?: any | null, freeTrialEnd?: any | null, toolCount: number, chatCount: number, instantResourcesCount: number, imageGeneratorCount: number, enterpriseUser: boolean, invitedCollaborators: boolean, teamMemberCount: number, subscriptionType?: EnumUserSubscriptionType | null, subscriptionInterval?: EnumUserSubscriptionInterval | null, copilotFreeTrialEnd?: any | null, chatwootIdentifierHash?: string | null, drives: Array<{ __typename?: 'Drive', id: string, createdAt: any, driveType?: EnumDriveDriveType | null, updatedAt: any, district?: { __typename?: 'District', id: string } | null, user?: { __typename?: 'User', id: string } | null }>, district?: { __typename?: 'District', id: string, urlId: string, name: string, payments?: any | null, workspaceType?: EnumDistrictWorkspaceType | null, createdBy?: { __typename?: 'User', id: string } | null } | null, enterprisePlan?: { __typename?: 'EnterprisePlan', isEnterpriseAccount: boolean, isLicenseActive: boolean, subscriptionType?: string | null } | null, referralActionsPending?: { __typename?: 'ReferralActionsPending', useChat: boolean, finishOnboarding: boolean, createSlideshow: boolean } | null } | null };

export type CheckUpdatePasswordTokenValidityQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CheckUpdatePasswordTokenValidityQuery = { __typename?: 'Query', checkUpdatePasswordPageValidity: boolean };

export type GetStripeCustomerManagementUrlQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetStripeCustomerManagementUrlQuery = { __typename?: 'Query', getStripeCustomerManagementURL: string };

export type CheckEnterpriseOboardingValidityQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type CheckEnterpriseOboardingValidityQuery = { __typename?: 'Query', checkEnterpriseOboardingValidity: boolean };

export type VerifyEmailHashQueryVariables = Exact<{
  emailHashInput: EmailHashInput;
}>;


export type VerifyEmailHashQuery = { __typename?: 'Query', verifyEmailHash: { __typename?: 'VerifyHashResponse', match?: boolean | null, isOnboarded?: boolean | null } };

export type GetInvitesQueryVariables = Exact<{
  where?: InputMaybe<InviteWhereInput>;
}>;


export type GetInvitesQuery = { __typename?: 'Query', invites: Array<{ __typename?: 'Invite', id: string, email: string, createdAt: any, inviteType?: EnumInviteInviteType | null, status?: EnumInviteStatus | null, invitedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, district?: { __typename?: 'District', id: string, name: string, createdBy?: { __typename?: 'User', id: string } | null } | null } | null }> };

export type GetInvitesForEmailQueryVariables = Exact<{
  where?: InputMaybe<InviteWhereInput>;
}>;


export type GetInvitesForEmailQuery = { __typename?: 'Query', invitesForEmail: Array<{ __typename?: 'Invite', id: string, email: string, createdAt: any, inviteType?: EnumInviteInviteType | null, status?: EnumInviteStatus | null, invitedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, district?: { __typename?: 'District', id: string, name: string, createdBy?: { __typename?: 'User', id: string } | null } | null } | null }> };

export type ProcessOneDriveAttachmentQueryVariables = Exact<{
  oneDriveAttachmentInput: OneDriveAttachmentInput;
}>;


export type ProcessOneDriveAttachmentQuery = { __typename?: 'Query', processOneDriveAttachment: { __typename?: 'Asset', id: string, key?: string | null, acl?: EnumAssetAcl | null, contentType?: string | null, size?: number | null, content?: any | null, assetType?: EnumAssetAssetType | null, createdAt: any, updatedAt: any, deletedAt?: string | null, expiresAt?: any | null, vectorEmbeddings?: EnumAssetVectorEmbeddings | null, version?: number | null, user?: { __typename?: 'User', id: string } | null, course?: { __typename?: 'Course', id: string } | null, resource?: { __typename?: 'Resource', id: string } | null } };

export type GetOneDriveQueryVariables = Exact<{
  oneDriveInput: OneDriveInput;
}>;


export type GetOneDriveQuery = { __typename?: 'Query', getOneDrive: string };

export type GetRefferalLinkQueryVariables = Exact<{
  product: Scalars['String']['input'];
}>;


export type GetRefferalLinkQuery = { __typename?: 'Query', getReferralLink: string };

export type GetReferralInfoQueryVariables = Exact<{
  referralInfoArgs: ReferralInfoArgs;
}>;


export type GetReferralInfoQuery = { __typename?: 'Query', getReferralInfo: { __typename?: 'ReferralInfo', referrerName: string, product: string, freeTrialDays: string, benefitsInDollars: string } };

export type NewBotConversationMutationVariables = Exact<{
  data: NewBotConversationInput;
}>;


export type NewBotConversationMutation = { __typename?: 'Mutation', newBotConversation: { __typename?: 'BotConversation', createdAt: any, data?: any | null, id: string, title: string, updatedAt: any, urlId: string } };

export type NewBotConversationEntryMutationVariables = Exact<{
  data: NewConversationEntryInput;
}>;


export type NewBotConversationEntryMutation = { __typename?: 'Mutation', newBotConversationEntry: { __typename?: 'BotConversationEntry', createdAt: any, deletedAt?: any | null, entry: any, id: string, speaker?: EnumBotConversationEntrySpeaker | null, updatedAt: any, conversation?: { __typename?: 'BotConversation', id: string } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type RegenerateBotConversationEntryMutationVariables = Exact<{
  data: RegenerateConversationEntryInput;
}>;


export type RegenerateBotConversationEntryMutation = { __typename?: 'Mutation', regenerateBotConversationEntry: { __typename?: 'BotConversationEntry', createdAt: any, deletedAt?: any | null, entry: any, id: string, speaker?: EnumBotConversationEntrySpeaker | null, updatedAt: any, conversation?: { __typename?: 'BotConversation', id: string } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } };

export type DeleteBotConversationMutationVariables = Exact<{
  where: BotConversationWhereUniqueInput;
}>;


export type DeleteBotConversationMutation = { __typename?: 'Mutation', markBotConversationDeleted: { __typename?: 'BotConversation', id: string, urlId: string, deletedAt?: any | null } };

export type RestoreBotConversationMutationVariables = Exact<{
  where: BotConversationWhereUniqueInput;
}>;


export type RestoreBotConversationMutation = { __typename?: 'Mutation', restoreBotConversation: { __typename?: 'BotConversation', id: string, urlId: string, deletedAt?: any | null } };

export type MarkBotConversationCompleteMutationVariables = Exact<{
  where: BotConversationWhereUniqueInput;
}>;


export type MarkBotConversationCompleteMutation = { __typename?: 'Mutation', markBotConversationComplete: { __typename?: 'BotConversation', id: string, urlId: string, completedAt?: any | null } };

export type UnmarkBotConversationCompleteMutationVariables = Exact<{
  where: BotConversationWhereUniqueInput;
}>;


export type UnmarkBotConversationCompleteMutation = { __typename?: 'Mutation', unmarkBotConversationComplete: { __typename?: 'BotConversation', id: string, urlId: string, completedAt?: any | null } };

export type RenameBotConversationMutationVariables = Exact<{
  where: BotConversationWhereUniqueInput;
  data: BotConversationUpdateInput;
}>;


export type RenameBotConversationMutation = { __typename?: 'Mutation', updateBotConversation: { __typename?: 'BotConversation', id: string, urlId: string, title: string } };

export type GetBotConversationQueryVariables = Exact<{
  where: BotConversationWhereUniqueInput;
}>;


export type GetBotConversationQuery = { __typename?: 'Query', botConversation?: { __typename?: 'BotConversation', createdAt: any, data?: any | null, deletedAt?: any | null, id: string, title: string, updatedAt: any, urlId: string } | null };

export type GetBotConversationsQueryVariables = Exact<{
  where: BotConversationWhereInput;
}>;


export type GetBotConversationsQuery = { __typename?: 'Query', botConversations: Array<{ __typename?: 'BotConversation', createdAt: any, data?: any | null, deletedAt?: any | null, id: string, title: string, updatedAt: any, urlId: string }> };

export type GetBotConversationByUrlIdQueryVariables = Exact<{
  where: BotConversationUrlIdInput;
}>;


export type GetBotConversationByUrlIdQuery = { __typename?: 'Query', botConversationByUrlId?: { __typename?: 'BotConversation', completedAt?: any | null, createdAt: any, data?: any | null, deletedAt?: any | null, id: string, title: string, updatedAt: any, urlId: string } | null };

export type GetChatByUrlIdQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
}>;


export type GetChatByUrlIdQuery = { __typename?: 'Query', getChatByUrlId: { __typename?: 'BotConversation', completedAt?: any | null, createdAt: any, data?: any | null, deletedAt?: any | null, id: string, title: string, updatedAt: any, urlId: string, conversationEntries: Array<{ __typename?: 'BotConversationEntry', createdAt: any, deletedAt?: any | null, entry: any, id: string, speaker?: EnumBotConversationEntrySpeaker | null, updatedAt: any, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null }>, botConversationParticipants: Array<{ __typename?: 'BotConversationParticipant', createdAt: any, deletedAt?: any | null, id: string, updatedAt: any, owner?: boolean | null, permissions?: Array<EnumBotConversationParticipantPermissions> | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null }> } };

export type GetBotConversationEntriesQueryVariables = Exact<{
  where: BotConversationEntryWhereInput;
}>;


export type GetBotConversationEntriesQuery = { __typename?: 'Query', botConversationEntries: Array<{ __typename?: 'BotConversationEntry', createdAt: any, deletedAt?: any | null, entry: any, id: string, speaker?: EnumBotConversationEntrySpeaker | null, updatedAt: any, conversation?: { __typename?: 'BotConversation', id: string } | null, user?: { __typename?: 'User', id: string } | null }> };

export type GetBotConversationParticipantsQueryVariables = Exact<{
  where: BotConversationParticipantWhereInput;
}>;


export type GetBotConversationParticipantsQuery = { __typename?: 'Query', botConversationParticipants: Array<{ __typename?: 'BotConversationParticipant', createdAt: any, deletedAt?: any | null, id: string, updatedAt: any, owner?: boolean | null, permissions?: Array<EnumBotConversationParticipantPermissions> | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, avatarUrl?: string | null } | null }> };

export type GetBotConversationHistoryQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetBotConversationHistoryQuery = { __typename?: 'Query', getBotConversationHistory: Array<{ __typename?: 'BotConversation', id: string, title: string, urlId: string, createdAt: any, updatedAt: any, completedAt?: any | null }> };

export type GetBotConversationHistoryCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBotConversationHistoryCountQuery = { __typename?: 'Query', getBotConversationHistoryCount: { __typename?: 'MetaQueryPayload', count: number } };

export type CreateDistrictMutationVariables = Exact<{
  data: DistrictCreateInput;
}>;


export type CreateDistrictMutation = { __typename?: 'Mutation', createDistrict: { __typename?: 'District', address?: any | null, createdAt: any, deletedAt?: any | null, id: string, identifiers?: any | null, edlinkId?: string | null, locale?: string | null, name: string, properties?: any | null, timezone?: string | null, updatedAt: any, urlId: string, payments?: any | null, edlinkIntegrations: Array<{ __typename?: 'EdlinkIntegration', id: string, provider?: { __typename?: 'EdlinkProvider', application?: string | null, name: string } | null }>, schools: Array<{ __typename?: 'School', id: string }>, users: Array<{ __typename?: 'User', id: string }> } };

export type UpdateDistrictMutationVariables = Exact<{
  data: DistrictUpdateInput;
  where: DistrictWhereUniqueInput;
}>;


export type UpdateDistrictMutation = { __typename?: 'Mutation', updateDistrict: { __typename?: 'District', address?: any | null, createdAt: any, deletedAt?: any | null, id: string, identifiers?: any | null, edlinkId?: string | null, locale?: string | null, name: string, properties?: any | null, timezone?: string | null, updatedAt: any, urlId: string, payments?: any | null, edlinkIntegrations: Array<{ __typename?: 'EdlinkIntegration', id: string, provider?: { __typename?: 'EdlinkProvider', application?: string | null, name: string } | null }>, schools: Array<{ __typename?: 'School', id: string }>, users: Array<{ __typename?: 'User', id: string }> } };

export type GetDistrictsQueryVariables = Exact<{
  where: DistrictWhereInput;
  orderBy?: InputMaybe<Array<DistrictOrderByInput> | DistrictOrderByInput>;
}>;


export type GetDistrictsQuery = { __typename?: 'Query', districts: Array<{ __typename?: 'District', address?: any | null, createdAt: any, deletedAt?: any | null, id: string, identifiers?: any | null, edlinkId?: string | null, locale?: string | null, name: string, properties?: any | null, timezone?: string | null, updatedAt: any, urlId: string, edlinkIntegrations: Array<{ __typename?: 'EdlinkIntegration', id: string, provider?: { __typename?: 'EdlinkProvider', application?: string | null, name: string } | null }>, schools: Array<{ __typename?: 'School', id: string }>, users: Array<{ __typename?: 'User', id: string }> }> };

export type GetDistrictQueryVariables = Exact<{
  where: DistrictWhereUniqueInput;
}>;


export type GetDistrictQuery = { __typename?: 'Query', district?: { __typename?: 'District', address?: any | null, createdAt: any, deletedAt?: any | null, id: string, identifiers?: any | null, edlinkId?: string | null, locale?: string | null, name: string, properties?: any | null, timezone?: string | null, updatedAt: any, urlId: string, edlinkIntegrations: Array<{ __typename?: 'EdlinkIntegration', id: string, provider?: { __typename?: 'EdlinkProvider', application?: string | null, name: string } | null }>, schools: Array<{ __typename?: 'School', id: string }>, users: Array<{ __typename?: 'User', id: string }> } | null };

export type CreateFavoriteMutationVariables = Exact<{
  data: FavoriteCreateInput;
}>;


export type CreateFavoriteMutation = { __typename?: 'Mutation', createFavorite: { __typename?: 'Favorite', id: string, resource?: { __typename?: 'Resource', id: string } | null, user?: { __typename?: 'User', id: string } | null } };

export type DeleteFavoriteMutationVariables = Exact<{
  where: FavoriteWhereUniqueInput;
}>;


export type DeleteFavoriteMutation = { __typename?: 'Mutation', deleteFavorite: { __typename?: 'Favorite', id: string, resource?: { __typename?: 'Resource', id: string } | null, user?: { __typename?: 'User', id: string } | null } };

export type GetFavoritesQueryVariables = Exact<{
  where: FavoriteWhereInput;
}>;


export type GetFavoritesQuery = { __typename?: 'Query', favorites: Array<{ __typename?: 'Favorite', id: string, resource?: { __typename?: 'Resource', id: string } | null, user?: { __typename?: 'User', id: string } | null }> };

export type CreateResourceMutationVariables = Exact<{
  data: ResourceInitInput;
}>;


export type CreateResourceMutation = { __typename?: 'Mutation', initResource: { __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, thumbnail?: string | null, tracking?: any | null, status?: any | null, attributes?: any | null, canEdit: boolean, canMoveWithinDrive: boolean, canMoveOutsideDrive: boolean, canTrash: boolean, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string } | null } };

export type UpdateResourceMutationVariables = Exact<{
  data: ResourceUpdateInput;
  where: ResourceWhereUniqueInput;
}>;


export type UpdateResourceMutation = { __typename?: 'Mutation', updateResource: { __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, thumbnail?: string | null, tracking?: any | null, status?: any | null, attributes?: any | null, canEdit: boolean, canMoveWithinDrive: boolean, canMoveOutsideDrive: boolean, canTrash: boolean, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string } | null } };

export type UpdateResourceAttributesMutationVariables = Exact<{
  data: ResourceAttributesInput;
  where: ResourceWhereUniqueInput;
}>;


export type UpdateResourceAttributesMutation = { __typename?: 'Mutation', updateResourceAttributes: { __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, thumbnail?: string | null, tracking?: any | null, status?: any | null, attributes?: any | null, canEdit: boolean, canMoveWithinDrive: boolean, canMoveOutsideDrive: boolean, canTrash: boolean, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string } | null } };

export type ArchiveResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveResourceMutation = { __typename?: 'Mutation', archiveResource: { __typename?: 'Resource', id: string, archivedAt?: any | null } };

export type DeleteResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteResourceMutation = { __typename?: 'Mutation', permanentlyDeleteResource: { __typename?: 'Resource', id: string, deletedAt?: any | null } };

export type RestoreResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreResourceMutation = { __typename?: 'Mutation', restoreResource: { __typename?: 'Resource', id: string, archivedAt?: any | null, deletedAt?: any | null } };

export type MoveResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
  driveId: Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveResourceMutation = { __typename?: 'Mutation', moveResource: { __typename?: 'Resource', id: string, updatedAt: any, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }> } };

export type DuplicateResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
  courseId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DuplicateResourceMutation = { __typename?: 'Mutation', duplicateResource: { __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, thumbnail?: string | null, tracking?: any | null, status?: any | null, attributes?: any | null, canEdit: boolean, canMoveWithinDrive: boolean, canMoveOutsideDrive: boolean, canTrash: boolean, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string } | null } };

export type PublishResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublishResourceMutation = { __typename?: 'Mutation', publishResource: { __typename?: 'Resource', id: string, publishedAt?: any | null, publishedBy?: { __typename?: 'User', id: string } | null } };

export type UnpublishResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UnpublishResourceMutation = { __typename?: 'Mutation', unpublishResource: { __typename?: 'Resource', id: string, publishedAt?: any | null, publishedBy?: { __typename?: 'User', id: string } | null } };

export type AiContentAssistantMutationVariables = Exact<{
  data: AiAssistantInput;
}>;


export type AiContentAssistantMutation = { __typename?: 'Mutation', aiContentAssistant: boolean };

export type GetResourceQueryVariables = Exact<{
  where: ResourceWhereUniqueInput;
}>;


export type GetResourceQuery = { __typename?: 'Query', resource?: { __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, tracking?: any | null, thumbnail?: string | null, status?: any | null, attributes?: any | null, canEdit: boolean, canMoveWithinDrive: boolean, canMoveOutsideDrive: boolean, canTrash: boolean, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetResourceByUrlIdQueryVariables = Exact<{
  where: ResourceUrlIdInput;
}>;


export type GetResourceByUrlIdQuery = { __typename?: 'Query', resourceByUrlId?: { __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, tracking?: any | null, thumbnail?: string | null, status?: any | null, attributes?: any | null, canEdit: boolean, canMoveWithinDrive: boolean, canMoveOutsideDrive: boolean, canTrash: boolean, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetResourcesQueryVariables = Exact<{
  where: ResourceWhereInput;
}>;


export type GetResourcesQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, tracking?: any | null, thumbnail?: string | null, status?: any | null, attributes?: any | null, canEdit: boolean, canMoveWithinDrive: boolean, canMoveOutsideDrive: boolean, canTrash: boolean, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null } | null }> };

export type GetSharedResourceQueryVariables = Exact<{
  where: ResourceUrlIdInput;
}>;


export type GetSharedResourceQuery = { __typename?: 'Query', sharedResource?: { __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, tracking?: any | null, thumbnail?: string | null, status?: any | null, attributes?: any | null, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetSharedQueryVariables = Exact<{
  where: ResourceWhereInput;
}>;


export type GetSharedQuery = { __typename?: 'Query', sharedResources: Array<{ __typename?: 'Resource', archivedAt?: any | null, content?: any | null, createdAt: any, deletedAt?: any | null, editorVersion?: number | null, id: string, isOnboarding?: boolean | null, isTemplate?: boolean | null, publishedAt?: any | null, resourceType?: EnumResourceResourceType | null, title: string, updatedAt: any, urlId: string, version?: number | null, schedule?: any | null, standards?: any | null, units?: any | null, tracking?: any | null, thumbnail?: string | null, status?: any | null, attributes?: any | null, course?: { __typename?: 'Course', id: string } | null, lastModifiedBy?: { __typename?: 'User', id: string } | null, publishedBy?: { __typename?: 'User', id: string } | null, template?: { __typename?: 'Resource', id: string } | null, drive?: { __typename?: 'Drive', id: string } | null, parents: Array<{ __typename?: 'Resource', id: string }>, planner?: { __typename?: 'Planner', id: string } | null, usedAsTemplate: Array<{ __typename?: 'Resource', urlId: string }>, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null } | null }> };

export type UpdateUserDetailsMutationVariables = Exact<{
  userDetailsInput: UserDetailsInput;
}>;


export type UpdateUserDetailsMutation = { __typename?: 'Mutation', updateUserDetails: boolean };

export type CreateStripeCheckoutSessionMutationVariables = Exact<{
  input: StripeCheckoutInput;
}>;


export type CreateStripeCheckoutSessionMutation = { __typename?: 'Mutation', createStripeCheckoutSession: string };

export type UpgradeSubscriptionMutationVariables = Exact<{
  input: StripeCheckoutInput;
}>;


export type UpgradeSubscriptionMutation = { __typename?: 'Mutation', upgradeSubscription: boolean };

export type RedirectToStripeCustomerPortalMutationVariables = Exact<{ [key: string]: never; }>;


export type RedirectToStripeCustomerPortalMutation = { __typename?: 'Mutation', redirectToStripeCustomerPortal: string };

export type RefreshSubscriptionUserQueryVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type RefreshSubscriptionUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, subscriptionType?: EnumUserSubscriptionType | null, subscriptionInterval?: EnumUserSubscriptionInterval | null } | null };

export type GetRecentActivityItemsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Float']['input']>;
  cursor?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetRecentActivityItemsQuery = { __typename?: 'Query', getRecentActivityItems: { __typename?: 'RecentActivityItemsResponse', hasMore: boolean, nextCursor?: any | null, items: Array<{ __typename?: 'RecentActivityItem', id: string, title: string, updatedAt: any, type: EnumRecentActivityItemType, url: string }> } };

export type GetUsersQueryVariables = Exact<{
  where: UserWhereInput;
  orderBy?: InputMaybe<Array<UserOrderByInput> | UserOrderByInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', avatarUrl?: string | null, createdAt: any, deletedAt?: any | null, edlinkId?: string | null, email: string, firstName?: string | null, gradeLevels?: Array<EnumUserGradeLevels> | null, id: string, identifiers?: any | null, lastName?: string | null, middleName?: string | null, updatedAt: any, username: string, district?: { __typename?: 'District', id: string } | null, schools: Array<{ __typename?: 'School', id: string }> }> };


export const CreateAiFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAiFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiFeedbackCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAiFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiContext"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"parentEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAiFeedbackMutation, CreateAiFeedbackMutationVariables>;
export const UpdateAiFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAiFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiFeedbackWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiFeedbackUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAiFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiContext"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"parentEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAiFeedbackMutation, UpdateAiFeedbackMutationVariables>;
export const GetAiFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAiFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiFeedbackWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiContext"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"parentEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAiFeedbackQuery, GetAiFeedbackQueryVariables>;
export const GetAiFeedbacksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAiFeedbacks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiFeedbackWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiContext"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"parentEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAiFeedbacksQuery, GetAiFeedbacksQueryVariables>;
export const InitAiToolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitAiTool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitToolInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initAiTool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiToolSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stepId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"initData"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<InitAiToolMutation, InitAiToolMutationVariables>;
export const UpdateAiToolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAiTool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAiTool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiToolSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stepId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"initData"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<UpdateAiToolMutation, UpdateAiToolMutationVariables>;
export const AiToolFieldAutofillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AiToolFieldAutofill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiAutofillInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolFieldAutofill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<AiToolFieldAutofillMutation, AiToolFieldAutofillMutationVariables>;
export const GenerateStepOutputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateStepOutput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateStepOutputInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateStepOutput"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<GenerateStepOutputMutation, GenerateStepOutputMutationVariables>;
export const CompleteToolStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteToolStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteToolStepInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeToolStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiToolSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stepId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"initData"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<CompleteToolStepMutation, CompleteToolStepMutationVariables>;
export const AiToolFinalOutputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AiToolFinalOutput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalStepOutputInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolFinalOutput"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<AiToolFinalOutputMutation, AiToolFinalOutputMutationVariables>;
export const AiChatInterfaceInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AiChatInterfaceInput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiChatInterfaceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiChatInterfaceInput"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<AiChatInterfaceInputMutation, AiChatInterfaceInputMutationVariables>;
export const AiChatInterfaceSuggestionResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AiChatInterfaceSuggestionResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiChatInterfaceSuggestionResponseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiChatInterfaceSuggestionResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<AiChatInterfaceSuggestionResponseMutation, AiChatInterfaceSuggestionResponseMutationVariables>;
export const ConvertMarkdownToPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConvertMarkdownToPDF"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"convertMarkdownToPDF"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"markdown"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markdown"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}]}]}}]} as unknown as DocumentNode<ConvertMarkdownToPdfMutation, ConvertMarkdownToPdfMutationVariables>;
export const ResourceGeneratorEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResourceGeneratorEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiResourceGeneratorEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceGeneratorEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<ResourceGeneratorEditMutation, ResourceGeneratorEditMutationVariables>;
export const CreateAiFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAiFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiFavoriteCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAiFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAiFavoriteMutation, CreateAiFavoriteMutationVariables>;
export const DeleteAiFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAiFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiFavoriteWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAiFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteAiFavoriteMutation, DeleteAiFavoriteMutationVariables>;
export const DeleteAiToolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAiTool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAiToolDeleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<DeleteAiToolMutation, DeleteAiToolMutationVariables>;
export const RestoreAiToolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreAiTool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restoreAiTool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<RestoreAiToolMutation, RestoreAiToolMutationVariables>;
export const MarkAiToolCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAiToolComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAiToolComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<MarkAiToolCompleteMutation, MarkAiToolCompleteMutationVariables>;
export const UnmarkAiToolCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnmarkAiToolComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unmarkAiToolComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<UnmarkAiToolCompleteMutation, UnmarkAiToolCompleteMutationVariables>;
export const RenameAiToolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameAiTool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAiTool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<RenameAiToolMutation, RenameAiToolMutationVariables>;
export const EditAiToolImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditAiToolImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditImageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editAiToolImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draftUrl"}}]}}]}}]} as unknown as DocumentNode<EditAiToolImageMutation, EditAiToolImageMutationVariables>;
export const GetAiToolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAiTool"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiToolSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stepId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"initData"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<GetAiToolQuery, GetAiToolQueryVariables>;
export const GetAiToolByUrlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAiToolByUrlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolUrlIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolByUrlId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiToolSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stepId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"initData"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<GetAiToolByUrlIdQuery, GetAiToolByUrlIdQueryVariables>;
export const GetAiToolStepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAiToolSteps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolStepWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolSteps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stepId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAiToolStepsQuery, GetAiToolStepsQueryVariables>;
export const GetAiToolParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAiToolParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetAiToolParticipantsQuery, GetAiToolParticipantsQueryVariables>;
export const GetAiFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAiFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiFavoriteWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAiFavoritesQuery, GetAiFavoritesQueryVariables>;
export const GetAiToolsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAIToolsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiToolParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetAiToolsHistoryQuery, GetAiToolsHistoryQueryVariables>;
export const GetAiToolsHistoryCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAIToolsHistoryCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_aiToolParticipantsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetAiToolsHistoryCountQuery, GetAiToolsHistoryCountQueryVariables>;
export const GetCurriculumToolsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurriculumToolsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"curriculumToolsParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurriculumToolsHistoryQuery, GetCurriculumToolsHistoryQueryVariables>;
export const GetCurriculumToolsHistoryCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurriculumToolsHistoryCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_curriculumToolsParticipantsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetCurriculumToolsHistoryCountQuery, GetCurriculumToolsHistoryCountQueryVariables>;
export const GetResourceGeneratorToolsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceGeneratorToolsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceGeneratorParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetResourceGeneratorToolsHistoryQuery, GetResourceGeneratorToolsHistoryQueryVariables>;
export const GetResourceGeneratorToolsHistoryCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceGeneratorToolsHistoryCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_resourceGeneratorParticipantsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetResourceGeneratorToolsHistoryCountQuery, GetResourceGeneratorToolsHistoryCountQueryVariables>;
export const GetImageGeneratorToolsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImageGeneratorToolsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageGeneratorParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetImageGeneratorToolsHistoryQuery, GetImageGeneratorToolsHistoryQueryVariables>;
export const GetImageGeneratorToolsHistoryCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImageGeneratorToolsHistoryCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiToolParticipantWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_imageGeneratorParticipantsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetImageGeneratorToolsHistoryCountQuery, GetImageGeneratorToolsHistoryCountQueryVariables>;
export const GetResourceFromToolStepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceFromToolStep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toolId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stepId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getResourceFromToolStep"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"toolId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toolId"}}},{"kind":"Argument","name":{"kind":"Name","value":"stepId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stepId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trackId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackId"}}},{"kind":"Argument","name":{"kind":"Name","value":"resourceKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackId"}},{"kind":"Field","name":{"kind":"Name","value":"resourceKey"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"loading"}}]}}]}}]} as unknown as DocumentNode<GetResourceFromToolStepQuery, GetResourceFromToolStepQueryVariables>;
export const CreateAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"acl"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"vectorEmbeddings"}}]}}]}}]} as unknown as DocumentNode<CreateAssetMutation, CreateAssetMutationVariables>;
export const UpdateAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"acl"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"vectorEmbeddings"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetMutation, UpdateAssetMutationVariables>;
export const DeleteAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const LinkForEmbeddingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkForEmbedding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkForEmbedding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"acl"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"vectorEmbeddings"}}]}}]}}]} as unknown as DocumentNode<LinkForEmbeddingMutation, LinkForEmbeddingMutationVariables>;
export const GetAttachmentsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAttachmentsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_assetsMeta"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetAttachmentsCountQuery, GetAttachmentsCountQueryVariables>;
export const GetAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"acl"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"vectorEmbeddings"}}]}}]}}]} as unknown as DocumentNode<GetAttachmentsQuery, GetAttachmentsQueryVariables>;
export const GetAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"acl"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"vectorEmbeddings"}}]}}]}}]} as unknown as DocumentNode<GetAssetsQuery, GetAssetsQueryVariables>;
export const CreateAuditLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAuditLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditLogCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAuditLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAuditLogMutation, CreateAuditLogMutationVariables>;
export const GetAuditLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuditLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditLogWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const GetAuditLogsForLimitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuditLogsForLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditLogsForLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionId"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuditLogsForLimitsQuery, GetAuditLogsForLimitsQueryVariables>;
export const LoginWithEmailIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginWithEmailId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Credentials"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWithEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarded"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<LoginWithEmailIdMutation, LoginWithEmailIdMutationVariables>;
export const SignUpWithEmailIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignUpWithEmailId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Credentials"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signUpWithEmailForAI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarded"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<SignUpWithEmailIdMutation, SignUpWithEmailIdMutationVariables>;
export const ResetPasswordWithEmailIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPasswordWithEmailId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPasswordWithEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordWithEmailIdMutation, ResetPasswordWithEmailIdMutationVariables>;
export const CompleteOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"completeOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onboardingInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onboardingInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onboardingInput"}}}]}]}}]} as unknown as DocumentNode<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;
export const UpdatePasswordWithEmailIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePasswordWithEmailId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePasswordCredentials"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}]}]}}]} as unknown as DocumentNode<UpdatePasswordWithEmailIdMutation, UpdatePasswordWithEmailIdMutationVariables>;
export const SetNewPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetNewPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passwordInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setNewPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"passwordInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passwordInput"}}}]}]}}]} as unknown as DocumentNode<SetNewPasswordMutation, SetNewPasswordMutationVariables>;
export const ReferAFriendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReferAFriend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referAFriend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referralInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralInput"}}}]}]}}]} as unknown as DocumentNode<ReferAFriendMutation, ReferAFriendMutationVariables>;
export const VerifyEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendVerificationEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendVerificationEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const CreateRefreshTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRefreshToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRefreshToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tokenInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenInput"}}}]}]}}]} as unknown as DocumentNode<CreateRefreshTokenMutation, CreateRefreshTokenMutationVariables>;
export const HandleApiSignOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HandleApiSignOut"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handleApiSignOut"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tokenInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenInput"}}}]}]}}]} as unknown as DocumentNode<HandleApiSignOutMutation, HandleApiSignOutMutationVariables>;
export const UpdateUserDistrictRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserDistrictRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserDistrictRoleInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserDistrictRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserDistrictRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserDistrictRoleInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserDistrictRoleInput"}}}]}]}}]} as unknown as DocumentNode<UpdateUserDistrictRoleMutation, UpdateUserDistrictRoleMutationVariables>;
export const ReferralLinkSignUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"referralLinkSignUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralLinkSignUpInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralLinkSignUpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralLinkSignUp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referralLinkSignUpInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralLinkSignUpInput"}}}]}]}}]} as unknown as DocumentNode<ReferralLinkSignUpMutation, ReferralLinkSignUpMutationVariables>;
export const IsActivateEligibleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"isActivateEligible"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isActiveEligibleInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IsActivateEligibleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActivateEligible"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isActiveEligibleInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isActiveEligibleInput"}}}]}]}}]} as unknown as DocumentNode<IsActivateEligibleMutation, IsActivateEligibleMutationVariables>;
export const ActivateUserWithPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activateUserWithPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activateUserWithPasswordInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateUserWithPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateUserWithPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activateUserWithPasswordInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activateUserWithPasswordInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarded"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<ActivateUserWithPasswordMutation, ActivateUserWithPasswordMutationVariables>;
export const ActivateUserWithSsoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activateUserWithSSO"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activateUserWithSSOInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateUserWithSSO"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateUserWithSSO"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"activateUserWithSSOInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activateUserWithSSOInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarded"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<ActivateUserWithSsoMutation, ActivateUserWithSsoMutationVariables>;
export const FinishEnterpriseOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinishEnterpriseOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnterpriseOnboardingCredentials"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishEnterpriseOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}]}]}}]} as unknown as DocumentNode<FinishEnterpriseOnboardingMutation, FinishEnterpriseOnboardingMutationVariables>;
export const LoginWithEdlinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginWithEdlink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EdlinkCredentials"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWithEdlink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarded"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<LoginWithEdlinkMutation, LoginWithEdlinkMutationVariables>;
export const IsEdlinkUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IsEdlinkUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEdlinkUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<IsEdlinkUserMutation, IsEdlinkUserMutationVariables>;
export const SubscribeToNewsletterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subscribeToNewsletter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsletterArgs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewsLetterArgs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToNewsletter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newsletterArgs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsletterArgs"}}}]}]}}]} as unknown as DocumentNode<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;
export const ExportMarkdownToGoogleDocDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportMarkdownToGoogleDoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportMarkdownToGoogleDocsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportMarkdownToGoogleDocInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportMarkdownToGoogleDoc"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"exportMarkdownToGoogleDocsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportMarkdownToGoogleDocsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ExportMarkdownToGoogleDocMutation, ExportMarkdownToGoogleDocMutationVariables>;
export const ExportMarkdownToGoogleFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportMarkdownToGoogleForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportMarkdownToGoogleFormsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportMarkdownToGoogleFormInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportMarkdownToGoogleForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"exportMarkdownToGoogleFormsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportMarkdownToGoogleFormsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ExportMarkdownToGoogleFormMutation, ExportMarkdownToGoogleFormMutationVariables>;
export const ReferralSignupCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReferralSignupCompleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralSignupCompleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"referralCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}]}]}}]} as unknown as DocumentNode<ReferralSignupCompletedMutation, ReferralSignupCompletedMutationVariables>;
export const SendReferralEmailInvitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendReferralEmailInvites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralEmailInviteArgs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralEmailInvitesArgs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendReferralEmailInvites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referralEmailInviteArgs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralEmailInviteArgs"}}}]}]}}]} as unknown as DocumentNode<SendReferralEmailInvitesMutation, SendReferralEmailInvitesMutationVariables>;
export const CompleteReferralActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteReferralAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralCompleteActionArgs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralCompleteActionArgs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeReferralAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referralCompleteActionArgs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralCompleteActionArgs"}}}]}]}}]} as unknown as DocumentNode<CompleteReferralActionMutation, CompleteReferralActionMutationVariables>;
export const MarkActivityCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkActivityComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markActivityComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}]}}]} as unknown as DocumentNode<MarkActivityCompleteMutation, MarkActivityCompleteMutationVariables>;
export const DeleteActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}]}}]} as unknown as DocumentNode<DeleteActivityMutation, DeleteActivityMutationVariables>;
export const UnsubscribeFromWeeklyReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnsubscribeFromWeeklyReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsubscribeFromWeeklyReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<UnsubscribeFromWeeklyReportsMutation, UnsubscribeFromWeeklyReportsMutationVariables>;
export const TrackWeeklyReportClickDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrackWeeklyReportClick"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackWeeklyReportClick"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"destination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destination"}}}]}]}}]} as unknown as DocumentNode<TrackWeeklyReportClickMutation, TrackWeeklyReportClickMutationVariables>;
export const GetAuthUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"districtRoles"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarded"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"onboardedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authProvider"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"}},{"kind":"Field","name":{"kind":"Name","value":"districtRoles"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialStart"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialEnd"}},{"kind":"Field","name":{"kind":"Name","value":"drives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driveType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toolCount"}},{"kind":"Field","name":{"kind":"Name","value":"chatCount"}},{"kind":"Field","name":{"kind":"Name","value":"instantResourcesCount"}},{"kind":"Field","name":{"kind":"Name","value":"imageGeneratorCount"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseUser"}},{"kind":"Field","name":{"kind":"Name","value":"invitedCollaborators"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionInterval"}},{"kind":"Field","name":{"kind":"Name","value":"enterprisePlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnterpriseAccount"}},{"kind":"Field","name":{"kind":"Name","value":"isLicenseActive"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referralActionsPending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"useChat"}},{"kind":"Field","name":{"kind":"Name","value":"finishOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"createSlideshow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copilotFreeTrialEnd"}},{"kind":"Field","name":{"kind":"Name","value":"chatwootIdentifierHash"}}]}}]}}]} as unknown as DocumentNode<GetAuthUserQuery, GetAuthUserQueryVariables>;
export const CheckUpdatePasswordTokenValidityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckUpdatePasswordTokenValidity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkUpdatePasswordPageValidity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<CheckUpdatePasswordTokenValidityQuery, CheckUpdatePasswordTokenValidityQueryVariables>;
export const GetStripeCustomerManagementUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStripeCustomerManagementURL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStripeCustomerManagementURL"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}]}}]} as unknown as DocumentNode<GetStripeCustomerManagementUrlQuery, GetStripeCustomerManagementUrlQueryVariables>;
export const CheckEnterpriseOboardingValidityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckEnterpriseOboardingValidity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkEnterpriseOboardingValidity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<CheckEnterpriseOboardingValidityQuery, CheckEnterpriseOboardingValidityQueryVariables>;
export const VerifyEmailHashDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"verifyEmailHash"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailHashInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailHashInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyEmailHash"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"emailHashInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailHashInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"match"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarded"}}]}}]}}]} as unknown as DocumentNode<VerifyEmailHashQuery, VerifyEmailHashQueryVariables>;
export const GetInvitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"inviteType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invitedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInvitesQuery, GetInvitesQueryVariables>;
export const GetInvitesForEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvitesForEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitesForEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"inviteType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invitedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInvitesForEmailQuery, GetInvitesForEmailQueryVariables>;
export const ProcessOneDriveAttachmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProcessOneDriveAttachment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oneDriveAttachmentInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OneDriveAttachmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processOneDriveAttachment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"oneDriveAttachmentInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oneDriveAttachmentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"acl"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"vectorEmbeddings"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<ProcessOneDriveAttachmentQuery, ProcessOneDriveAttachmentQueryVariables>;
export const GetOneDriveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneDrive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oneDriveInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OneDriveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOneDrive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"oneDriveInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oneDriveInput"}}}]}]}}]} as unknown as DocumentNode<GetOneDriveQuery, GetOneDriveQueryVariables>;
export const GetRefferalLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRefferalLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"product"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReferralLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product"},"value":{"kind":"Variable","name":{"kind":"Name","value":"product"}}}]}]}}]} as unknown as DocumentNode<GetRefferalLinkQuery, GetRefferalLinkQueryVariables>;
export const GetReferralInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReferralInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralInfoArgs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralInfoArgs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReferralInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referralInfoArgs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralInfoArgs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrerName"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialDays"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInDollars"}}]}}]}}]} as unknown as DocumentNode<GetReferralInfoQuery, GetReferralInfoQueryVariables>;
export const NewBotConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NewBotConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewBotConversationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newBotConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}}]}}]} as unknown as DocumentNode<NewBotConversationMutation, NewBotConversationMutationVariables>;
export const NewBotConversationEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NewBotConversationEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewConversationEntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newBotConversationEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speaker"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<NewBotConversationEntryMutation, NewBotConversationEntryMutationVariables>;
export const RegenerateBotConversationEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegenerateBotConversationEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegenerateConversationEntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regenerateBotConversationEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speaker"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<RegenerateBotConversationEntryMutation, RegenerateBotConversationEntryMutationVariables>;
export const DeleteBotConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBotConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markBotConversationDeleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<DeleteBotConversationMutation, DeleteBotConversationMutationVariables>;
export const RestoreBotConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreBotConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restoreBotConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<RestoreBotConversationMutation, RestoreBotConversationMutationVariables>;
export const MarkBotConversationCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkBotConversationComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markBotConversationComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<MarkBotConversationCompleteMutation, MarkBotConversationCompleteMutationVariables>;
export const UnmarkBotConversationCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnmarkBotConversationComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unmarkBotConversationComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<UnmarkBotConversationCompleteMutation, UnmarkBotConversationCompleteMutationVariables>;
export const RenameBotConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameBotConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBotConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<RenameBotConversationMutation, RenameBotConversationMutationVariables>;
export const GetBotConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBotConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"botConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}}]}}]} as unknown as DocumentNode<GetBotConversationQuery, GetBotConversationQueryVariables>;
export const GetBotConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBotConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"botConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}}]}}]} as unknown as DocumentNode<GetBotConversationsQuery, GetBotConversationsQueryVariables>;
export const GetBotConversationByUrlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBotConversationByUrlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationUrlIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"botConversationByUrlId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}}]}}]} as unknown as DocumentNode<GetBotConversationByUrlIdQuery, GetBotConversationByUrlIdQueryVariables>;
export const GetChatByUrlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatByUrlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getChatByUrlId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speaker"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"botConversationParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetChatByUrlIdQuery, GetChatByUrlIdQueryVariables>;
export const GetBotConversationEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBotConversationEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationEntryWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"botConversationEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"speaker"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetBotConversationEntriesQuery, GetBotConversationEntriesQueryVariables>;
export const GetBotConversationParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBotConversationParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BotConversationParticipantWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"botConversationParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetBotConversationParticipantsQuery, GetBotConversationParticipantsQueryVariables>;
export const GetBotConversationHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBotConversationHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBotConversationHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<GetBotConversationHistoryQuery, GetBotConversationHistoryQueryVariables>;
export const GetBotConversationHistoryCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBotConversationHistoryCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBotConversationHistoryCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetBotConversationHistoryCountQuery, GetBotConversationHistoryCountQueryVariables>;
export const CreateDistrictDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDistrict"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DistrictCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDistrict"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"edlinkId"}},{"kind":"Field","name":{"kind":"Name","value":"edlinkIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"application"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}},{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"payments"}}]}}]}}]} as unknown as DocumentNode<CreateDistrictMutation, CreateDistrictMutationVariables>;
export const UpdateDistrictDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDistrict"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DistrictUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DistrictWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDistrict"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"edlinkId"}},{"kind":"Field","name":{"kind":"Name","value":"edlinkIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"application"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}},{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"payments"}}]}}]}}]} as unknown as DocumentNode<UpdateDistrictMutation, UpdateDistrictMutationVariables>;
export const GetDistrictsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDistricts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DistrictWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DistrictOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"districts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"edlinkId"}},{"kind":"Field","name":{"kind":"Name","value":"edlinkIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"application"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}},{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}}]}}]} as unknown as DocumentNode<GetDistrictsQuery, GetDistrictsQueryVariables>;
export const GetDistrictDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDistrict"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DistrictWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"edlinkId"}},{"kind":"Field","name":{"kind":"Name","value":"edlinkIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"application"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}},{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}}]}}]} as unknown as DocumentNode<GetDistrictQuery, GetDistrictQueryVariables>;
export const CreateFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFavoriteMutation, CreateFavoriteMutationVariables>;
export const DeleteFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>;
export const GetFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFavoritesQuery, GetFavoritesQueryVariables>;
export const CreateResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceInitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveWithinDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveOutsideDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canTrash"}}]}}]}}]} as unknown as DocumentNode<CreateResourceMutation, CreateResourceMutationVariables>;
export const UpdateResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveWithinDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveOutsideDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canTrash"}}]}}]}}]} as unknown as DocumentNode<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const UpdateResourceAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateResourceAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceAttributesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateResourceAttributes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveWithinDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveOutsideDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canTrash"}}]}}]}}]} as unknown as DocumentNode<UpdateResourceAttributesMutation, UpdateResourceAttributesMutationVariables>;
export const ArchiveResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ArchiveResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}}]}}]}}]} as unknown as DocumentNode<ArchiveResourceMutation, ArchiveResourceMutationVariables>;
export const DeleteResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permanentlyDeleteResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<DeleteResourceMutation, DeleteResourceMutationVariables>;
export const RestoreResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restoreResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<RestoreResourceMutation, RestoreResourceMutationVariables>;
export const MoveResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoveResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driveId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"driveId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driveId"}}},{"kind":"Argument","name":{"kind":"Name","value":"folderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"folderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MoveResourceMutation, MoveResourceMutationVariables>;
export const DuplicateResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveWithinDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveOutsideDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canTrash"}}]}}]}}]} as unknown as DocumentNode<DuplicateResourceMutation, DuplicateResourceMutationVariables>;
export const PublishResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PublishResourceMutation, PublishResourceMutationVariables>;
export const UnpublishResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnpublishResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unpublishResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UnpublishResourceMutation, UnpublishResourceMutationVariables>;
export const AiContentAssistantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AIContentAssistant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AiAssistantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiContentAssistant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<AiContentAssistantMutation, AiContentAssistantMutationVariables>;
export const GetResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveWithinDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveOutsideDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canTrash"}}]}}]}}]} as unknown as DocumentNode<GetResourceQuery, GetResourceQueryVariables>;
export const GetResourceByUrlIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceByUrlId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceUrlIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceByUrlId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveWithinDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveOutsideDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canTrash"}}]}}]}}]} as unknown as DocumentNode<GetResourceByUrlIdQuery, GetResourceByUrlIdQueryVariables>;
export const GetResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveWithinDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canMoveOutsideDrive"}},{"kind":"Field","name":{"kind":"Name","value":"canTrash"}}]}}]}}]} as unknown as DocumentNode<GetResourcesQuery, GetResourcesQueryVariables>;
export const GetSharedResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSharedResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceUrlIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]} as unknown as DocumentNode<GetSharedResourceQuery, GetSharedResourceQueryVariables>;
export const GetSharedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShared"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedResources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editorVersion"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"urlId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAsTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"standards"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"tracking"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}}]}}]}}]} as unknown as DocumentNode<GetSharedQuery, GetSharedQueryVariables>;
export const UpdateUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userDetailsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userDetailsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userDetailsInput"}}}]}]}}]} as unknown as DocumentNode<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const CreateStripeCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStripeCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeCheckoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStripeCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>;
export const UpgradeSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpgradeSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeCheckoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradeSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpgradeSubscriptionMutation, UpgradeSubscriptionMutationVariables>;
export const RedirectToStripeCustomerPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RedirectToStripeCustomerPortal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectToStripeCustomerPortal"}}]}}]} as unknown as DocumentNode<RedirectToStripeCustomerPortalMutation, RedirectToStripeCustomerPortalMutationVariables>;
export const RefreshSubscriptionUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefreshSubscriptionUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionInterval"}}]}}]}}]} as unknown as DocumentNode<RefreshSubscriptionUserQuery, RefreshSubscriptionUserQueryVariables>;
export const GetRecentActivityItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecentActivityItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRecentActivityItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}}]}}]}}]} as unknown as DocumentNode<GetRecentActivityItemsQuery, GetRecentActivityItemsQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edlinkId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"gradeLevels"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifiers"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;